//Custom imports
// ⛔ THESE URLS ARE RENDERED ONCE, WHEN THIS FILE IS SAVED — the `?v=` stamp of each import is
// baked into the compiled theme.js and never refreshes on its own. Push a change to custom.js /
// utils.js / api.js alone and the browser keeps loading the OLD version, because compiled
// theme.js still asks the CDN for the old stamp (measured 11 Sep 2026: custom.js.liquid pushed,
// its compiled twin regenerated within seconds, the page kept importing the 14 Aug build for 30
// minutes). Re-save THIS file after any change to those three — a comment edit is enough.
import * as utils from "//mesmerizeindia.com/cdn/shop/t/346/assets/utils.js?v=121444215945374234871792587412";
import * as custom from "//mesmerizeindia.com/cdn/shop/t/346/assets/custom.js?v=41843155022331045991792587445";
import * as api from "//mesmerizeindia.com/cdn/shop/t/346/assets/api.js?v=101506405557130572531792587412";

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/common/utilities/country-selector.js
var CountrySelector = class extends HTMLElement {
  constructor() {
    super();
    this._onCountryChangedListener = this._onCountryChanged.bind(this);
  }
  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement.addEventListener("change", this._onCountryChangedListener);
    if (this.hasAttribute("country") && this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.getAttribute("country")));
      this.countryElement.dispatchEvent(new Event("change"));
    } else {
      this._onCountryChanged();
    }
  }
  disconnectedCallback() {
    this.countryElement.removeEventListener("change", this._onCountryChangedListener);
  }
  _onCountryChanged() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.getAttribute("data-provinces"));
    this.provinceElement.parentElement.hidden = provinces.length === 0;
    if (provinces.length === 0) {
      return;
    }
    this.provinceElement.innerHTML = "";
    provinces.forEach((data) => {
      const selected = data[1] === this.getAttribute("province");
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
};
if (!window.customElements.get("country-selector")) {
  window.customElements.define("country-selector", CountrySelector);
}

// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    // number = Math.floor(number / 100);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";

    //CUSTOM: If cents amount is ".00", remove it
    if (centsAmount === ".00") centsAmount = "";
    return dollarsAmount + centsAmount;
  }
  
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// js/common/utilities/cached-fetch.js
var cachedMap = /* @__PURE__ */ new Map();
/**
 * ⛔ IN-FLIGHT DE-DUPLICATION (added 30 Jul 2026 — measured, RC4).
 *
 * `cachedMap` is only written INSIDE an async `.then` after the body has been read, so two callers
 * for the same URL in the same tick BOTH miss the cache and BOTH hit the network. The facet form
 * warms the URL from `_onFormChanged` (`cachedFetch(this._buildUrl())`, the no-`update-on-change`
 * branch) and the `facet:update` handler can fetch the same URL moments later, so the race is real
 * and this map removes it.
 *
 * ⚠ THIS IS HYGIENE, NOT A FIX FOR THE CHIP FLICKER — do not cite it as one. I added it while
 * chasing duplicate `?...&section_id=...` requests I had measured on RC4, and the duplicates turned
 * out to be MY OWN doing: stack traces showed the two `cachedFetch` frames coming from two DIFFERENT
 * theme.js versions (v=1797…791 and v=1317…466) coexisting in one JS context because I had pushed
 * new copies mid-session. Each module instance registers its own top-level `facet:update` listener,
 * so one dispatch became two fetches. A shopper loads one copy and sees one fetch. The flicker
 * Priyanka reported is STILL UNDIAGNOSED as of 30 Jul 2026.
 *
 * The pending map makes the second caller await the FIRST request instead of starting another.
 * Everyone gets a `.clone()` because a Response body can only be read once and there are now two
 * or more readers of the same response. The entry is cleared in `finally` so a failed request does
 * not poison the URL for the rest of the session.
 *
 * ⚠ On abort: the joining caller no longer controls the request it joined, so an `abortController`
 * abort cannot cancel a fetch started by someone else. That is deliberate and safe here — the URL
 * is identical, so the content is identical; sharing one in-flight request is strictly better than
 * racing two.
 */
var inFlightMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  if (inFlightMap.has(cacheKey)) {
    return inFlightMap.get(cacheKey).then((response) => response.clone());
  }
  const pending = fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  }).finally(() => {
    inFlightMap.delete(cacheKey);
  });
  inFlightMap.set(cacheKey, pending);
  return pending.then((response) => response.clone());
}

// js/common/utilities/extract-section-id.js
function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// js/common/utilities/dom.js
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}

// js/common/utilities/player.js
var _callback, _duration, _remainingTime, _startTime, _timer, _state, _onVisibilityChangeListener, _onVisibilityChange, onVisibilityChange_fn;
var Player = class extends EventTarget {
  constructor(durationInSec, stopOnVisibility = true) {
    super();
    __privateAdd(this, _onVisibilityChange);
    __privateAdd(this, _callback, void 0);
    __privateAdd(this, _duration, void 0);
    __privateAdd(this, _remainingTime, void 0);
    __privateAdd(this, _startTime, void 0);
    __privateAdd(this, _timer, void 0);
    __privateAdd(this, _state, "paused");
    __privateAdd(this, _onVisibilityChangeListener, __privateMethod(this, _onVisibilityChange, onVisibilityChange_fn).bind(this));
    __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent("player:end")));
    __privateSet(this, _duration, __privateSet(this, _remainingTime, durationInSec * 1e3));
    if (stopOnVisibility) {
      document.addEventListener("visibilitychange", __privateGet(this, _onVisibilityChangeListener));
    }
  }
  pause() {
    if (__privateGet(this, _state) !== "started") {
      return;
    }
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "paused");
    __privateSet(this, _remainingTime, __privateGet(this, _remainingTime) - ((/* @__PURE__ */ new Date()).getTime() - __privateGet(this, _startTime)));
    this.dispatchEvent(new CustomEvent("player:pause"));
  }
  resume(restartTimer = false) {
    if (__privateGet(this, _state) !== "stopped") {
      if (restartTimer) {
        this.start();
      } else {
        clearTimeout(__privateGet(this, _timer));
        __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
        __privateSet(this, _state, "started");
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
        this.dispatchEvent(new CustomEvent("player:resume"));
      }
    }
  }
  start() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
    __privateSet(this, _state, "started");
    __privateSet(this, _remainingTime, __privateGet(this, _duration));
    __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
    this.dispatchEvent(new CustomEvent("player:start"));
  }
  stop() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "stopped");
    this.dispatchEvent(new CustomEvent("player:stop"));
  }
};
_callback = new WeakMap();
_duration = new WeakMap();
_remainingTime = new WeakMap();
_startTime = new WeakMap();
_timer = new WeakMap();
_state = new WeakMap();
_onVisibilityChangeListener = new WeakMap();
_onVisibilityChange = new WeakSet();
onVisibilityChange_fn = function() {
  if (document.visibilityState === "hidden") {
    this.pause();
  } else if (document.visibilityState === "visible") {
    this.resume();
  }
};

// js/common/actions/confirm-button.js
var ConfirmButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (!window.confirm(this.getAttribute("data-message") ?? "Are you sure you wish to do this?")) {
        event.preventDefault();
      }
    });
  }
};
if (!window.customElements.get("confirm-button")) {
  window.customElements.define("confirm-button", ConfirmButton, { extends: "button" });
}

// js/common/actions/controls.js
var PageDots = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.items = Array.from(this.children);
    this.items.forEach((button, index) => button.addEventListener("click", () => this.select(index), { signal: this._abortController.signal }));
    this.addEventListener("control:filter", this._filterItems, { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener("carousel:change", (event) => this.select(event.detail.index, false), { signal: this._abortController.signal });
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.items.indexOf(event.target)));
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
  get selectedIndex() {
    return this.items.findIndex((button) => button.getAttribute("aria-current") === "true");
  }
  select(selectedIndex, dispatchEvent = true) {
    if (this.hasAttribute("align-selected")) {
      this.scrollTo({
        left: this.items[selectedIndex].offsetLeft - this.clientWidth / 2 + this.items[selectedIndex].clientWidth / 2,
        top: this.items[selectedIndex].offsetTop - this.clientHeight / 2 - this.items[selectedIndex].clientHeight / 2,
        behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
      });
    }
    if (this.selectedIndex === selectedIndex) {
      return;
    }
    this.items.forEach((button, index) => button.setAttribute("aria-current", selectedIndex === index ? "true" : "false"));
    if (dispatchEvent) {
      this._dispatchEvent(selectedIndex);
    }
  }
  _filterItems(event) {
    this.items.forEach((item, index) => item.hidden = event.detail.filteredIndexes.includes(index));
  }
  _dispatchEvent(index) {
    (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:select", { bubbles: true, cancelable: true, detail: { index } }));
  }
};
var PrevButton = class extends HTMLButtonElement {
  connectedCallback() {
    const DISABLE_SCROLL_BUTTONS = false; // flip to true later
    this._abortController = new AbortController();
    this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:prev", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener(
        "scroll:edge-nearing",
        (event) => {
          if (!DISABLE_SCROLL_BUTTONS) this.disabled = false;
          else this.disabled = event.detail.position === "start";
        },
        { signal: this._abortController.signal }
      );

      this.controlledElement.addEventListener(
        "scroll:edge-leaving",
        (event) => {
          if (!DISABLE_SCROLL_BUTTONS) this.disabled = false;
          else this.disabled = event.detail.position === "start" ? false : this.disabled;
        },
        { signal: this._abortController.signal }
      );
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
};
var NextButton = class extends HTMLButtonElement {
  connectedCallback() {
    const DISABLE_SCROLL_BUTTONS = false; // flip to true later
    this._abortController = new AbortController();
    this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:next", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
    if (this.controlledElement) {
      this.controlledElement.addEventListener(
        "scroll:edge-nearing",
        (event) => {
          if (!DISABLE_SCROLL_BUTTONS) this.disabled = false;
          else this.disabled = event.detail.position === "end";
        },
        { signal: this._abortController.signal }
      );

      this.controlledElement.addEventListener(
        "scroll:edge-leaving",
        (event) => {
          if (!DISABLE_SCROLL_BUTTONS) this.disabled = false;
          else this.disabled = event.detail.position === "end" ? false : this.disabled;
        },
        { signal: this._abortController.signal }
      );

    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
};
if (!window.customElements.get("page-dots")) {
  window.customElements.define("page-dots", PageDots);
}
if (!window.customElements.get("prev-button")) {
  window.customElements.define("prev-button", PrevButton, { extends: "button" });
}
if (!window.customElements.get("next-button")) {
  window.customElements.define("next-button", NextButton, { extends: "button" });
}

// js/common/actions/copy-button.js
import { timeline } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var CopyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.append(this.contentElement, this.animationElement);
    this.addEventListener("click", this._copyToClipboard.bind(this));
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__feedback">  
        <svg role="presentation" focusable="false" fill="none" width="18px" height="18px" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
          <path d="m6 9.8 2.63 2.8L14 7" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
    `).firstElementChild;
  }
  async _copyToClipboard() {
    if (!navigator.clipboard) {
      return;
    }
    await navigator.clipboard.writeText(this.getAttribute("data-text") || "");
    timeline([
      [this.contentElement, { y: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15, at: "+0.5" }],
      [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
    ]);
  }
};
if (!window.customElements.get("copy-button")) {
  window.customElements.define("copy-button", CopyButton, { extends: "button" });
}

// js/common/actions/custom-button.js
import { animate, timeline as timeline2, stagger } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var CustomButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    if (this.type === "submit" && this.form) {
      this.form.addEventListener("submit", () => this.setAttribute("aria-busy", "true"));
    }
    this.append(this.contentElement, this.animationElement);
    window.addEventListener("pageshow", () => this.removeAttribute("aria-busy"));
  }
  get contentElement() {
    if (this._contentElement) {
      return this._contentElement;
    }
    this._contentElement = document.createElement("div");
    this._contentElement.append(...this.childNodes);
    return this._contentElement = this._contentElement || document.createElement("div").append();
  }
  get animationElement() {
    return this._animationElement = this._animationElement || document.createRange().createContextualFragment(`
      <span class="button__loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild;
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    /* V9.28.214 (Shrey 14 Oct: quick add stayed on "..." after Add to cart without a size): a busy flag removed within ~30 ms
       (submit blocked because no size was picked) started the "back to text" timeline while the "show dots" one was still
       running; the older one's dots-in step ended LAST and left the dots on. Stop whatever is running before starting the next. */
    if (this._mesTl) { try { this._mesTl.stop(); } catch (e) {} }
    if (this._mesDots && newValue !== "true") { try { this._mesDots.stop(); } catch (e) {} this._mesDots = null; }
    if (newValue === "true") {
      this._mesTl = timeline2([
        [this.contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
      if (this._mesDots) { try { this._mesDots.stop(); } catch (e) {} }
      this._mesDots = animate(this.animationElement.children, { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      this._mesTl = timeline2([
        [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
        [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
      ]);
    }
  }
};
if (!window.customElements.get("custom-button")) {
  window.customElements.define("custom-button", CustomButton, { extends: "button" });
}

// js/common/actions/share-button.js
var ShareButton = class extends HTMLButtonElement {
  constructor() {
    super();
    if (navigator.share) {
      this.addEventListener("click", this._showSystemShare);
    }
  }
  _showSystemShare() {
    navigator.share({
      title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
      url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
    });
  }
};
if (!window.customElements.get("share-button")) {
  window.customElements.define("share-button", ShareButton, { extends: "button" });
}

// js/common/animation/heading.js
import { stagger as stagger2 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
function getHeadingKeyframe(element, options = {}) {
  if (!element) {
    return [];
  }
  const splitLines = element.querySelector("split-lines")?.lines;
  if (window.themeVariables.settings.headingApparition === "fade" || !splitLines) {
    return [element, { opacity: [0, 1] }, { duration: 0.2, ...options }];
  } else {
    element.style.opacity = "1";
    switch (window.themeVariables.settings.headingApparition) {
      case "split_fade":
        return [splitLines, { transform: ["translateY(0.5em)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.3, delay: stagger2(0.1), ...options }];
      case "split_clip":
        return [splitLines, { clipPath: ["inset(0 0 100% 0)", "inset(0 0 -0.3em 0)"], transform: ["translateY(100%)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.7, delay: stagger2(0.15), easing: [0.22, 1, 0.36, 1], ...options }];
      case "split_rotation":
        const rotatedSpans = splitLines.map((line) => line.querySelector("span"));
        rotatedSpans.forEach((span) => span.style.transformOrigin = "top left");
        splitLines.forEach((line) => line.style.clipPath = "inset(0 0 -0.3em 0)");
        return [rotatedSpans, { transform: ["translateY(0.5em) rotateZ(5deg)", "translateY(0) rotateZ(0)"], opacity: [0, 1] }, { duration: 0.4, delay: stagger2(0.1), ...options }];
    }
  }
}

// js/common/animation/reveal-items.js
import { animate as animate2, stagger as stagger3, inView } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var _reveal, reveal_fn;
var RevealItems = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _reveal);
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, __privateMethod(this, _reveal, reveal_fn).bind(this), { margin: this.getAttribute("margin") ?? "-50px 0px" });
    }
  }
};
_reveal = new WeakSet();
reveal_fn = function() {
  this.style.opacity = "1";
  animate2(
    this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children,
    { opacity: [0, 1], transform: ["translateY(15px)", "translateY(0)"] },
    { duration: 0.35, delay: stagger3(0.05, { easing: "ease-out" }), easing: "ease" }
  );
};
if (!window.customElements.get("reveal-items")) {
  window.customElements.define("reveal-items", RevealItems);
}


// js/common/behavior/custom-cursor.js
var _abortController, _onPointerLeave, onPointerLeave_fn, _onPointerMove, onPointerMove_fn;
var CustomCursor = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onPointerLeave);
    __privateAdd(this, _onPointerMove);
    __privateAdd(this, _abortController, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController, new AbortController());
    this.parentElement.addEventListener("pointermove", __privateMethod(this, _onPointerMove, onPointerMove_fn).bind(this), { passive: true, signal: __privateGet(this, _abortController).signal });
    this.parentElement.addEventListener("pointerleave", __privateMethod(this, _onPointerLeave, onPointerLeave_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
};
_abortController = new WeakMap();
_onPointerLeave = new WeakSet();
onPointerLeave_fn = function() {
  this.classList.remove("is-visible", "is-half-start", "is-half-end");
};
_onPointerMove = new WeakSet();
onPointerMove_fn = function(event) {
  if (event.target.matches("button, a[href], button :scope, a[href] :scope")) {
    return this.classList.remove("is-visible");
  }
  const parentBoundingRect = this.parentElement.getBoundingClientRect(), parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, isOnStartHalfPart = event.pageX < parentXCenter;
  this.classList.toggle("is-half-start", isOnStartHalfPart);
  this.classList.toggle("is-half-end", !isOnStartHalfPart);
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

// js/common/behavior/gesture-area.js
var _domElement, _thresholdDistance, _thresholdTime, _signal, _firstClientX, _tracking, _start, _touchStart, touchStart_fn, _preventTouch, preventTouch_fn, _gestureStart, gestureStart_fn, _gestureMove, gestureMove_fn, _gestureEnd, gestureEnd_fn;
var GestureArea = class {
  constructor(domElement, { thresholdDistance = 80, thresholdTime = 500, signal = null } = {}) {
    __privateAdd(this, _touchStart);
    __privateAdd(this, _preventTouch);
    __privateAdd(this, _gestureStart);
    __privateAdd(this, _gestureMove);
    __privateAdd(this, _gestureEnd);
    __privateAdd(this, _domElement, void 0);
    __privateAdd(this, _thresholdDistance, void 0);
    __privateAdd(this, _thresholdTime, void 0);
    __privateAdd(this, _signal, void 0);
    __privateAdd(this, _firstClientX, void 0);
    __privateAdd(this, _tracking, false);
    __privateAdd(this, _start, {});
    __privateSet(this, _domElement, domElement);
    __privateSet(this, _thresholdDistance, thresholdDistance);
    __privateSet(this, _thresholdTime, thresholdTime);
    __privateSet(this, _signal, signal);
    __privateGet(this, _domElement).addEventListener("touchstart", __privateMethod(this, _touchStart, touchStart_fn).bind(this), { passive: true, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("touchmove", __privateMethod(this, _preventTouch, preventTouch_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerdown", __privateMethod(this, _gestureStart, gestureStart_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointermove", __privateMethod(this, _gestureMove, gestureMove_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerup", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerleave", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointercancel", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
  }
};
_domElement = new WeakMap();
_thresholdDistance = new WeakMap();
_thresholdTime = new WeakMap();
_signal = new WeakMap();
_firstClientX = new WeakMap();
_tracking = new WeakMap();
_start = new WeakMap();
_touchStart = new WeakSet();
touchStart_fn = function(event) {
  __privateSet(this, _firstClientX, event.touches[0].clientX);
};
_preventTouch = new WeakSet();
preventTouch_fn = function(event) {
  if (Math.abs(event.touches[0].clientX - __privateGet(this, _firstClientX)) > 10) {
    event.preventDefault();
  }
};
_gestureStart = new WeakSet();
gestureStart_fn = function(event) {
  __privateSet(this, _tracking, true);
  __privateSet(this, _start, {
    time: (/* @__PURE__ */ new Date()).getTime(),
    x: event.clientX,
    y: event.clientY
  });
};
_gestureMove = new WeakSet();
gestureMove_fn = function(event) {
  if (__privateGet(this, _tracking)) {
    event.preventDefault();
  }
};
_gestureEnd = new WeakSet();
gestureEnd_fn = function(event) {
  if (!__privateGet(this, _tracking)) {
    return;
  }
  __privateSet(this, _tracking, false);
  const now = (/* @__PURE__ */ new Date()).getTime(), deltaTime = now - __privateGet(this, _start).time, deltaX = event.clientX - __privateGet(this, _start).x, deltaY = event.clientY - __privateGet(this, _start).y;
  if (deltaTime > __privateGet(this, _thresholdTime)) {
    return;
  }
  let matchedEvent;
  if (deltaX === 0 && deltaY === 0 && !event.target.matches("a, button, a :scope, button :scope")) {
    matchedEvent = "tap";
  } else if (deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swiperight";
  } else if (-deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeleft";
  } else if (deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipedown";
  } else if (-deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeup";
  }
  if (matchedEvent) {
    __privateGet(this, _domElement).dispatchEvent(new CustomEvent(matchedEvent, { bubbles: true, composed: true, detail: { originalEvent: event } }));
  }
};

// js/common/behavior/height-observer.js
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateCustomProperties.bind(this)).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) {
      document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${this.clientHeight.toFixed(1)}px`);
    }
  }
  _updateCustomProperties(entries) {
    requestAnimationFrame(() => {
      entries.forEach((entry) => {
        if (entry.target === this) {
          const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
          document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${Math.round(height)}px`);
        }
      });
    });
  }
};
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}

// js/common/behavior/safe-sticky.js
import { inView as inView2 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var _resizeObserver, _checkPositionListener, _initialTop, _lastKnownY, _currentTop, _position, _recalculateStyles, recalculateStyles_fn, _checkPosition, checkPosition_fn;
var SafeSticky = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _recalculateStyles);
    __privateAdd(this, _checkPosition);
    __privateAdd(this, _resizeObserver, new ResizeObserver(__privateMethod(this, _recalculateStyles, recalculateStyles_fn).bind(this)));
    __privateAdd(this, _checkPositionListener, throttle(__privateMethod(this, _checkPosition, checkPosition_fn).bind(this)));
    __privateAdd(this, _initialTop, 0);
    __privateAdd(this, _lastKnownY, 0);
    /* we could initialize it to window.scrollY but this avoids a costly reflow */
    __privateAdd(this, _currentTop, 0);
    __privateAdd(this, _position, "relative");
  }
  connectedCallback() {
    inView2(this, () => {
      __privateGet(this, _resizeObserver).observe(this);
      window.addEventListener("scroll", __privateGet(this, _checkPositionListener));
      return () => {
        __privateGet(this, _resizeObserver).unobserve(this);
        window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
      };
    }, { margin: "500px" });
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
  }
};
_resizeObserver = new WeakMap();
_checkPositionListener = new WeakMap();
_initialTop = new WeakMap();
_lastKnownY = new WeakMap();
_currentTop = new WeakMap();
_position = new WeakMap();
_recalculateStyles = new WeakSet();
recalculateStyles_fn = function() {
  this.style.removeProperty("top");
  const computedStyles = getComputedStyle(this);
  __privateSet(this, _initialTop, parseInt(computedStyles.top));
  __privateSet(this, _position, computedStyles.position);
  __privateMethod(this, _checkPosition, checkPosition_fn).call(this);
};
_checkPosition = new WeakSet();
checkPosition_fn = function() {
  if (__privateGet(this, _position) !== "sticky") {
    return this.style.removeProperty("top");
  }
  let bounds = this.getBoundingClientRect(), maxTop = bounds.top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop), minTop = this.clientHeight - window.innerHeight + 20;
  if (window.scrollY < __privateGet(this, _lastKnownY)) {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY)));
  } else {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY));
  }
  __privateSet(this, _currentTop, Math.min(Math.max(__privateGet(this, _currentTop), -minTop), maxTop, __privateGet(this, _initialTop)));
  __privateSet(this, _lastKnownY, window.scrollY);
  this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`;
};
if (!window.customElements.get("safe-sticky")) {
  window.customElements.define("safe-sticky", SafeSticky);
}

// js/common/behavior/scroll-area.js
var ScrollArea = class {
  constructor(element, abortController2 = null) {
    this._element = element;
    this._allowTriggerNearingStartEvent = false;
    this._allowTriggerLeavingStartEvent = true;
    this._allowTriggerNearingEndEvent = true;
    this._allowTriggerLeavingEndEvent = false;
    new ResizeObserver(this._checkIfScrollable.bind(this)).observe(element);
    this._element.addEventListener("scroll", throttle(this._onScroll.bind(this)), { signal: abortController2?.signal });
  }
  get scrollNearingThreshold() {
    return 125;
  }
  get scrollDirection() {
    if (this._element.scrollWidth > this._element.clientWidth) {
      return "inline";
    } else if (this._element.scrollHeight > this._element.clientHeight) {
      return "block";
    } else {
      return "none";
    }
  }
  _checkIfScrollable() {
    this._element.classList.toggle("is-scrollable", this.scrollDirection !== "none");
  }
  _onScroll() {
    clearTimeout(this._scrollTimeout);
    this._lastScrollPosition = this._lastScrollPosition ?? (this.scrollDirection === "inline" ? Math.abs(this._element.scrollLeft) : Math.abs(this._element.scrollTop));
    let direction;
    if (this.scrollDirection === "inline") {
      direction = this._lastScrollPosition > Math.abs(this._element.scrollLeft) ? "start" : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollLeft);
    } else {
      direction = this._lastScrollPosition > Math.abs(this._element.scrollTop) ? "start" : "end";
      this._lastScrollPosition = Math.abs(this._element.scrollTop);
    }
    const scrollPosition = Math.round(Math.abs(this.scrollDirection === "inline" ? this._element.scrollLeft : this._element.scrollTop)), scrollMinusSize = Math.round(this.scrollDirection === "inline" ? this._element.scrollWidth - this._element.clientWidth : this._element.scrollHeight - this._element.clientHeight);
    if (direction === "start" && this._allowTriggerNearingStartEvent && scrollPosition <= this.scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = false;
      this._allowTriggerLeavingStartEvent = true;
      this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "start" } }));
    } else if (direction === "end" && scrollPosition > this.scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = true;
      if (this._allowTriggerLeavingStartEvent) {
        this._allowTriggerLeavingStartEvent = false;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "start" } }));
      }
    }
    if (direction === "end" && this._allowTriggerNearingEndEvent && scrollMinusSize <= scrollPosition + this.scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = false;
      this._allowTriggerLeavingEndEvent = true;
      this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "end" } }));
    } else if (direction === "start" && scrollMinusSize > scrollPosition + this.scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = true;
      if (this._allowTriggerLeavingEndEvent) {
        this._allowTriggerLeavingEndEvent = false;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "end" } }));
      }
    }
    if (window.onscrollend === void 0) {
      this._scrollTimeout = setTimeout(() => {
        this._element.dispatchEvent(new CustomEvent("scrollend", { bubbles: true, composed: true }));
      }, 75);
    }
  }
};

// js/common/behavior/scroll-progress.js
var ScrollProgress = class extends HTMLElement {
  connectedCallback() {
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }
  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
  }
  _updateScrollProgress() {
    const scrollLeft = document.dir === "ltr" ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft), advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
    this.style.setProperty("--scroll-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
  }
};
if (!window.customElements.get("scroll-progress")) {
  window.customElements.define("scroll-progress", ScrollProgress);
}

// js/common/behavior/scroll-shadow.js
var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, linear-gradient(to bottom, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-bottom, linear-gradient(to top, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-left, linear-gradient(to right, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-right, linear-gradient(to left, rgb(var(--background)), rgb(var(--background) / 0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`;
var Updater = class {
  constructor(targetElement) {
    this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
  }
  start(element) {
    if (this.element) {
      this.stop();
    }
    if (element) {
      element.addEventListener("scroll", this.scheduleUpdate);
      this.resizeObserver.observe(element);
      this.element = element;
    }
  }
  stop() {
    if (!this.element) {
      return;
    }
    this.element.removeEventListener("scroll", this.scheduleUpdate);
    this.resizeObserver.unobserve(this.element);
    this.element = null;
  }
  update(targetElement, style) {
    if (!this.element) {
      return;
    }
    const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
    const scroll2 = {
      top: Math.max(this.element.scrollTop, 0),
      bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
      left: Math.max(this.element.scrollLeft, 0),
      right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
    };
    requestAnimationFrame(() => {
      for (const position of ["top", "bottom", "left", "right"]) {
        targetElement.style.setProperty(
          `--${position}`,
          `${scroll2[position] > maxSize ? maxSize : scroll2[position]}px`
        );
      }
    });
  }
};
var ScrollShadow = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).innerHTML = template;
    this.updater = new Updater(this.shadowRoot.lastElementChild);
  }
  connectedCallback() {
    this.shadowRoot.querySelector("slot").addEventListener("slotchange", this.start);
    this.start();
  }
  disconnectedCallback() {
    this.updater.stop();
  }
  start() {
    if (this.firstElementChild) {
      this.updater.start(this.firstElementChild);
    }
  }
};
if ("ResizeObserver" in window && !window.customElements.get("scroll-shadow")) {
  window.customElements.define("scroll-shadow", ScrollShadow);
}

// js/common/behavior/split-lines.js
var _requireSplit, _lastScreenWidth, _split, split_fn, _onWindowResized, onWindowResized_fn;
var SplitLines = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _split);
    __privateAdd(this, _onWindowResized);
    __privateAdd(this, _requireSplit, true);
    __privateAdd(this, _lastScreenWidth, window.innerWidth);
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment("<slot></slot>"));
    window.addEventListener("resize", throttle(__privateMethod(this, _onWindowResized, onWindowResized_fn).bind(this)));
    new MutationObserver(__privateMethod(this, _split, split_fn).bind(this, true)).observe(this, { characterData: true, attributes: false, childList: false, subtree: true });
  }
  connectedCallback() {
    __privateMethod(this, _split, split_fn).call(this);
  }
  get lines() {
    return Array.from(this.shadowRoot.children);
  }
};
_requireSplit = new WeakMap();
_lastScreenWidth = new WeakMap();
_split = new WeakSet();
split_fn = function(force = false) {
  if (!__privateGet(this, _requireSplit) && !force) {
    return;
  }
  this.shadowRoot.innerHTML = this.textContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
  const bounds = /* @__PURE__ */ new Map();
  Array.from(this.shadowRoot.children).forEach((letter) => {
    const key = Math.round(letter.getBoundingClientRect().top);
    bounds.set(key, (bounds.get(key) || "").concat(letter.textContent));
  });
  this.shadowRoot.replaceChildren(...Array.from(bounds.values(), (line) => document.createRange().createContextualFragment(`
      <span style="display: inline-block;">
        <span style="display: block">${line}</span>
      </span>
    `)));
  __privateSet(this, _requireSplit, false);
};
_onWindowResized = new WeakSet();
onWindowResized_fn = function() {
  if (__privateGet(this, _lastScreenWidth) === window.innerWidth) {
    return;
  }
  __privateMethod(this, _split, split_fn).call(this, true);
  __privateSet(this, _lastScreenWidth, window.innerWidth);
};
if (!window.customElements.get("split-lines")) {
  window.customElements.define("split-lines", SplitLines);
}

// js/common/behavior/visibility-progress.js
import { scroll } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var VisibilityProgress = class extends HTMLElement {
  connectedCallback() {
    scroll((info) => {
      this.style.setProperty("--visibility-progress", info.y.progress);
    }, {
      target: this,
      offset: ["start end", "end start"]
    });
  }
};
if (!window.customElements.get("visibility-progress")) {
  window.customElements.define("visibility-progress", VisibilityProgress);
}

// js/common/carousel/effect-carousel.js
import { timeline as timeline3, inView as inView3 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";

// js/common/carousel/base-carousel.js
var BaseCarousel = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this._reloaded = false;
    if (Shopify.designMode) {
      this.closest(".shopify-section").addEventListener("shopify:section:select", (event) => this._reloaded = event.detail.load);
    }
    if (this.items.length > 1) {
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => this.select(this.items.indexOf(event.target), { animate: !event.detail.load }));
      }
      if (this.hasAttribute("adaptive-height")) {
        this.addEventListener("carousel:settle", this._adjustHeight);
        this._adjustHeight();
      }
      this.addEventListener("carousel:select", this._preloadImages, { signal: this._abortController.signal });
      this.addEventListener("carousel:filter", this._filterItems, { signal: this._abortController.signal });
      this.addEventListener("control:prev", this.previous, { signal: this._abortController.signal });
      this.addEventListener("control:next", this.next, { signal: this._abortController.signal });
      this.addEventListener("control:select", (event) => this.select(event.detail.index), { signal: this._abortController.signal });
    }
    if (this.selectedIndex === 0) {
      this._dispatchEvent("carousel:select", 0);
    } else {
      this.select(this.selectedIndex, { animate: false, force: true });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get items() {
    if (this.hasAttribute("reversed")) {
      return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children).reverse();
    } else {
      return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children);
    }
  }
  get visibleItems() {
    return this.items.filter((item) => item.offsetParent !== null);
  }
  get selectedIndex() {
    return this._selectedIndex = this._selectedIndex ?? parseInt(this.getAttribute("initial-index") || 0);
  }
  get selectedIndexAmongVisible() {
    return this.visibleItems.indexOf(this.selectedSlide);
  }
  get loop() {
    return false;
  }
  get selectedSlide() {
    return this.items[this.selectedIndex];
  }
  get previousSlide() {
    return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible - 1 + this.visibleItems.length) % this.visibleItems.length : Math.max(this.selectedIndexAmongVisible - 1, 0)];
  }
  get nextSlide() {
    return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible + 1 + this.visibleItems.length) % this.visibleItems.length : Math.min(this.selectedIndexAmongVisible + 1, this.visibleItems.length - 1)];
  }
  previous(animate11 = true) {
    this.select(this.items.indexOf(this.previousSlide), { direction: "previous", animate: animate11 });
  }
  next(animate11 = true) {
    this.select(this.items.indexOf(this.nextSlide), { direction: "next", animate: animate11 });
  }
  _transitionTo(fromSlide, toSlide, options = {}) {
  }
  _adjustHeight() {
    if (this.hasAttribute("adaptive-height") && this.selectedSlide.clientHeight !== this.clientHeight) {
      this.style.maxHeight = `${this.selectedSlide.clientHeight}px`;
    }
  }
  _filterItems(event) {
    this.items.forEach((item, index) => item.hidden = event.detail.filteredIndexes.includes(index));
  }
  _preloadImages() {
    [this.previousSlide, this.nextSlide].forEach((item) => {
      if (item) {
        Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
      }
    });
  }
  _dispatchEvent(eventName, index) {
    this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { slide: this.items[index], index } }));
  }
};

// js/common/carousel/effect-carousel.js
var EffectCarousel = class extends BaseCarousel {
  connectedCallback() {
    super.connectedCallback();
    if (this.items.length > 1) {
      if (this.swipeable) {
        new GestureArea(this, { signal: this._abortController.signal });
        this.addEventListener("swipeleft", this.next, { signal: this._abortController.signal });
        this.addEventListener("swiperight", this.previous, { signal: this._abortController.signal });
      }
      if (this.hasAttribute("autoplay")) {
        this._player = new Player(this.getAttribute("autoplay"));
        this._player.addEventListener("player:end", this.next.bind(this));
        inView3(this, () => this._player.resume(true));
        if (Shopify.designMode) {
          this.addEventListener("shopify:block:select", () => this._player.stop(), { signal: this._abortController.signal });
          this.addEventListener("shopify:block:deselect", () => this._player.start(), { signal: this._abortController.signal });
        }
      }
    }
  }
  get player() {
    return this._player;
  }
  get loop() {
    return true;
  }
  get swipeable() {
    return this.getAttribute("swipeable") !== "false";
  }
  async select(index, { direction, animate: animate11 = true } = {}) {
    const indexBeforeChange = this.selectedIndex;
    this._selectedIndex = index;
    this._dispatchEvent("carousel:select", index);
    if (!direction) {
      direction = index > indexBeforeChange ? "next" : "previous";
    }
    if (index !== indexBeforeChange) {
      const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
      this._dispatchEvent("carousel:change", index);
      this.player?.pause();
      await this._transitionTo(fromSlide, toSlide, { direction, animate: animate11 });
      this.player?.resume(true);
      this._dispatchEvent("carousel:settle", index);
    }
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate11 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    const timelineControls = timeline3([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { at: "<", zIndex: { easing: "step-end" } }]
    ], { duration: animate11 ? 0.3 : 0 });
    return timelineControls.finished;
  }
};
if (!window.customElements.get("effect-carousel")) {
  window.customElements.define("effect-carousel", EffectCarousel);
}

// js/common/carousel/scroll-carousel.js
var ScrollCarousel = class extends BaseCarousel {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(this._adjustHeight.bind(this))).observe(this);
    }
  }
  connectedCallback() {
    this._hasPendingProgrammaticScroll = false;
    this._scrollArea = new ScrollArea(this, this._abortController);
    super.connectedCallback();
    this.addEventListener("scroll", throttle(this._onCarouselScroll.bind(this)), { signal: this._abortController.signal });
    this.addEventListener("scrollend", this._onScrollSettled, { signal: this._abortController.signal });
  }
  get itemOffset() {
    return this.visibleItems.length < 2 ? 0 : this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
  }
  get slidesPerPage() {
    return this.visibleItems.length < 2 ? 1 : Math.floor((this.clientWidth - this.visibleItems[0].offsetLeft) / (Math.abs(this.itemOffset) - (parseInt(getComputedStyle(this).gap) || 0)));
  }
  get totalPages() {
    return this.visibleItems.length < 2 ? 1 : this.visibleItems.length - this.slidesPerPage + 1;
  }
  select(index, { animate: animate11 = true, force = false } = {}) {
    const indexBeforeChange = this.selectedIndex;
    if (!this.offsetParent || !this._scrollArea || this._scrollArea.scrollDirection === "none") {
      return this._selectedIndex = index;
    }
    const indexAmongVisible = this.visibleItems.indexOf(this.items[index]);
    index = this.items.indexOf(this.visibleItems[Math.min(this.totalPages, indexAmongVisible)]);
    this._selectedIndex = index;
    this._dispatchEvent("carousel:select", index);
    if (index !== indexBeforeChange || force) {
      const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
      this._dispatchEvent("carousel:change", index);
      this._transitionTo(fromSlide, toSlide, { animate: animate11 });
    }
  }
  /**
   * Transition using the scrollTo method. To prevent the intersection observer to caught up the change, we set up
   * a "hasPendingProgrammaticScroll" variable to true, that is set back to false once the scroll has settled
   */
  _transitionTo(fromSlide, toSlide, { animate: animate11 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let slideAlign = this._extractSlideAlign(toSlide), scrollAmount = 0;
    switch (slideAlign) {
      case "start":
        scrollAmount = this.itemOffset * this.visibleItems.indexOf(toSlide);
        break;
      case "center":
        scrollAmount = toSlide.offsetLeft - (this.clientWidth / 2 - (parseInt(getComputedStyle(this).scrollPaddingInline) || 0)) + toSlide.clientWidth / 2;
        break;
    }
    this._hasPendingProgrammaticScroll = animate11;
    this.scrollTo({ left: scrollAmount, behavior: animate11 ? "smooth" : "auto" });
  }
  /**
   * Update the index when manually scrolling (which allows to update the controls)
   */
  _onCarouselScroll() {
    if (this._hasPendingProgrammaticScroll || !this._scrollArea || this._scrollArea.scrollDirection === "none") {
      return;
    }
    const newIndex = this.items.indexOf(this.visibleItems[Math.round(this.scrollLeft / this.itemOffset)]);
    if (newIndex !== this.selectedIndex) {
      this._selectedIndex = newIndex;
      this._dispatchEvent("carousel:select", this.selectedIndex);
      this._dispatchEvent("carousel:change", this.selectedIndex);
    }
  }
  /**
   * On the scroll has settled we dispatch the event (which covers both programmatic scroll and swipe)
   */
  _onScrollSettled() {
    this._hasPendingProgrammaticScroll = false;
    this._dispatchEvent("carousel:settle", this.selectedIndex);
  }
  _adjustHeight() {
    this.style.maxHeight = null;
    if (this._scrollArea && this._scrollArea.scrollDirection !== "none") {
      super._adjustHeight();
    }
  }
  _extractSlideAlign(slide) {
    return getComputedStyle(slide).scrollSnapAlign === "center" ? "center" : "start";
  }
};
if (!window.customElements.get("scroll-carousel")) {
  window.customElements.define("scroll-carousel", ScrollCarousel);
}

// js/common/cart/cart-count.js
import { animate as animate3 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";

// js/common/cart/fetch-cart.js
var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var fetchCart = createCartPromise();
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail["cart"];
});
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});

// js/common/cart/cart-count.js
/* THE GIFT WRAP IS NOT A PRODUCT (5 Aug 2026, Shrey ruled 1A after Priyanka's 3 Aug report that
   "the cart item count is not handled consistently when Gift Wrap is added").
   The drawer has excluded the wrap line since 21 Jul; this badge did not, so one cart showed two
   different numbers depending on where you looked. `MES_WRAP_HANDLE` is published by
   sections/cart-drawer.liquid, which is the only place that knows the handle.
   ⛔ Fail-open on purpose: no handle published (drawer absent from a page) means fall back to the
   raw item_count. An inflated count is the pre-existing behaviour; a count that silently drops
   real products would be a new and worse bug. */
var mesVisibleCartCount = (cart) => {
  /* ⛔ ALWAYS RETURNS A NUMBER (6 Aug 2026 — my own regression, reported by Priyanka: "the cart
     button in the header is not showing the number of products"). The first version could hand
     back `cart.item_count` when that was undefined, or `undefined` outright on a page where the
     drawer section never published MES_WRAP_HANDLE. Impact's setter then wrote `undefined` into
     the badge's innerText, so the bubble rendered blank — a live-facing defect I introduced
     while fixing a counting bug. A count is a number or it is nothing; never a maybe. */
  if (!cart) return 0;
  const wrap = window.MES_WRAP_HANDLE || '';
  /* Greeting cards hide from the cart list exactly like the wrap (Shrey, 20 Aug 2026), so they
     come out of the badge too. Same fail-open contract: absent global = wrap-only behaviour,
     never a count that silently drops real products. */
  const cards = window.MES_CARD_HANDLES || '';
  const raw = typeof cart.item_count === 'number' ? cart.item_count : 0;
  if ((!wrap && !cards) || !Array.isArray(cart.items)) return raw;
  const n = cart.items.reduce((acc, it) => {
    if (wrap && it.handle === wrap) return acc;
    if (cards && cards.indexOf(',' + it.handle + ',') !== -1) return acc;
    return acc + (it.quantity || 0);
  }, 0);
  return typeof n === 'number' && !isNaN(n) ? n : raw;
};
var CartCount = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<span><slot></slot></span>"));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    document.addEventListener("cart:change", (event) => {
      /* wrap excluded — see mesVisibleCartCount (Shrey 1A, 5 Aug 2026). The published total is
         updated here too, so a badge parsed later and the drawer's own label cannot disagree. */
      window.MES_VISIBLE_COUNT = mesVisibleCartCount(event.detail["cart"]);
      this.itemCount = window.MES_VISIBLE_COUNT;
      /* Sweep EVERY badge, not just this instance. Measured 5 Aug on RC4: the legacy header's
         cart-count sat at a stale "1" while the pill header and the widget both read 5 — three
         surfaces, two answers, which is the shape of the bug Priyanka reported. The sweep is a
         textContent write, so it dispatches nothing and cannot loop. */
      if (window.__mesSyncCartBadges) window.__mesSyncCartBadges();
    }, { signal: this._abortController.signal });
    document.addEventListener("cart:refresh", this._updateFromServer.bind(this), { signal: this._abortController.signal });
    window.addEventListener("pageshow", this._updateFromServer.bind(this));
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  async _updateFromServer() {
    try {
      const cart = await api.fetchCartData();
      window.MES_VISIBLE_COUNT = mesVisibleCartCount(cart);
      this.itemCount = window.MES_VISIBLE_COUNT;
      if (window.__mesSyncCartBadges) window.__mesSyncCartBadges();
    } catch (err) {
      console.error("Failed to fetch cart for cart-count:", err);
    }
  }

  get itemCount() {
    return parseInt(this.innerText);
  }
  set itemCount(count) {
    if (this.itemCount === count) {
      return;
    }
    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      this.innerText = count;
    } else if (this.itemCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      this.innerText = count;
    } else {
      (async () => {
        await animate3(this.shadowRoot.firstElementChild, { transform: ["translateY(-50%)"], opacity: 0 }, { duration: 0.25, easing: [1, 0, 0, 1] }).finished;
        this.innerText = count;
        animate3(this.shadowRoot.firstElementChild, { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 }, { duration: 0.25, easing: [1, 0, 0, 1] });
      })();
    }
  }
};
if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

// js/common/cart/cart-drawer.js
import { animate as animate4 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";

// js/common/overlay/dialog-element.js
import { FocusTrap, Delegate } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var _lockLayerCount, _isLocked;
var _DialogElement = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _isLocked, false);
    this.addEventListener("dialog:force-close", (event) => {
      this.hide();
      event.stopPropagation();
    });
  }
  static get observedAttributes() {
    return ["id", "open"];
  }
  connectedCallback() {
    if (this.id) {
      this.delegate.off().on("click", `[aria-controls="${this.id}"]`, this._onToggleClicked.bind(this));
    }
    this._abortController = new AbortController();
    this.setAttribute("role", "dialog");
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load), { signal: this._abortController.signal });
      this.addEventListener("shopify:block:deselect", this.hide, { signal: this._abortController.signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("handle-section-events")) {
          this._shopifySection.addEventListener("shopify:section:select", (event) => this.show(!event.detail.load), { signal: this._abortController.signal });
          this._shopifySection.addEventListener("shopify:section:deselect", this.hide.bind(this), { signal: this._abortController.signal });
        }
        this._shopifySection.addEventListener("shopify:section:unload", () => this.remove(), { signal: this._abortController.signal });
      }
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
    this.delegate.off();
    this.focusTrap?.deactivate({ onDeactivate: false });
    if (__privateGet(this, _isLocked)) {
      __privateSet(this, _isLocked, false);
      document.documentElement.classList.toggle("lock", --__privateWrapper(_DialogElement, _lockLayerCount)._ > 0);
    }
  }
  show(animate11 = true) {
    if (this.open) {
      return;
    }
    this.setAttribute("open", animate11 ? "" : "immediate");
    return waitForEvent(this, "dialog:after-show");
  }
  hide() {
    if (!this.open) {
      return;
    }
    this.removeAttribute("open");
    return waitForEvent(this, "dialog:after-hide");
  }
  get delegate() {
    return this._delegate = this._delegate || new Delegate(document.body);
  }
  get controls() {
    return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`));
  }
  get open() {
    return this.hasAttribute("open");
  }
  get shouldTrapFocus() {
    return true;
  }
  get shouldLock() {
    return false;
  }
  /**
   * Sometimes (especially for drawer) we need to ensure that an element is on top of everything else. To do that,
   * we need to move the element to the body. We are doing that on open, and then restore the initial position on
   * close
   */
  get shouldAppendToBody() {
    return false;
  }
  get initialFocus() {
    return this.hasAttribute("initial-focus") ? this.getAttribute("initial-focus") : this.hasAttribute("tabindex") ? this : this.querySelector('input:not([type="hidden"])') || false;
  }
  get preventScrollWhenTrapped() {
    return true;
  }
  get focusTrap() {
    return this._focusTrap = this._focusTrap || new FocusTrap.createFocusTrap([this, this.shadowRoot], {
      onDeactivate: this.hide.bind(this),
      allowOutsideClick: this._allowOutsideClick.bind(this),
      initialFocus: window.matchMedia("screen and (pointer: fine)").matches ? this.initialFocus : false,
      fallbackFocus: this,
      preventScroll: this.preventScrollWhenTrapped
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "id":
        if (newValue) {
          this.delegate.off().on("click", `[aria-controls="${this.id}"]`, this._onToggleClicked.bind(this));
        }
        break;
      case "open":
        this.controls.forEach((toggle) => toggle.setAttribute("aria-expanded", newValue === null ? "false" : "true"));
        if (oldValue === null && (newValue === "" || newValue === "immediate")) {
          this.removeAttribute("inert");
          this._originalParentBeforeAppend = null;
          if (this.shouldAppendToBody && this.parentElement !== document.body) {
            this._originalParentBeforeAppend = this.parentElement;
            document.body.append(this);
          }
          const showTransitionPromise = this._showTransition(newValue !== "immediate") || Promise.resolve();
          showTransitionPromise.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:after-show", { bubbles: true }));
          });
          if (this.shouldTrapFocus) {
            this.focusTrap.activate({
              checkCanFocusTrap: () => showTransitionPromise
            });
          }
          if (this.shouldLock) {
            __privateSet(_DialogElement, _lockLayerCount, __privateGet(_DialogElement, _lockLayerCount) + 1);
            __privateSet(this, _isLocked, true);
            document.documentElement.classList.add("lock");
          }
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute("inert", "");
          const hideTransitionPromise = this._hideTransition() || Promise.resolve();
          hideTransitionPromise.then(() => {
            if (this.parentElement === document.body && this._originalParentBeforeAppend) {
              this._originalParentBeforeAppend.appendChild(this);
              this._originalParentBeforeAppend = null;
            }
            this.dispatchEvent(new CustomEvent("dialog:after-hide", { bubbles: true }));
          });
          this.focusTrap?.deactivate({
            checkCanReturnFocus: () => hideTransitionPromise
          });
          if (this.shouldLock) {
            __privateSet(this, _isLocked, false);
            document.documentElement.classList.toggle("lock", --__privateWrapper(_DialogElement, _lockLayerCount)._ > 0);
          }
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        break;
    }
  }
  /* Those methods are used to perform custom show/hide transition, and must return a promise */
  _showTransition(animate11 = true) {
  }
  _hideTransition() {
  }
  /* By default, a focus element is deactivated when you click outside it */
  _allowOutsideClick(event) {
    
    if (event.target && event.target.closest && event.target.closest("[data-mes-overlay]")) {
      return true;
    }
    if ("TouchEvent" in window && event instanceof TouchEvent) {
      return this._allowOutsideClickTouch(event);
    } else {
      return this._allowOutsideClickMouse(event);
    }
  }
  _allowOutsideClickTouch(event) {
    event.target.addEventListener("touchend", (subEvent) => {
      const endTarget = document.elementFromPoint(subEvent.changedTouches.item(0).clientX, subEvent.changedTouches.item(0).clientY);
      if (!this.contains(endTarget)) {
        this.hide();
      }
    }, { once: true });
    return false;
  }
  _allowOutsideClickMouse(event) {
    if (event.type !== "click") {
      return false;
    }
    if (!this.contains(event.target)) {
      this.hide();
    }
    let target = event.target, closestControl = event.target.closest("[aria-controls]");
    if (closestControl && closestControl.getAttribute("aria-controls") === this.id) {
      target = closestControl;
    }
    return this.id !== target.getAttribute("aria-controls");
  }
  _onToggleClicked(event) {
    event?.preventDefault();
    this.open ? this.hide() : this.show();
  }
};
var DialogElement = _DialogElement;
_lockLayerCount = new WeakMap();
_isLocked = new WeakMap();
__privateAdd(DialogElement, _lockLayerCount, 0);
var CloseButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true })));
  }
};
if (!window.customElements.get("dialog-element")) {
  window.customElements.define("dialog-element", DialogElement);
}
if (!window.customElements.get("close-button")) {
  window.customElements.define("close-button", CloseButton, { extends: "button" });
}

// js/common/overlay/drawer.js
import { animate as motionAnimate, timeline as motionTimeline } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var reduceDrawerAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches || JSON.parse("true");
var Drawer = class extends DialogElement {
  constructor() {
    super();
    const template2 = document.getElementById(this.template).content.cloneNode(true);
    this.attachShadow({ mode: "open" }).appendChild(template2);
    this.shadowRoot.addEventListener("slotchange", (event) => this._updateSlotVisibility(event.target));
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => this._updateSlotVisibility(slot));
  }
  get template() {
    return this.getAttribute("template") || "drawer-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return true;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "bottom" : this.getAttribute("open-from") || "right";
  }
  _getClipPathProperties() {
    switch (this.openFrom) {
      case "left":
        return document.dir === "ltr" ? ["inset(0 100% 0 0 round 8px)", "inset(0 0 0 0 round 8px"] : ["inset(0 0 0 100% round 8px)", "inset(0 0 0 0 round 8px"];
      case "right":
        return document.dir === "ltr" ? ["inset(0 0 0 100% round 8px)", "inset(0 0 0 0 round 8px"] : ["inset(0 100% 0 0 round 8px)", "inset(0 0 0 0 round 8px"];
      case "bottom":
        return ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"];
      case "top":
        return ["inset(0 0 100% 0 round 8px)", "inset(0 0 0 0 round 8px"];
    }
  }
  _setInitialPosition() {
    this.style.left = document.dir === "ltr" && this.openFrom === "left" || document.dir === "rtl" && this.openFrom === "right" ? "0px" : null;
    this.style.right = this.style.left === "" ? "0px" : null;
    this.style.bottom = this.openFrom === "bottom" ? "0px" : null;
    this.style.top = this.style.bottom === "" ? "0px" : null;
  }
  _showTransition(animate11 = true) {
    let animationControls;
    this._setInitialPosition();
    if (reduceDrawerAnimation) {
      animationControls = motionAnimate(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.1 });
    } else {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: this._getClipPathProperties() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    }
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }
  _hideTransition() {
    let animationControls;
    if (reduceDrawerAnimation) {
      animationControls = motionAnimate(this, { opacity: [1, 0], visibility: ["visibility", "hidden"] }, { duration: 0.2 });
    } else {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: this._getClipPathProperties().reverse() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    }
    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
  _updateSlotVisibility(slot) {
    if (!["header", "footer", "body"].includes(slot.name)) {
      return;
    }
    slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
  }
};
if (!window.customElements.get("x-drawer")) {
  window.customElements.define("x-drawer", Drawer);
}

// js/common/overlay/popover.js
import { animate as motionAnimate2, timeline as motionTimeline2 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var Popover = class extends DialogElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.getElementById(this.template).content.cloneNode(true));
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    this.controls.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    if (this.hasAttribute("close-on-listbox-select")) {
      this.addEventListener("listbox:select", this.hide, { signal: this._abortController.signal });
    }
  }
  get template() {
    return this.getAttribute("template") || "popover-default-template";
  }
  get shouldLock() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get shouldAppendToBody() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get anchor() {
    return {
      vertical: this.getAttribute("anchor-vertical") || "start",
      horizontal: this.getAttribute("anchor-horizontal") || "end"
    };
  }
  _showTransition(animate11 = true) {
    let animationControls, content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    this.style.display = "block";
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      this.style.left = "0px";
      this.style.right = null;
      this.style.bottom = "0px";
      this.style.top = null;
      animationControls = motionTimeline2([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    } else {
      let spacingBlockValue = "var(--popover-anchor-block-spacing)", spacingInlineValue = "var(--popover-anchor-inline-spacing)";
      this.style.left = this.anchor.horizontal === "start" ? spacingInlineValue : null;
      this.style.right = this.anchor.horizontal === "end" ? spacingInlineValue : null;
      if (this.anchor.vertical === "center") {
        this.style.top = `calc(50% - ${parseInt(this.clientHeight / 2)}px)`;
        this.style.bottom = null;
      } else {
        this.style.top = this.anchor.vertical === "end" ? `calc(100% + ${spacingBlockValue})` : null;
        this.style.bottom = this.anchor.vertical === "start" ? `calc(100% + ${spacingBlockValue})` : null;
      }
      animationControls = motionTimeline2([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: "none" }, { at: "<", duration: 0 }],
        [content.children, { opacity: 1 }, { at: "<", duration: 0 }]
      ]);
    }
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished;
  }
  _hideTransition() {
    let animationControls;
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
      animationControls = motionTimeline2([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: [null, "inset(100% 0 0 0 round 8px)"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    } else {
      animationControls = motionAnimate2(this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 });
    }
    return animationControls.finished.then(() => this.style.display = "none");
  }
};
if (!window.customElements.get("x-popover")) {
  window.customElements.define("x-popover", Popover);
}

// js/common/overlay/privacy-bar.js
import { Delegate as Delegate2 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var PrivacyBar = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate2(this);
    window.Shopify.loadFeatures([{
      name: "consent-tracking-api",
      version: "0.1",
      onLoad: this._onConsentLibraryLoaded.bind(this)
    }]);
    if (Shopify.designMode) {
      const section = this.closest(".shopify-section");
      section.addEventListener("shopify:section:select", this.show.bind(this));
      section.addEventListener("shopify:section:deselect", this.hide.bind(this));
    }
  }
  connectedCallback() {
    this._delegate.on("click", '[data-action="accept"]', this._acceptPolicy.bind(this));
    this._delegate.on("click", '[data-action="decline"]', this._declinePolicy.bind(this));
    this._delegate.on("click", '[data-action="close"]', this.hide.bind(this));
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  show() {
    this.style.display = "block";
  }
  hide() {
    this.style.display = "none";
  }
  _onConsentLibraryLoaded() {
    if (window.Shopify.customerPrivacy?.shouldShowGDPRBanner()) {
      this.show();
    }
  }
  _acceptPolicy() {
    window.Shopify.customerPrivacy?.setTrackingConsent(true, this.hide.bind(this));
  }
  _declinePolicy() {
    window.Shopify.customerPrivacy?.setTrackingConsent(false, this.hide.bind(this));
  }
};
if (!window.customElements.get("privacy-bar")) {
  window.customElements.define("privacy-bar", PrivacyBar);
}

/* V9.28.162 FASTER ADD TO CART (Shrey approved, 6 Oct 2026). Measured on live: add ~1.9s, then a
   second GET /cart.js 0.7-2s, then the drawer opens. Two changes, shared by every add path:
   1. the add asks for the `mes-cart-json` section too and builds the cart from it (api.js.liquid
      cartAfterAdd), falling back to the old /cart.js read whenever that section is unusable;
   2. a path that ends by opening the drawer fires `mes-cart:adding` the moment the add starts, so
      the drawer opens at once with an "Adding…" status in the offer strip (CartDrawer._onCartAdding; V9.28.163). The SAME
      variant:add then cart:change pair still follows, unchanged. A path whose add fails without a
      cart:error fires `mes-cart:add-failed`.
   Published on window for the plain-JS adders (bracelet builder, Liquid snippets), which cannot
   import api.js. Each of them keeps its old /cart.js read if this object is missing. */
var MesCartJson = {
  section: api.CART_JSON_SECTION,
  withSection: api.withCartJsonSection,
  parse: api.cartFromSections,
  afterAdd: api.cartAfterAdd,
  invalidate: api.invalidateCartRead
};
if (!window.MesCartJson) {
  window.MesCartJson = MesCartJson;
}

// js/common/cart/cart-drawer.js
var CartDrawer = class extends Drawer {
  constructor() {
    super();
    this._onPrepareBundledSectionsListener = this._onPrepareBundledSections.bind(this);
    this._onCartChangedListener = this._onCartChanged.bind(this);
    this._onCartRefreshListener = this._onCartRefresh.bind(this);
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
    // V9.28.162: the instant-open "Adding…" state (see _onCartAdding)
    this._onCartAddingListener = this._onCartAdding.bind(this);
    this._onCartAddFailedListener = this._onCartAddFailed.bind(this);
    this._onCartUpdatingListener = () => { if (this._mesAddPhase !== "adding") this._mesAddStatus("updating"); };
    this._onCartUpdateFailedListener = () => { if (this._mesAddPhase === "updating") this._mesAddStatus(null); };
    // V9.28.168: a short message in the same strip (e.g. "Only 1 in stock" when + is already at the stock maximum)
    this._onCartNoticeListener = (e) => { if (this._mesAddPhase === "adding") return; this._mesNoticeText = (e.detail && e.detail.text) || ""; this._mesAddStatus("notice"); };
    this.addEventListener("toggle", this._onAddingToggle.bind(this));
    window.addEventListener("pageshow", this._onPageShow.bind(this));
    this._productGiftWrapListener = this.toggleProductGiftWrap.bind(this);
    this._giftWrapRemoveListener = this._removeGiftWrapAll.bind(this);
    this._giftWrapAllProductsListener = this._giftWrapAllProducts.bind(this);
    
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("cart:prepare-bundled-sections", this._onPrepareBundledSectionsListener);
    document.addEventListener("cart:change", this._onCartChangedListener);
    document.addEventListener("cart:refresh", this._onCartRefreshListener);
    document.addEventListener("variant:add", this._onVariantAddedListener);
    document.addEventListener("mes-cart:adding", this._onCartAddingListener);
    document.addEventListener("mes-cart:updating", this._onCartUpdatingListener);
    document.addEventListener("mes-cart:update-failed", this._onCartUpdateFailedListener);
    document.addEventListener("mes-cart:notice", this._onCartNoticeListener);
    document.addEventListener("mes-cart:add-failed", this._onCartAddFailedListener);
    document.addEventListener("cart:error", this._onCartAddFailedListener);
    document.addEventListener("cart:gift-wrap-change", this.toggleProductGiftWrap.bind(this));
    document.addEventListener("cart:gift-wrap-remove-all", this._removeGiftWrapAll.bind(this));
    document.addEventListener("cart:update-gift-wrap-properties", this._updateGiftWrapCartProperties.bind(this))

    // Per-node wrap listeners REMOVED here (TA-41958 round 4): the checkbox 'change' and the
    // wrap-all / remove-all 'click' handlers are all DELEGATED once in
    // _initializeGiftWrapControls — per-node copies here would double-fire alongside them.
    this.giftWrapAllBtn = this.querySelector('[data-action="giftwrap-all-to-cart"]');

    this._initializeGiftWrapControls();
  }
  
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("cart:prepare-bundled-sections", this._onPrepareBundledSectionsListener);
    document.removeEventListener("cart:change", this._onCartChangedListener);
    document.removeEventListener("cart:refresh", this._onCartRefreshListener);
    document.removeEventListener("variant:add", this._onVariantAddedListener);
    document.removeEventListener("mes-cart:adding", this._onCartAddingListener);
    document.removeEventListener("mes-cart:updating", this._onCartUpdatingListener);
    document.removeEventListener("mes-cart:update-failed", this._onCartUpdateFailedListener);
    document.removeEventListener("mes-cart:notice", this._onCartNoticeListener);
    document.removeEventListener("mes-cart:add-failed", this._onCartAddFailedListener);
    document.removeEventListener("cart:error", this._onCartAddFailedListener);
    document.removeEventListener("cart:gift-wrap-change", this._productGiftWrapListener);
    document.removeEventListener("cart:gift-wrap-remove-all", this._giftWrapRemoveListener);
    document.removeEventListener("cart:update-gift-wrap-properties", this._updateGiftWrapCartProperties);
  }
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    // V3 drawer (H61): slide-up sheet on mobile, right panel on desktop
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "bottom" : "right";
  }
  _getClipPathProperties() {
    // V3 drawer (H61): match the sheet's 22px radius during the open/close clip animation
    switch (this.openFrom) {
      case "bottom":
        return ["inset(100% 0 0 0 round 22px)", "inset(0 0 0 0 round 22px"];
      default:
        return document.dir === "ltr" ? ["inset(0 0 0 100% round 22px)", "inset(0 0 0 0 round 22px"] : ["inset(0 100% 0 0 round 22px)", "inset(0 0 0 0 round 22px"];
    }
  }
  // V3 drawer (H61, V9.20.3): on mobile the sheet SLIDES up/down like the V3 mobile menu
  // (same 0.34s cubic-bezier(0.22,0.61,0.36,1) translateY), instead of the clip-path wipe.
  // Desktop keeps the base right-panel transition. Compositor-only (transform/opacity).
  _slideParts() {
    return {
      content: this.shadowRoot.querySelector('[part="content"]'),
      overlay: this.shadowRoot.querySelector('[part="overlay"]'),
      closeButton: this.shadowRoot.querySelector('[part="outside-close-button"]')
    };
  }
  // Kill every animation currently applied to the sheet's shadow parts. The hide animations
  // run with fill:"forwards" (they must hold the closed pose until visibility flips), which
  // means a hide that never reaches its cleanup leaves effects that OVERRIDE style forever —
  // reproduced 28 Jul 2026 (TA-41958 round 6): after close -> reopen, the content part sat at
  // translateY(100%) with the finished hide animation still applied, the sheet was off-screen,
  // and every touch landed on the overlay (whose click handler CLOSES the drawer). That is the
  // "cart is unresponsive after reopening" report from both testers. Cancelling stale effects
  // at show-start makes every interleaving converge to a clean open — the same cure, applied
  // preventively, as the disappearing-X fix below.
  _cancelSheetAnimations() {
    const { content, overlay, closeButton } = this._slideParts();
    [content, overlay, closeButton].forEach((el) => {
      if (el && el.getAnimations) el.getAnimations().forEach((a) => { try { a.cancel(); } catch (e) {} });
    });
  }
  _showTransition(animate11 = true) {
    // honours the OS prefers-reduced-motion only: the store's reduce_drawer_animation
    // setting is ON (it killed the old clip-wipe), but Shrey explicitly wants the V3
    // sheet to slide like the mobile menu; this transform-only slide is compositor-cheap
    if (this.openFrom !== "bottom" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return super._showTransition(animate11);
    }
    const { content, overlay, closeButton } = this._slideParts();
    this._cancelSheetAnimations();
    this._setInitialPosition();
    this.style.visibility = "visible";
    this.style.opacity = "1";
    content.style.clipPath = "none";
    const contentAnim = content.animate(
      [{ transform: "translateY(100%)" }, { transform: "translateY(0)" }],
      { duration: animate11 ? 340 : 0, easing: "cubic-bezier(0.22, 0.61, 0.36, 1)" }
    );
    const overlayAnim = overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: animate11 ? 220 : 0, easing: "ease" });
    const closeAnim = closeButton ? closeButton.animate([{ opacity: 0 }, { opacity: 1 }], { duration: animate11 ? 200 : 0, delay: animate11 ? 160 : 0, fill: "backwards" }) : null;
    const promises = [contentAnim.finished, overlayAnim.finished];
    if (closeAnim) promises.push(closeAnim.finished);
    return Promise.all(promises).then(() => this.classList.add("show-close-cursor"));
  }
  _hideTransition() {
    if (this.openFrom !== "bottom" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return super._hideTransition();
    }
    const { content, overlay, closeButton } = this._slideParts();
    const contentAnim = content.animate(
      [{ transform: "translateY(0)" }, { transform: "translateY(100%)" }],
      { duration: 280, easing: "cubic-bezier(0.55, 0, 0.55, 0.2)", fill: "forwards" }
    );
    const overlayAnim = overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 240, delay: 60, fill: "forwards" });
    // The close-button fade is fill:forwards and MUST be cancelled in cleanup below. Left running, it
    // holds the X at opacity 0 after close; the open animation is fill:BACKWARDS (no forwards), so once
    // it finishes the X reverts to that stale 0 — making the X invisible from the SECOND open onward.
    // (Shrey's disappearing-X; independent of the removed swipe. 20 Jul 2026.)
    const closeAnim = closeButton
      ? closeButton.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, fill: "forwards" })
      : null;
    // CLEANUP HARDENED (TA-41958 round 6, 28 Jul 2026). Two failure modes, both real:
    // (a) this cleanup can land AFTER a reopen has already started — animation `finished`
    //     promises resolve in a rendering step, which a busy or momentarily-frameless page
    //     delays past the next tap. Unguarded, the late cleanup then set visibility:hidden on
    //     a drawer that is OPEN. The open-attribute guard makes a late cleanup a no-op.
    // (b) if the reopen's _showTransition cancels these mid-flight animations first,
    //     `finished` REJECTS — the old chain skipped cleanup entirely (leaving the
    //     fill:forwards effects applied forever) and leaked an unhandled rejection. The
    //     catch turns an interrupted close into a resolved, harmless one.
    return Promise.all([contentAnim.finished, overlayAnim.finished]).catch(() => {}).then(() => {
      if (this.hasAttribute("open")) return; // reopened while closing — the open owns the sheet now
      this.style.visibility = "hidden";
      this.style.opacity = "";
      [contentAnim, overlayAnim, closeAnim].forEach((anim) => { if (anim) { try { anim.cancel(); } catch (e) {} } });
      this.classList.remove("show-close-cursor");
    });
  }


  /**
   * Toggle product gift wrap in cart based on custom dispatched event action and checkbox state
   */
  toggleProductGiftWrap(event) {
    const checkbox = event.detail?.target || event.target;
    const action = event.detail?.action || "";
    const quantity = event.detail?.quantity;
    const giftWrapVariant = Number(checkbox.dataset.variant);
    const productVariantSKU = checkbox.dataset.variantsku;
    const productVariant = Number(checkbox.id.split("checkbox-")[1]);
    const isChecked = checkbox.checked;
    // const label = document.getElementById(`gift-wrap-label-${productVariant}`);
    // const pillLoader = this.querySelector(`pill-loader[id="pill-loader-${productVariant}"]`);
    
    const labels = document.querySelectorAll(`.gift-wrap-label-checkbox`);
    const pillLoaders = this.querySelectorAll(`.pill-loader-checkbox`);
    
    let promise;
    
    //Hide checkbox label as soon as toggle product gift wrap is called
    checkbox.disabled = true;
    // label.classList.add('hidden-visibility');
    // setTimeout(()=>{
    //   pillLoader.setAttribute("aria-busy", "true");
    // },100)

    labels.forEach(label => label.classList.add('hidden-visibility'));
    setTimeout(() => {
      pillLoaders.forEach(pillLoader => pillLoader.setAttribute("aria-busy", "true"));
    }, 100);
    

    switch (action) {
      case "increase":
        if (isChecked) {
          promise = this._addProductToCart(giftWrapVariant, productVariant, action);
        } else {
          promise = Promise.resolve();
        }
        break;
      case "decrease":
        if (isChecked) {
          promise = this._removeProductFromCart(giftWrapVariant, productVariant, action);
        } else {
          promise = Promise.resolve();
        }
        if (quantity === 0) utils.removeCookie(checkbox.id);
        break;
      case "remove":
        if (isChecked) {
          utils.removeCookie(checkbox.id);
          promise = this._removeProductFromCart(giftWrapVariant, productVariant, action, quantity, productVariantSKU);
        } else {
          promise = Promise.resolve();
        }
        break;
      case "change":
        if (isChecked) {
          promise = this._updateProductInCart(giftWrapVariant, productVariant, action, quantity);
        } else {
          promise = Promise.resolve();
        }
        break;
      default:
        if (isChecked) {
          utils.setCookie(checkbox.id, isChecked, 30);
          promise = this._addProductToCart(giftWrapVariant, productVariant, action);
        } else {
          utils.removeCookie(checkbox.id);
          promise = this._removeProductFromCart(giftWrapVariant, productVariant, action, productVariantSKU);
        }
    }

    // Ensure promise is always defined and handle completion
    if (!promise || typeof promise.finally !== 'function') {
      promise = Promise.resolve();
    }

     promise.finally(() => {
      setTimeout(() => {
        pillLoaders.forEach(pillLoader => pillLoader.removeAttribute("aria-busy"));
        setTimeout(() => {
          labels.forEach(label => label.classList.remove('hidden-visibility'));
          checkbox.disabled = false;
        }, 100);
      }, 3000);
    }).catch((error) => {
      setTimeout(() => {
        pillLoaders.forEach(pillLoader => pillLoader.removeAttribute("aria-busy"));
        setTimeout(() => {
          labels.forEach(label => label.classList.remove('hidden-visibility'));
          checkbox.disabled = false;
        }, 100);
      }, 3000);
    });
  }


 /**
 * CUSTOM : Change gift wrap product in cart and select quantity from changed item quantity input
 */
  async _updateProductInCart(giftWrapVariant, productVariant, action, initialQuantity) {
    try {
      const cart = await api.fetchCartData();
      const giftWrapItem = cart.items.find(item => item.variant_id == giftWrapVariant);
      const productVariantItem = cart.items.find(item => item.variant_id == productVariant);
      let productVariantSKU = productVariantItem?.sku || '';
  
      if (!giftWrapItem) {
        console.log('Gift wrap item not found in cart.');
      }
  
      if (!productVariantItem) {
        console.log('Product variant item not found in cart. Deleting from cart...');
      }
  
      const giftWrapItemQty = giftWrapItem?.quantity || 0;
      const productVariantItemQty = productVariantItem?.quantity || 0;

      let giftWrapProperties = this._updateGiftWrapCartProperties("update", giftWrapItem, productVariantSKU)
  
      let cartQty;
      if (initialQuantity <= productVariantItemQty) {
        // Quantity increased
        cartQty = (productVariantItemQty - initialQuantity) + giftWrapItemQty;
      } else {
        // Quantity decreased or remained the same
        cartQty = giftWrapItemQty - (initialQuantity - productVariantItemQty);
      }

      // await api.cartUpdate(productVariant, productVariantItemQty, productVariantProperties);
      // V9.21.88: the write carries its own drawer render — paint from the response, no
      // second round trip. The catch keeps the classic refresh as the safety net.
      const json = await api.cartUpdate(giftWrapVariant, cartQty, giftWrapProperties, extractSectionId(this));
      this._dispatchWriteRender(json);

    } catch (error) {
      console.error('Error in cart operations:', error);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  }

  
   /**
   * CUSTOM : Add gift wrap product to cart and select quantity from clicked product item quantity 
   */
  async _addProductToCart(giftWrapVariant, productVariant, action) {
    // console.log("_addProductToCart");
    let isGiftWrapPresent = true;
    try {
      const cart = await api.fetchCartData();
      const giftWrapItem = cart.items.find(item => item.variant_id == giftWrapVariant);
      const productVariantItem = cart.items.find(item => item.variant_id == productVariant);
      let productVariantSKU = productVariantItem?.sku || '';
  
      if (!giftWrapItem) {
        isGiftWrapPresent = false;
        console.log('Gift wrap item not found in cart.');
      }
  
      if (!productVariantItem) {
        console.log('Product variant item not found in cart.');
      }
  
      const productVariantItemQty = productVariantItem?.quantity || 0;
      let cartQty = action === "increase" ? 1 : productVariantItemQty;
  
      let giftWrapProperties = this._updateGiftWrapCartProperties("add", giftWrapItem, productVariantSKU)
      
      // V9.21.88: writes carry their own drawer render; paint from the response.
      let json;
      if(isGiftWrapPresent){
        json = await api.cartUpdate(giftWrapVariant, cartQty+giftWrapItem.quantity, giftWrapProperties, extractSectionId(this));
      }
      else{
        json = await api.cartAdd(giftWrapVariant, cartQty, giftWrapProperties, extractSectionId(this));
      }
      this._dispatchWriteRender(json);

    } catch (error) {
      console.error('Error in cart operations:', error);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  }


 /**
 * CUSTOM : Remove gift wrap product from cart and adjust quantity based on the clicked product item quantity
 */
  async _removeProductFromCart(giftWrapVariant, productVariant, action, targetQuantity, variantSKU) {
    // console.log("_removeProductFromCart");
    try {
      const cart = await api.fetchCartData();
      const giftWrapItem = cart.items.find(item => item.variant_id == giftWrapVariant);
      const productVariantItem = cart.items.find(item => item.variant_id == productVariant);
      let productVariantSKU = productVariantItem?.sku || '';
  
      if (!giftWrapItem) {
        console.log('Gift wrap item not found in cart.');
      }
  
      if (!productVariantItem) {
        console.log('Product variant item not found in cart. Deleting from cart...');
        targetQuantity = Math.max(targetQuantity, 0);
        productVariantSKU = variantSKU;
      }
  
      const giftWrapItemQty = giftWrapItem?.quantity || 0;
      const productVariantItemQty = productVariantItem?.quantity || 0;

      let giftWrapProperties = this._updateGiftWrapCartProperties("remove", giftWrapItem, productVariantSKU)
  
      let cartQty;
      if (action === "remove") {
        cartQty = giftWrapItemQty - targetQuantity;
      } else if (action === "decrease") {
        cartQty = giftWrapItemQty - 1;
      } else {
        cartQty = giftWrapItemQty - productVariantItemQty;
      }

      // V9.21.88: when a wrap write happens it carries its own render; when NO write was
      // needed the classic refresh still runs (the product removal that got us here has its
      // own render path, but this dispatch was always the belt-and-braces — now coalesced).
      if (giftWrapItem && giftWrapItemQty > 1) {
        const json = await api.cartUpdate(giftWrapVariant, cartQty, giftWrapProperties, extractSectionId(this));
        this._dispatchWriteRender(json);
      } else if (giftWrapItem) {
        const json = await api.cartUpdate(giftWrapVariant, 0, giftWrapProperties, extractSectionId(this));
        this._dispatchWriteRender(json);
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }

    } catch (error) {
      console.error('Error in cart operations:', error);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  }


  /**
 * CUSTOM : Remove all gift wraps from cart, uncheck selected checkboxes and remove all existing cookies associated
 */
  async _removeGiftWrapAll(event){
    const giftWrapHandle = event.currentTarget.dataset.handle;
    if(!giftWrapHandle){
      console.log('Gift wrap product not found');
      return;
    }
  
    try {
      const cart = await api.fetchCartData();
      const giftWrapItem = cart.items.find(item => item.handle == giftWrapHandle);
      const giftWrapVariantId = giftWrapItem.variant_id;
      //remove all gift wraps from cart — V9.21.88: the write carries its own drawer render
      const json = await api.cartRemove(giftWrapVariantId, extractSectionId(this));

      //unchecking all checkboxes
      document.querySelectorAll('input[name="gift-wrap-checkbox"]').forEach(checkbox => {
          checkbox.checked = false;
      });

      //Removing all cookies for checked giftwraps
      utils.removeCookiesByKey("gift-wrap-checkbox")

      this._dispatchWriteRender(json);

    } catch (error) {
      console.error('Error in cart operations:', error);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  }

  
  /**
 * Adds or updates the gift wrap item in the cart based after clicking gift wrap all button.
 * @param {Event} event - The event triggered by clicking the gift wrap all button.
 */
  async _giftWrapAllProducts(event) {
    const button = event.target.closest('button');
    if (!button) {
        console.error('Gift Wrap button not found in the event target');
        return;
    }
    const variantGiftwrapNum = Number(button.dataset.variantGiftwrap);
    // Get list of all excluded gift wrap product handles
    const giftWrapExclusionList = button.dataset.excludedHandles.split(",");
    // V9.21.88: ALSO exclude the FREE GIFT — measured 10 Aug: this handler counted the
    // auto-added free keychain as wrappable (target 6 on a 5-unit cart), charged ₹39 to wrap
    // a free item, and mes-cart-v3's re-level (whose wrappableCount excludes the free gift
    // via the zone's data-mcart-wrap-freegift) corrected it 4s later — the shopper watched
    // ₹5,330 become ₹5,291. Two definitions of "wrappable" is the bug; this aligns them by
    // reading the SAME zone attribute V3 reads, never inventing a third list.
    const freeGiftHandle = (document.querySelector('[data-mcart-wrapzone]')?.getAttribute('data-mcart-wrap-freegift') || '').trim();
    if (freeGiftHandle) giftWrapExclusionList.push(freeGiftHandle);
    let giftWrapCounter = 0, variantAddedQty = 0, isGiftWrapPresent = false;
    try {
        const cart = await api.fetchCartData();
        let giftWrapProperties = {};
        let totalItemQty = 0;
        cart.items.forEach(item => {
            // Check if the product exclusion list does NOT include the current item's handle
            if(!giftWrapExclusionList.includes(item.handle)){
              const variantId = item.variant_id;
              const currentItemQty = item.quantity;
              const checkboxId = `gift-wrap-checkbox-${variantId}`;
              const checkbox = document.getElementById(checkboxId);
  
              if (variantId === variantGiftwrapNum) {
                  isGiftWrapPresent = true;
                  giftWrapCounter = currentItemQty;
              } else {
                  totalItemQty += currentItemQty;
                  giftWrapProperties[`_${item.sku}`] = "Gift Wrap";
              }
  
              if (checkbox && !utils.checkCookie(checkboxId)) {
                  utils.setCookie(checkboxId, true, 30);
                  checkbox.checked = true;
              } else if (utils.checkCookie(checkboxId) && variantId !== variantGiftwrapNum) {
                  variantAddedQty += currentItemQty;
              }
           }
        });

        // WRAP QUANTITY COMES FROM THE CART, NOT FROM COOKIES (TA-41958, Priyanka 27 Jul 2026:
        // "gift wrap for 2 products should be 39 x 2 = 78 but it sometimes remains fixed at 39",
        // and "gift wrap remains selected but no gift wrap charge is added").
        // WHAT WAS WRONG: the old line was
        //     totalItemQty - variantAddedQty + (isGiftWrapPresent ? giftWrapCounter : 0)
        // where `variantAddedQty` is the sum of quantities for items whose `gift-wrap-checkbox-*`
        // COOKIE is already set. Those cookies live for 30 DAYS and survive across carts, so they
        // describe a cart that may no longer exist. Two consequences, and they match the report
        // exactly: on a repeat visit every wrappable item already has a cookie, so
        // variantAddedQty == totalItemQty and the target collapses to the wrap qty already in the
        // cart (stays at 39, or 0 = ticked with no charge); and the `cartAdd` branch then
        // subtracted giftWrapCounter a SECOND time, having already added it in.
        // "Wrap everything" has exactly one correct answer and the cart alone knows it: one wrap
        // per wrappable unit. Cookies still drive the per-line checkbox visuals, but they no
        // longer take part in arithmetic.
        const targetQty = totalItemQty;

        // V9.21.88: both branches carry the drawer render in the write response, and the
        // add branch VERIFIES its outcome instead of leaving it to the delayed re-level.
        // Measured on 10 Aug: the read above can miss a wrap line still landing from a
        // just-fired untick, so cartAdd stacked ON TOP of it (target 5 → line at 6) and the
        // shopper watched ₹5,330 correct itself to ₹5,291 four seconds later. add.js tells
        // us the line's post-add quantity — if it overshot, one immediate absolute update
        // fixes it in the same gesture, and the render dispatched is the CORRECTED one.
        let json = null;
        if (isGiftWrapPresent) {
            // change.js sets the absolute quantity — idempotent, so a wrong earlier state heals
            json = await api.cartUpdate(variantGiftwrapNum, targetQty, giftWrapProperties, extractSectionId(this));
        } else if (targetQty > 0) {
            json = await api.cartAdd(variantGiftwrapNum, targetQty, giftWrapProperties, extractSectionId(this));
            const landedQty = json && typeof json.quantity === 'number' ? json.quantity : targetQty;
            if (landedQty !== targetQty) {
                json = await api.cartUpdate(variantGiftwrapNum, targetQty, giftWrapProperties, extractSectionId(this));
            }
        }

        if (json) {
            this._dispatchWriteRender(json);
        }
    } catch (error) {
        console.error('Error:', error);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
      }
  }

   
  /**
 * CUSTOM : Initialize gift wrap controls by syncing checkboxes with stored cookie states
 * and attaching necessary event listeners.
 */
  _initializeGiftWrapControls() {
    this.giftWrapCartBtns = document.querySelectorAll('[data-action="add-product-gift-wrap"]');
    this.giftWrapCartBtns.forEach(btn => {
      btn.checked = this._getCheckboxState(btn.id) === 'true';
    });

    // DELEGATED, ATTACHED ONCE (TA-41958 round 3, Priyanka 27 Jul 2026: "adding gift wrap for
    // two or more products only charges for a single gift wrap ... intermittent and difficult
    // to reproduce"). The old code attached a listener PER CHECKBOX on every re-render, with a
    // removeEventListener now and the addEventListener on a 750ms delay — so after every cart
    // change there was a window in which the boxes had NO handler. A tick landing inside it was
    // swallowed whole: no cart write, no cookie, and the next re-render flipped the box back off
    // (REPRODUCED on the dev base: tick box 2 400ms after box 1's re-render -> zero /cart writes,
    // box visually reverts). That one window is all three of her reported shapes: "briefly
    // appears checked then unchecks itself", "selected but no charge added", and the
    // intermittent single-wrap charge. One delegated listener on document survives every
    // re-render, so there is no window. Programmatic .checked writes (the cookie restore above,
    // the reconcile below) fire no change event, so nothing double-fires — the old delay's
    // "avoid conflicts" reason does not apply to delegation.
    if (!window.__mesWrapDelegated) {
      window.__mesWrapDelegated = true;
      document.addEventListener("change", (event) => {
        const box = event.target && event.target.closest
          ? event.target.closest('[data-action="add-product-gift-wrap"]')
          : null;
        if (box) this._productGiftWrapListener(event);
      });
      // The wrap-all + remove-all BUTTONS had the same per-node fragility (measured: a zone
      // tick ~2.5s after opening clicked a proxy whose node had been swapped by the
      // init-on-open re-render and not yet re-bound — no write, and the 8s latch expiry then
      // reverted the box). Delegate them the same way. _removeGiftWrapAll reads
      // event.currentTarget, which under delegation would be `document` — hand it the matched
      // button explicitly.
      document.addEventListener("click", (event) => {
        if (!event.target || !event.target.closest) return;
        const all = event.target.closest('[data-action="giftwrap-all-to-cart"]');
        if (all) { this._giftWrapAllProducts(event); return; }
        const rm = event.target.closest('[data-action="remove-gift-wrap-all"]');
        if (rm) this._removeGiftWrapAll({ currentTarget: rm, target: event.target });
      });
    }

    // Kept as a node lookup only (reconcile reads its data attributes); listeners are delegated above.
    this.giftWrapAllBtn = this.querySelector('[data-action="giftwrap-all-to-cart"]');

    // Cookies outlive carts; the cart is the truth. See _reconcileWrapCookies.
    this._reconcileWrapCookies();

    // Products outlive nothing; a wrap whose product is gone is a live overcharge.
    // See _reconcileOrphanWrap. Deliberately AFTER the cookie reconcile: that one only
    // acts when there is NO wrap line, this one only when there IS, so they can never
    // fight over the same cart state.
    this._reconcileOrphanWrap();
  }

  /**
   * CUSTOM (TA-41958, Priyanka 27 Jul 2026): drop gift-wrap cookies that the cart contradicts.
   *
   * Per-line wrap checkboxes are restored from `gift-wrap-checkbox-<variantId>` cookies with a
   * THIRTY DAY life, while the cart they describe lasts hours. So a visitor who wrapped something
   * last week comes back to a fresh cart with boxes already ticked and no wrap line behind them —
   * the "automatically checks" half of the report — and, until the sibling fix above, those same
   * stale cookies were subtracted from the wrap quantity, which is how "39 x 2" collapsed to 39.
   *
   * The reconcile is deliberately one-directional and conservative: if the cart HAS a wrap line we
   * leave every cookie alone, because a partial per-item selection is legitimate state we cannot
   * reconstruct from a quantity. We only act on the unambiguous case — no wrap in the cart at all,
   * therefore nothing can be wrapped, therefore every ticked box is lying.
   */
  async _reconcileWrapCookies() {
    const wrapVariant = Number(this.giftWrapAllBtn?.dataset?.variantGiftwrap || 0);
    if (!wrapVariant) return;
    try {
      const cart = await api.fetchCartData();
      const wrapped = cart.items.some(it => it.variant_id === wrapVariant && it.quantity > 0);
      if (wrapped) return;
      document.querySelectorAll('[data-action="add-product-gift-wrap"]').forEach(btn => {
        utils.removeCookie(btn.id);
        btn.checked = false;
      });
    } catch (e) { /* leave the cookies as they are rather than guess */ }
  }

  /**
   * CUSTOM (30 Jul 2026): drop gift-wrap quantity whose PRODUCT has left the cart.
   *
   * ⛔ WHY THIS IS A MONEY BUG, not tidiness. Each wrapped product stamps a `_<SKU>` property onto
   * the single gift-wrap line (see _updateGiftWrapCartProperties), and the line's QUANTITY is how
   * many wraps the customer pays for. Nothing anywhere reconciled that line when a wrapped product
   * was removed: _reconcileWrapCookies is explicitly one-directional and returns early the moment a
   * wrap line exists ("if the cart HAS a wrap line we leave every cookie alone"), and no other path
   * inspects the properties. So removing a wrapped product left its wrap behind — the shopper pays
   * ₹39 to wrap something that is not in the order, and neither the cart nor checkout shows why,
   * because the `_` prefix hides the property from display.
   *
   * ⚠ PROVENANCE, stated honestly: this was found while cleaning up a test cart via raw /cart
   * fetches, which BYPASS the theme's handlers, so that first sighting proved nothing about the real
   * UI. What justifies the fix is the CODE: the orphan direction has no handler at all. Confirmation
   * on a real device is step 4 of Priyanka's round (H189). If she reports the wrap already
   * disappearing on removal, this becomes a redundant guard rather than a fix — which is a fine
   * outcome and NOT a reason to skip it.
   *
   * Conservative by construction:
   *  - Acts ONLY on per-product `_<SKU>` keys it can positively match against the live cart. A wrap
   *    line carrying no such keys (an order-level wrap) is left completely alone — we cannot know
   *    what it refers to, and guessing here bills the customer.
   *  - A SKU-less line item cannot orphan anything, so a cart containing one aborts the pass
   *    entirely rather than treating "no SKU" as "not present" and deleting a legitimate wrap.
   *  - Never ADDS quantity, only reduces; when the last key goes, the line goes.
   */
  /**
   * Resolve the gift-wrap variant id from the most reliable source available.
   *
   * ⛔ DO NOT collapse this back to `this.giftWrapAllBtn.dataset.variantGiftwrap` — that is exactly
   * the bug this replaced, and it fails SILENTLY (the reconcile returns 0 and the overcharge stays).
   * MEASURED 30 Jul: after a cart:refresh, `_patchDrawerFrom` replaces the drawer's nodes, so the
   * cached `giftWrapAllBtn` reference is detached or null and `dataset.variantGiftwrap` is undefined.
   * The order-level button is also absent whenever that row is not rendered. My first orphan test
   * passed ONLY because I had primed the reference by hand seconds earlier; the second test, run
   * after a re-render, returned at the first line and did nothing.
   *
   * So: the cached button first (correct and cheapest when fresh), then a LIVE query for any
   * per-line checkbox, which carries the same id in `data-variant` and exists whenever there are
   * line items at all.
   */
  _resolveWrapVariantId() {
    const fromBtn = Number(this.giftWrapAllBtn?.dataset?.variantGiftwrap || 0);
    if (fromBtn) return fromBtn;
    const liveBtn = this.querySelector('[data-action="giftwrap-all-to-cart"]')
      || document.querySelector('[data-action="giftwrap-all-to-cart"]');
    const fromLive = Number(liveBtn?.dataset?.variantGiftwrap || 0);
    if (fromLive) return fromLive;
    const box = this.querySelector('[data-action="add-product-gift-wrap"][data-variant]')
      || document.querySelector('[data-action="add-product-gift-wrap"][data-variant]');
    return Number(box?.getAttribute('data-variant') || 0);
  }

  async _reconcileOrphanWrap() {
    const wrapVariant = this._resolveWrapVariantId();
    if (!wrapVariant) return;
    try {
      const cart = await api.fetchCartData();
      const wrapLine = cart.items.find(it => it.variant_id === wrapVariant && it.quantity > 0);
      if (!wrapLine) return;

      const others = cart.items.filter(it => it.variant_id !== wrapVariant);
      // If ANY real line lacks a SKU we cannot tell present from absent — abort, never guess.
      if (others.some(it => !it.sku)) return;
      const liveSkus = new Set(others.map(it => String(it.sku)));

      const props = { ...(wrapLine.properties || {}) };
      const keys = Object.keys(props).filter(k => k.startsWith('_'));
      if (!keys.length) return; // order-level wrap: not ours to judge

      const orphaned = keys.filter(k => !liveSkus.has(k.slice(1)));
      if (!orphaned.length) return;

      orphaned.forEach(k => { delete props[k]; });
      const remaining = keys.length - orphaned.length;

      // V9.21.88: this runs in the REMOVAL chain — the exact recipe behind the desktop
      // freeze (remove 1–2 products → view cart). Its writes now carry their own render
      // and the dispatch at the bottom paints from the response instead of buying another
      // section fetch on top of the removal's own re-render burst.
      let json = null;
      if (remaining <= 0) {
        json = await api.cartRemove(wrapVariant, extractSectionId(this));
        document.querySelectorAll('[data-action="add-product-gift-wrap"]').forEach(btn => {
          utils.removeCookie(btn.id);
          btn.checked = false;
        });
      } else {
        json = await api.cartUpdate(wrapVariant, remaining, props, extractSectionId(this));
        // Untick only the boxes whose product actually left; a partial selection stays intact.
        // ⚠ The markup attribute is `data-variantSKU`, which the DOM lowercases to
        // dataset.variantsku — NOT dataset.variantSKU and NOT dataset.sku. Reading the
        // camelCase form returns undefined and silently unticks nothing, so the fallback
        // chain is deliberate rather than defensive noise.
        const skuOf = (btn) => String(
          (btn.dataset && (btn.dataset.variantsku ?? btn.dataset.variantSku ?? btn.dataset.sku)) ??
          btn.getAttribute('data-variantSKU') ?? ''
        );
        orphaned.forEach(k => {
          const sku = k.slice(1);
          document.querySelectorAll('[data-action="add-product-gift-wrap"]').forEach(btn => {
            if (skuOf(btn) === sku) {
              utils.removeCookie(btn.id);
              btn.checked = false;
            }
          });
        });
      }

      this._dispatchWriteRender(json);
    } catch (e) {
      // A failed reconcile must never break the drawer; the worst case is the status quo.
      console.warn('[cart] orphan wrap reconcile skipped:', e && e.message);
    }
  }

     
   /**
 * CUSTOM : Update the properties of the gift wrap item in the cart based on the action and the associated product variant.
 *
 * This function modifies the properties of a gift wrap item in the shopping cart. If the action is "remove," 
 * it deletes the SKU key of the associated product variant from the gift wrap properties. Otherwise, it adds 
 * the SKU key with a "Gift Wrap" value.
 */
 _updateGiftWrapCartProperties(action, giftWrapItem, productVariantSKU) {
   let giftWrapProperties = { ...giftWrapItem?.properties };
   let key = `_${productVariantSKU}`; // _ makes the key private and will not display in the cart
   if(action === "remove"){
      utils.deleteKey(giftWrapProperties, key);
   }
   else{
      giftWrapProperties[key] = "Gift Wrap";
   }
   return giftWrapProperties;
 }


    
   /**
   * Updates the cart when a specific product variant is added.
   * Checks if the variant in the URL is present in the cart, then triggers an event to update the gift wrap status.
   * 
   * @param {CustomEvent} event - The event object containing cart details and the action type.
   */
  _updateCartOnVariantAdd(event) {
      if (event.detail.baseEvent !== 'variant:add') {
          return;
      }
      const url = new URL(window.location.href);
    
      /* Temp Fix:
      Local storage value is set from the selectVariant function in Variant Picker class.
      The reason it was done, when variant is selected from the quick-add button, URL is not changed to no other way to retrieve variant id
      */
      const variantId = url.searchParams.get("variant") || localStorage.getItem("variantPickerId");
      let initialQuantity;
      const cartLineItem = document.getElementById(`line-item-qty-${variantId}`);
      if (!cartLineItem) {
          console.error(`Line item with ID line-item-qty-${variantId} not found.`);
      }
      else{
        initialQuantity = cartLineItem.dataset.initialQuantity;
      }
      
      // Find the product variant in the cart items that matches the variant ID
      const productVariant = event.detail.cart.items.find(item => item.variant_id == parseInt(variantId));
      if (!productVariant) {
          // ⚠ MUST return, not fall through: this runs INSIDE the reconcile timeout BEFORE
          // _reconcileLineItems — the old `productVariant.variant_id` deref threw here whenever
          // the page URL's ?variant= wasn't in the cart (e.g. quick-adding from the cart while
          // on another product's PDP), which silently killed the reconcile and left the line
          // list stale until the next qty change (Shrey, 24 Jul 2026).
          console.error(`Product variant with ID ${variantId} not found in the cart.`);
          return;
      }

      const giftWrapCheckbox = document.getElementById(`gift-wrap-checkbox-${productVariant.variant_id}`);
      if (!giftWrapCheckbox) {
          // Row not rendered yet (fresh add) or product-level wrap disabled — dispatching with a
          // null target made toggleProductGiftWrap operate on <html> (garbage). Skip; the later
          // cart sync passes reconcile wrap state anyway.
          return;
      }
      const giftWrapChangeObject = {
          bubbles: true,
          detail: {
              target: giftWrapCheckbox,
              action: 'change',
              quantity: parseInt(initialQuantity)
          }
      };
      document.documentElement.dispatchEvent(new CustomEvent('cart:gift-wrap-change', giftWrapChangeObject));
    }


  /**
   * Get checkbox state from a cookie
   */
  _getCheckboxState(checkboxId) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${checkboxId}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
  
  _onPrepareBundledSections(event) {
    event.detail.sections.push(extractSectionId(this));
  }
  
  /**
   * Update the cart drawer content when cart content changes.
   */
  async _onCartChanged(event) {
    // Arm the scroll gate NOW, not on first _mesRunOrPark: its touch listeners attach at arm
    // time, so a gesture already in progress when the first gated job arrives would be invisible
    // and the job would run mid-scroll (caught by the 20ms-window replay on 11 Aug).
    this._mesArmScrollGate();
    // V9.28.162: the cart:change that follows an add ends its "Adding…" state. V9.28.163: it ends it as a short
    // "Added to your cart" in the same strip, which then hands back to the strip's own offer message.
    if (this._mesAdding) this._mesAddStatus("done");
    // V9.28.165: a +/-/remove ends its "Updating…" once the new rows have landed (the reconcile below runs 300 ms
    // after this event), with no "done" flash: the new numbers are the confirmation, and a removal's Undo toast
    // must get the strip back at once.
    else if (this._mesAddPhase === "updating") { clearTimeout(this._mesAddTimer); this._mesAddTimer = setTimeout(() => { if (this._mesAddPhase === "updating") this._mesAddStatus(null); }, 350); }
    // Guard (TA-41958 round 4): a cart:change carrying no bundled section render (a failed
    // or challenged request upstream) must leave the drawer as it is — half-swapping on bad
    // input is how the drawer lost its listeners and went dead.
    const bundled = event.detail && event.detail.cart && event.detail.cart["sections"]
      ? event.detail.cart["sections"][extractSectionId(this)] : null;
    if (!bundled) { console.warn('[cart] cart:change without a usable section render — drawer left as is'); return; }
    const updatedDrawerContent = new DOMParser().parseFromString(bundled, "text/html");
    if (!updatedDrawerContent.querySelector(".cart-drawer")) {
      console.warn('[cart] bundled render has no .cart-drawer — drawer left as is'); return;
    }
    if (event.detail.cart["item_count"] > 0) {
      const currentLineItemsElement = this.querySelector(".cart-drawer__line-items"), updatedLineItemsElement = updatedDrawerContent.querySelector(".cart-drawer__line-items");
      if (!currentLineItemsElement) {
        this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
        this._updateCartOnVariantAdd(event);
      } else {
        // H61: reconcile line rows in place instead of blowing away the whole list innerHTML.
        // The wholesale innerHTML swap destroyed + re-parsed every row node, so the list collapsed
        // and re-expanded for a frame — the changed item visibly jumped up and settled back.
        // Reconciling keeps every existing row node in place (only the changed row's qty + price
        // update), so nothing moves. (Shrey, 19–20 Jul 2026.)
        //
        // DEBOUNCE (per drawer instance): every qty change fires TWO cart:change events (the real
        // one + the gift-wrap sync), so two _onCartChanged run ~overlapping; and rapid clicks stack
        // more. Left un-coalesced, an earlier reconcile can run against an intermediate/empty list
        // and rebuild the row — reintroducing the jump. Cancelling the pending reconcile and keeping
        // only the latest means ONE reconcile per burst, against the final cart state (measured
        // 20 Jul 2026: this is what actually stops repeated-click node churn).
        clearTimeout(this._mesReconcileTimer);
        this._mesReconcileTimer = setTimeout(() => {
          // SCROLL-IDLE GATE (round 9, 10 Aug 2026). This reconcile mutates rows INSIDE the
          // drawer's scroll container, and it fires 300ms-2s after a cart write — exactly when
          // the shopper's thumb is back on the list. On Android, replacing/patching DOM under an
          // active touch gesture ABORTS the gesture: the scroller goes dead until the finger
          // lifts and re-flicks, which Priyanka reported as "stuck ~4s, inconsistently, on wrap
          // add / wrap remove / adding recommended products" — i.e. on every WRITE, felt only
          // when a scroll was in flight (the inconsistency). Desktop-Chromium script cost was
          // already profiled to ≤20ms, so the payload is the gesture kill, not the work itself.
          this._mesRunOrPark("reconcile", () => {
            // Isolated: a throw in the gift-wrap bookkeeping must NEVER kill the list reconcile
            // below (it did — stale list after quick-add; Shrey, 24 Jul 2026).
            try { this._updateCartOnVariantAdd(event); } catch (e) { console.error("updateCartOnVariantAdd failed", e); }
            // Re-query the live list at run time — never trust the reference captured above (a sibling
            // cart:change can have detached it).
            const liveLineItems = this.querySelector(".cart-drawer__line-items") || currentLineItemsElement;
            this._reconcileLineItems(liveLineItems, updatedLineItemsElement);
            this._initializeGiftWrapControls();
          });
        }, event.detail.baseEvent === "variant:add" ? 0 : 300); // was 1250 — the line row (qty + price) lagged a full second behind the footer on every qty change (H61 perf pass); 300ms still clears the LineItemQuantity debounce window
        // Image-preserving swap (round 5, 28 Jul 2026). These were unconditional
        // replaceChildren calls: every cart change re-created the footer wholesale — the
        // payment-icon strip, the <buy-buttons> custom element (destroyed and re-upgraded)
        // and its <style> node — even when the markup was byte-identical. Measured churn on
        // one add: 2 image nodes and 7 children replaced for a total that changed by a few
        // rupees. Now: untouched when nothing differs, and unchanged images are carried
        // across rather than rebuilt. See _swapRegionPreservingImages.
        // Same scroll-idle gate as the reconcile: the footer swap reflows the scroller (its
        // height changes), which is enough to kill an in-flight Android scroll gesture. Idle =
        // runs immediately, so the 1-2s price-update time Priyanka measured is unchanged.
        this._mesRunOrPark("swaps", () => {
          this._swapRegionPreservingImages(this.querySelector('[slot="prices"]'), updatedDrawerContent.querySelector('[slot="prices"]'));
          this._swapRegionPreservingImages(this.querySelector('[slot="footer"]'), updatedDrawerContent.querySelector('[slot="footer"]'));
        });
      }
    } else {
      await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
      this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
      animate4(this.querySelector(".empty-state"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
    }
    this._initializeGiftWrapControls();
  }

  /**
   * Reconcile the drawer's line-item rows against a freshly-rendered list WITHOUT rebuilding the
   * DOM. Rows are matched by the STABLE variant id (data-mcart-variant): an existing row is updated
   * in place (never the node), a genuinely new line is inserted, a vanished line is removed. This
   * replaces `currentEl.innerHTML = updatedEl.innerHTML`, which recreated every row and made the
   * changed item jump.
   *
   * ⚠ Why variant id and NOT data-mcart-key: Shopify's line_item.key is `variant:hash`, and on this
   * store the hash is RE-COMPUTED on every quantity change (measured 19 Jul 2026: the same line went
   * `44541923262688:249071b5…` → `…:f3df08e0…` on a single +1). Keying on it made every existing row
   * look "removed", so the reconcile rebuilt the node — the exact jump we were fixing. The variant id
   * is stable; an ordered per-variant queue keeps the rare "same variant on two lines" case pairing
   * correctly (Shopify preserves cart line order). (H61, Shrey 19–20 Jul 2026.)
   */
  /**
   * SCROLL-IDLE GATE (round 9, 10 Aug 2026). Runs `fn` immediately when the drawer is not being
   * scrolled; while a touch gesture or momentum scroll is in flight, parks it and runs it when
   * the scroll rests. Mutating the scroller's DOM mid-gesture aborts the gesture on Android —
   * the "cart stuck ~4s after any write" Priyanka reported across three different triggers.
   *
   * Mechanics: touchstart→touchend tracks the finger; any capture-phase scroll event inside the
   * drawer stamps _mesLastScrollAt, so momentum counts as busy until events stop for 250ms.
   * One parked job per key — a newer job replaces the older (only the final state matters).
   * HARD CAP 2.5s: continuous scrolling must never starve the update; one mid-scroll hiccup
   * beats a permanently stale total. Desktop wheel scrolling passes through the same gate and
   * simply defers by ≤250ms after the last scroll event.
   */
  _mesArmScrollGate() {
    if (this._mesGateArmed) return;
    this._mesGateArmed = true;
    this._mesTouchDown = false;
    this._mesLastScrollAt = 0;
    this._mesParked = {};
    this._mesParkedAt = {};
    // TOUCHEND-LOSS INSURANCE (11 Aug 2026): touch events are locked to the node they started
    // on, so if the reconcile replaces that row mid-gesture the touchend fires on a DETACHED
    // node and never propagates here — _mesTouchDown would stay true and every update would
    // limp along on the 2.5s cap. A touch that reports no end within 10s is over.
    const lift = () => { this._mesTouchDown = false; clearTimeout(this._mesTouchSafety); };
    this.addEventListener("touchstart", () => {
      this._mesTouchDown = true;
      clearTimeout(this._mesTouchSafety);
      this._mesTouchSafety = setTimeout(lift, 10000);
    }, { passive: true, capture: true });
    this.addEventListener("touchend", lift, { passive: true, capture: true });
    this.addEventListener("touchcancel", lift, { passive: true, capture: true });
    this.addEventListener("scroll", () => { this._mesLastScrollAt = performance.now(); }, { passive: true, capture: true });
  }

  _mesScrollBusy() {
    return this._mesTouchDown || performance.now() - (this._mesLastScrollAt || 0) < 250;
  }

  _mesRunOrPark(key, fn) {
    this._mesArmScrollGate();
    if (!this._mesScrollBusy()) {
      // A newer update SUPERSEDES any parked one — cancel it before running, or the parked
      // (stale) job's poll fires up to 120ms later and repaints old state over this fresh one.
      // Priyanka hit exactly that on 11 Aug: removed a product, list updated, and the footer
      // total resurrected the pre-removal render — reproduced here as FRESH>STALE ordering.
      this._mesParked[key] = null;
      this._mesParkedAt[key] = 0;
      if (this._mesParkPolls && this._mesParkPolls[key]) clearTimeout(this._mesParkPolls[key]);
      fn(); return;
    }
    this._mesParked[key] = fn;
    if (!this._mesParkedAt[key]) this._mesParkedAt[key] = performance.now();
    clearTimeout(this._mesParkPolls && this._mesParkPolls[key]);
    this._mesParkPolls = this._mesParkPolls || {};
    const poll = () => {
      const parked = this._mesParked[key];
      if (!parked) return;
      const overdue = performance.now() - this._mesParkedAt[key] > 2500;
      if (!this._mesScrollBusy() || overdue) {
        this._mesParked[key] = null;
        this._mesParkedAt[key] = 0;
        parked();
      } else {
        this._mesParkPolls[key] = setTimeout(poll, 120);
      }
    };
    this._mesParkPolls[key] = setTimeout(poll, 120);
  }

  _reconcileLineItems(currentEl, updatedEl) {
    if (!currentEl || !updatedEl) return;
    const variantOf = (node) => (node.getAttribute ? node.getAttribute("data-mcart-variant") : null);

    // Index current rows by variant id, preserving DOM order (a queue per variant).
    const currentByVariant = new Map();
    currentEl.querySelectorAll(":scope > .mcart-li[data-mcart-variant]").forEach((row) => {
      const v = variantOf(row);
      if (!currentByVariant.has(v)) currentByVariant.set(v, []);
      currentByVariant.get(v).push(row);
    });

    // Walk the freshly-rendered rows in order, keeping matched nodes exactly where they are.
    let anchor = null; // the last row we placed — new rows go after it, preserving order
    updatedEl.querySelectorAll(":scope > .mcart-li[data-mcart-variant]").forEach((newRow) => {
      const queue = currentByVariant.get(variantOf(newRow));
      const existing = queue && queue.length ? queue.shift() : null;
      if (existing) {
        this._syncLineItemRow(existing, newRow);
        // Only re-seat if genuinely out of order — in the common case this is a no-op, so the
        // node never moves (that no-move is the whole point).
        if (anchor ? existing.previousElementSibling !== anchor : existing !== currentEl.firstElementChild) {
          if (anchor) anchor.after(existing);
          else currentEl.insertBefore(existing, currentEl.firstChild);
        }
        anchor = existing;
      } else {
        const inserted = document.importNode(newRow, true);
        if (anchor) anchor.after(inserted);
        else if (currentEl.firstChild) currentEl.insertBefore(inserted, currentEl.firstChild);
        else currentEl.appendChild(inserted);
        anchor = inserted;
      }
    });

    // Any current row not consumed above is gone from the cart — remove it.
    // (Quantity-to-zero rows usually animate themselves out via LineItem._onChanged before this
    // runs; this is the fallback so the list can never hold a stale row.)
    currentByVariant.forEach((rows) => rows.forEach((row) => row.remove()));

    // The savings strip is a non-row direct child that appears/updates/disappears with discounts.
    // It sits below every row, so replacing it can't shift a line item.
    const curStrip = currentEl.querySelector(":scope > [data-mcart-strip]");
    const newStrip = updatedEl.querySelector(":scope > [data-mcart-strip]");
    if (curStrip && newStrip) {
      if (curStrip.outerHTML !== newStrip.outerHTML) curStrip.replaceWith(document.importNode(newStrip, true));
    } else if (curStrip && !newStrip) {
      curStrip.remove();
    } else if (!curStrip && newStrip) {
      currentEl.appendChild(document.importNode(newStrip, true));
    }

    // V9.28.152 (Priyanka, 2 Oct): the cart-offer marker ([data-mes-cart-covered]: eligible units and their prices) is
    // also a non-row child. Left out here it went stale on every change to a non-empty cart, so collection cards kept
    // the "20% off the 2nd" price after the pair was complete. Replaced (not attribute-synced) so MesCartOffer's
    // added-node observer repaints even when this reconcile was parked past its 450ms re-check.
    const curMarker = currentEl.querySelector(":scope > [data-mes-cart-covered]");
    const newMarker = updatedEl.querySelector(":scope > [data-mes-cart-covered]");
    if (newMarker && (!curMarker || curMarker.outerHTML !== newMarker.outerHTML)) {
      const fresh = document.importNode(newMarker, true);
      if (curMarker) curMarker.replaceWith(fresh); else currentEl.appendChild(fresh);
    }
  }

  /**
   * Update one existing line row in place from a freshly-rendered copy — no node is destroyed, so
   * the row cannot reflow or jump. Because the line key is re-hashed on every change (see
   * _reconcileLineItems), this MUST propagate the new key/href onto the surviving controls, or the
   * next +/-/remove click would target a stale line. (H61, Shrey 19–20 Jul 2026.)
   */
  _syncLineItemRow(existing, updated) {
    const copyAttrs = (from, to, removeMissing) => {
      if (!from || !to) return;
      for (const a of Array.from(from.attributes)) {
        if (to.getAttribute(a.name) !== a.value) to.setAttribute(a.name, a.value);
      }
      if (removeMissing) {
        for (const a of Array.from(to.attributes)) {
          if (!from.hasAttribute(a.name)) to.removeAttribute(a.name);
        }
      }
    };

    // Wrapper attrs (data-mcart-key/qty/title, class). Add/update only — never strip a runtime attr
    // the fresh render doesn't know about. This carries the re-hashed key forward on the same node.
    copyAttrs(updated, existing, false);

    // Interactive controls carry the key too (data-line-key, remove href, data-quantity) and the
    // wrap checkbox's disabled state — full-sync these (removeMissing) so disabled can also clear.
    ["input.quantity-input", "a.quantity-decrease", "a.quantity-increase", "a.mcart-li__x", ".mcart-li__wrapcheck"].forEach((sel) => {
      copyAttrs(updated.querySelector(sel), existing.querySelector(sel), true);
    });

    // A rendered <input>'s live value isn't set by its value attribute — set it explicitly.
    const curInput = existing.querySelector("input.quantity-input");
    const newInput = updated.querySelector("input.quantity-input");
    if (curInput && newInput) {
      const v = newInput.getAttribute("value") || newInput.value || "";
      if (curInput.value !== v) curInput.value = v;
    }

    // Price block (compare + final) and the gift-wrap "N × price" line: inline spans, so swapping
    // their innerHTML when changed can't move the row vertically.
    [".mcart-li__price", ".mcart-li__wrapqty"].forEach((sel) => {
      const c = existing.querySelector(sel);
      const n = updated.querySelector(sel);
      if (c && n && c.innerHTML !== n.innerHTML) c.innerHTML = n.innerHTML;
    });
  }


  /**
   * Handle the case when the page is served from BF cache
   */
  _onPageShow(event) {
    if (!event.persisted) {
      return;
    }
    this._onCartRefresh();
  }

  
  /**
   * Listeners called when a new variant has been added
   */
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "drawer" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    // V9.28.162: the drawer already opened for this add and the shopper closed it while it was
    // still adding; reopening it ~2s later would undo their choice. Time-boxed, so a stale flag
    // can never swallow a later, unrelated add.
    const dismissedAt = this._mesAddingDismissedAt || 0;
    this._mesAddingDismissedAt = 0;
    if (dismissedAt && performance.now() - dismissedAt < 15000) {
      this._initializeGiftWrapControls();
      return;
    }
    this.show();
    // Reinitialize checkboxes and their event listeners after cart refresh
    this._initializeGiftWrapControls();
  }

  /**
   * V9.28.162 INSTANT OPEN. `mes-cart:adding` fires the moment an add starts on a path that ends by
   * opening the drawer. Same gate as _onVariantAdded (drawer cart type, blockCartDrawerOpening, which
   * the quick-buy drawer sets on its own adds exactly as it does for variant:add), so a path that
   * shows a toast or goes to /cart is untouched. The later variant:add finds the drawer open and its
   * show() is a no-op; the following cart:change paints the line and ends the state.
   * Ends on: cart:change, cart:error, mes-cart:add-failed, the shopper closing the sheet, or 10s.
   * On a failed add the sheet closes again ONLY if this add opened it: before, a failed add never
   * opened the drawer and its error shows beside the button, which an open sheet would cover.
   */
  _onCartAdding(event) {
    if (window.themeVariables.settings.cartType !== "drawer" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    this._mesAddingDismissedAt = 0;
    this._mesAddingOpened = !this.open;
    // V9.28.163: what is being added, for the pending cart's line (photo, name, variant). ProductLoader is the cache
    // the product page already filled, so this is normally instant; a miss just leaves the shimmer in place.
    this._mesAddProduct = null;
    const addHandle = event.detail && event.detail.handle, addVariant = Number(event.detail && event.detail.variantId);
    if (addHandle) {
      const token = this._mesAddToken = (this._mesAddToken || 0) + 1;
      Promise.resolve(ProductLoader.load(addHandle)).then((p) => {
        if (token !== this._mesAddToken || !p || !Array.isArray(p.variants)) return;
        const v = p.variants.find((x) => x.id === addVariant) || null;
        const img = (v && v.featured_image && v.featured_image.src) || p.featured_image || "";
        this._mesAddProduct = {
          title: p.title || "",
          variant: v && p.variants.length > 1 ? String(v.title || "") : "",
          image: img ? img + (img.indexOf("?") === -1 ? "?" : "&") + "width=160" : ""
        };
        this._mesPaintAddStatus();
      }).catch(() => {});
    }
    this._mesAddStatus("adding");
    this.show();
  }

  _onCartAddFailed() {
    this._mesAddingDismissedAt = 0; // a failed add sends no variant:add, so nothing is left to suppress
    if (!this._mesAdding) return;
    const opened = this._mesAddingOpened;
    this._mesAddingOpened = false;
    this._mesAddStatus(null);
    if (opened) this.hide();
  }

  _onAddingToggle(event) {
    if (event.target === this && !this.open && this._mesAddPhase === "updating") { this._mesAddStatus(null); return; }
    if (event.target !== this || this.open || !this._mesAdding) return;
    this._mesAddingDismissedAt = performance.now();
    this._mesAddingOpened = false;
    this._mesAddStatus(null);
  }_mesAddStatus(phase) {
    clearTimeout(this._mesAddTimer);
    this._mesAdding = phase === "adding";
    this._mesAddPhase = phase || null;
    if (phase === "adding") {
      // never leave it stuck: a path that dies without any event still clears here
      this._mesAddTimer = setTimeout(() => { this._mesAddingOpened = false; this._mesAddStatus(null); }, 10000);
    } else if (phase === "notice") {
      this._mesAddTimer = setTimeout(() => { if (this._mesAddPhase === "notice") this._mesAddStatus(null); }, 2400);
    } else if (phase === "updating") {
      this._mesAddTimer = setTimeout(() => this._mesAddStatus(null), 10000);
    } else if (phase === "done") {
      this._mesAddTimer = setTimeout(() => this._mesAddStatus(null), 1600);
    }
    if (phase) {
      // ⛔ Loop breaker. A paint that writes on every call would re-trigger this observer forever in microtasks and
      // freeze the page (the first build did exactly that on an empty cart, 7 Oct). More than 40 paints in a second
      // means the paint is not settling: stop observing and leave the cart as it is rather than hang the tab.
      this._mesAddObserver = this._mesAddObserver || new MutationObserver(() => {
        const now = performance.now();
        if (now - (this._mesAddBurstAt || 0) > 1000) { this._mesAddBurstAt = now; this._mesAddBurst = 0; }
        if (++this._mesAddBurst > 40) { this._mesAddObserver.disconnect(); return; }
        this._mesPaintAddStatus();
      });
      this._mesAddObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden"] });
    } else if (this._mesAddObserver) {
      this._mesAddObserver.disconnect();
    }
    this._mesPaintAddStatus();
  }

  // Pending cart line: photo, name and variant of the product being added, once known. Writes only what differs, so
  // the observer that calls the paint settles (see the V9.28.163 note above _mesAddStatus).
  _mesFillPending(card) {
    const prod = this._mesAddProduct;
    if (!prod || card.getAttribute("data-mcart-filled") === prod.title) return;
    card.setAttribute("data-mcart-filled", prod.title);
    const title = card.querySelector("[data-mcart-pend-title]");
    if (title && prod.title) title.textContent = prod.title;
    const variant = card.querySelector("[data-mcart-pend-variant]");
    if (variant) variant.textContent = prod.variant;
    const holder = card.querySelector("[data-mcart-pend-img]");
    if (holder && prod.image) {
      const img = document.createElement("img");
      img.className = "mcart-li__img";
      img.alt = "";
      img.width = 64;
      img.height = 64;
      img.decoding = "async";
      img.src = prod.image;
      holder.replaceWith(img);
    }
  }

  _mesPaintAddStatus() {
    const phase = this._mesAddPhase;
    const card = this.querySelector(".cart-drawer__line-items");
    const empty = card ? null : this.querySelector(".mcart-empty");
    let strip = card ? card.querySelector(":scope > [data-mcart-strip]") : null;
    let solo = this.querySelector("[data-mcart-addsolo]");
    if (solo && (phase !== "adding" || !empty)) { solo.remove(); solo = null; }
    const pendingOn = phase === "adding" && !!empty;
    if (!pendingOn) this.querySelectorAll("[data-mcart-pending]").forEach((n) => n.remove());
    const tpl = this.querySelector("template[data-mcart-pending-tpl]");
    if (pendingOn && tpl && !this.querySelector("[data-mcart-pending]")) {
      // Hold the sheet at the empty state's height (measured just before it is hidden), see .mcart--pending in mes-cart-v3.css.
      const part = this.shadowRoot && this.shadowRoot.querySelector('[part="content"]');
      const h = part ? Math.round(part.getBoundingClientRect().height) : 0;
      if (h > 200) this.style.setProperty("--mcart-pend-h", h + "px"); else this.style.removeProperty("--mcart-pend-h");
      this.appendChild(tpl.content.cloneNode(true));
    }
    const pendCard = pendingOn ? this.querySelector("[data-mcart-pending-card]") : null;
    if (pendCard) this._mesFillPending(pendCard);
    if (this.classList.contains("mcart--adding") !== pendingOn) this.classList.toggle("mcart--adding", pendingOn);
    if (this.classList.contains("mcart--pending") !== !!pendCard) this.classList.toggle("mcart--pending", !!pendCard);
    if (pendCard) strip = pendCard.querySelector(":scope > [data-mcart-strip]");
    // The target is chosen BEFORE the clean-up below, so the clean-up can never strip the very element it then re-paints.
    // (The standalone strip is only a fallback for a drawer rendered before the pending template existed.)
    if (phase === "adding" && !strip && empty) {
      if (!solo) {
        solo = document.createElement("div");
        solo.className = "mcart-strip mcart-strip--solo";
        solo.setAttribute("data-mcart-strip", "");
        solo.setAttribute("data-mcart-addsolo", "");
        const orb = empty.querySelector(".mcart-empty__orb");
        if (orb) orb.after(solo); else empty.prepend(solo);
      }
      strip = solo;
    }
    this.querySelectorAll("[data-mcart-strip].is-status").forEach((s) => {
      if (phase && s === strip) return;
      s.classList.remove("is-status", "is-done", "is-notice");
      const st = s.querySelector(":scope > .mcart-strip__status");
      if (st) st.remove();
      // same rule as mes-cart-v3.js clearToast: the strip stays only while it carries a message of its own
      if (!s.querySelector(".mcart-strip__save, .mcart-strip__nudge, .mcart-strip__toast")) s.hidden = true;
    });
    if (!phase || !strip) return;
    const done = phase === "done";
    if (!strip.classList.contains("is-status")) strip.classList.add("is-status");
    if (strip.classList.contains("is-done") !== done) strip.classList.toggle("is-done", done);
    const notice = phase === "notice";
    if (strip.classList.contains("is-notice") !== notice) strip.classList.toggle("is-notice", notice);
    if (strip.hidden) strip.hidden = false;
    let st = strip.querySelector(":scope > .mcart-strip__status");
    if (!st) {
      st = document.createElement("span");
      st.className = "mcart-strip__status";
      st.setAttribute("role", "status");
      st.setAttribute("aria-live", "polite");
      st.innerHTML = '<span class="mcart-strip__statusicon" aria-hidden="true"></span><span class="mcart-strip__statustxt"></span>';
      strip.appendChild(st);
    }
    const text = done ? "Added to your cart" : phase === "updating" ? "Updating your cart…" : phase === "notice" ? (this._mesNoticeText || "") : "Adding to your cart…";
    const txt = st.querySelector(".mcart-strip__statustxt");
    if (txt.textContent !== text) txt.textContent = text;
  }

  
  /**
   * V9.21.88 (10 Aug 2026): paint straight from a WRITE RESPONSE that carried its own render.
   *
   * Every wrap handler below used to end with dispatch('cart:refresh') — a SECOND round trip
   * (section fetch) plus a full patch, per dispatch, per subsystem. Measured cost of that
   * design on RC4: tap→server-correct ~1s but tap→painted-price ~2s best case and NEVER
   * (>12s) worst case, with the price then moving a second time when the re-level correction
   * landed; and the removal path stacked enough of these to block the desktop main thread
   * for 499ms in one task (Priyanka's ~5s freeze on a slower Safari).
   *
   * Now the write itself asks Shopify to bundle the drawer's section render into its response
   * (`sections` param, added in api.js), and this helper hands that render to the SAME
   * in-place reconcile path a normal line-item change uses (_onCartChanged). One request,
   * paint from the response, no second fetch, no full-drawer patch.
   *
   * Shapes, stated because they differ: change.js/update.js responses ARE the cart JSON
   * (item_count present) — dispatch directly. add.js responses are the added-line JSON
   * (no item_count), so the cart is taken from the now-invalidated shared read (one real
   * read) and the bundled render attached to it. Anything unexpected — no sections, no
   * usable shape, a throw — falls back to the classic cart:refresh, which remains the
   * safety net it always was.
   */
  _dispatchWriteRender(json) {
    try {
      const secId = extractSectionId(this);
      const bundled = json && json.sections && json.sections[secId];
      if (!bundled) { this._requestCartRefresh(); return; }
      if (typeof json.item_count === 'number') {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'soft:update', cart: json }
        }));
        return;
      }
      // add.js shape: fetch the cart (post-write, cache invalidated → real read), attach render
      api.fetchCartData().then((cart) => {
        const withSections = Object.assign({}, cart, { sections: json.sections });
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'soft:update', cart: withSections }
        }));
      }).catch(() => this._requestCartRefresh());
    } catch (e) {
      console.warn('[cart] write-render dispatch failed, falling back to refresh:', e && e.message);
      this._requestCartRefresh();
    }
  }

  /**
   * V9.21.88: COALESCED refresh. Several subsystems dispatch cart:refresh on the same burst
   * (wrap bookkeeping, free gift, orphan reconcile) and each dispatch used to buy its own
   * section fetch + full patch — that stacking is what the 499ms desktop long task was made
   * of. All internal callers now come through here: dispatches within a 150ms window collapse
   * into ONE _onCartRefresh, and a dispatch while a refresh is already fetching schedules
   * exactly one follow-up (the state may have changed since that fetch started) instead of
   * piling on. External document-level dispatches still work — the listener path is unchanged.
   */
  _requestCartRefresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /**
   * Force a complete refresh of the cart drawer (this is called by dispatching the 'cart:refresh' on the document)
   */
  async _onCartRefresh() {
    // COALESCE (V9.21.88): collapse a burst of refresh requests into one section fetch.
    // First call arms a 150ms timer; further calls inside the window are absorbed by it.
    // A call landing while the fetch is IN FLIGHT sets a dirty flag → one follow-up run.
    if (this._refreshTimer || this._refreshInFlight) {
      if (this._refreshInFlight) this._refreshDirty = true;
      return;
    }
    this._refreshTimer = setTimeout(() => { this._refreshTimer = null; this._runCartRefresh(); }, 150);
  }

  async _runCartRefresh() {
    // HARDENED (TA-41958 round 4, 27 Jul 2026). This used to do
    // `tempDiv.querySelector("#cart-drawer").children` unguarded — when the section fetch
    // returns anything but the real render (Shopify's bot-challenge page, a 429, a network
    // error page), that's a TypeError on null, the drawer keeps whatever half-state it had,
    // and the exception was the crash signature captured in Priyanka's session. Rule: a
    // failed refresh keeps the CURRENT drawer intact and retries once; it never swaps in
    // garbage and never throws.
    this._refreshInFlight = true;
    try {
      const res = await fetch(`${window.Shopify.routes.root}?section_id=${extractSectionId(this)}`);
      if (!res.ok) throw new Error('section refresh HTTP ' + res.status);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = await res.text();
      const fresh = tempDiv.querySelector("#cart-drawer");
      if (!fresh) throw new Error('section refresh returned no #cart-drawer');
      this._patchDrawerFrom(fresh);
      // Reinitialize checkboxes and their event listeners after cart refresh
      this._initializeGiftWrapControls();
      this._refreshRetried = false;
    } catch (e) {
      console.warn('[cart] refresh failed, keeping current drawer:', e && e.message);
      if (!this._refreshRetried) {
        this._refreshRetried = true;
        setTimeout(() => this._onCartRefresh(), 2500);
      }
    } finally {
      this._refreshInFlight = false;
      if (this._refreshDirty) {
        // state changed while we were fetching — one follow-up, through the coalescer
        this._refreshDirty = false;
        this._onCartRefresh();
      }
    }
  }

  /**
   * Apply a fresh section render to the LIVE drawer WITHOUT rebuilding it.
   *
   * ⛔ WHY THIS EXISTS (TA-41958 round 5, 28 Jul 2026) — this one line was the root cause of
   * three separate bugs Shrey and Priyanka kept re-reporting after every "fix". It used to be
   * `this.replaceChildren(...fresh.children)`: a total teardown of the drawer on EVERY
   * cart:refresh. Measured on the dev theme, a single gift-wrap tick destroyed and recreated
   * 24 <img> nodes — 12 in the drawer itself, plus 12 more as <product-recommendations> got
   * re-connected and re-fetched twice. That teardown produced all three symptoms at once:
   *   • thumbnails visibly FLASH (every image node is brand new, so every image re-decodes)
   *   • the drawer goes UNRESPONSIVE for a beat (every custom element destroyed and
   *     re-upgraded, every listener re-bound, full layout redone — on a mid-range Android
   *     that is exactly the "cart is dead for a second or two" report)
   *   • the sheet's glass cannot composite while the main thread is doing all of that
   * It also threw away scroll position and any in-flight interaction.
   *
   * Now: reconcile the line list in place (the same proven path _onCartChanged uses) and swap
   * only the two text-only slots. Nothing holding an <img> is ever replaced, so no thumbnail
   * can flash. A real rebuild happens ONLY when the drawer changes shape (empty <-> filled),
   * where there is no equivalent DOM to preserve anyway.
   *
   * This is deliberately defensive rather than clever: `cart:refresh` is a public event that
   * the theme, our own code and third-party apps all dispatch, so the SAFE behaviour has to
   * live here at the receiving end — not in each caller remembering to use a softer path.
   */
  _patchDrawerFrom(freshRoot) {
    const curList = this.querySelector(".cart-drawer__line-items");
    const newList = freshRoot.querySelector(".cart-drawer__line-items");

    // Shape change (empty <-> filled): rebuilding is the honest move here — there is no
    // matching DOM on the other side to preserve.
    if (!curList || !newList) {
      this.replaceChildren(...freshRoot.children);
      return;
    }

    this._reconcileLineItems(curList, newList);

    // The two money regions. Everything else in the drawer — header, the gift-wrap zone with
    // its product image, the quick-add/upsell row, <product-recommendations> — is left ALONE:
    // mes-cart-v3.js keeps those live (syncCountLabel / syncWrapZone), and re-rendering them
    // is what caused the flash.
    ['[slot="prices"]', '[slot="footer"]'].forEach((sel) => {
      this._swapRegionPreservingImages(this.querySelector(sel), freshRoot.querySelector(sel));
    });
  }

  /**
   * Replace a region's contents from a fresh render WITHOUT re-creating any image that is
   * still the same image.
   *
   * Measured 28 Jul 2026: [slot="footer"] is NOT image-free — it carries the payment-method
   * strip and the checkout arrow. A first pass here simply skipped any region containing an
   * <img>, which was worse than the disease: the footer holds the order totals, so skipping
   * it would have left the total STALE after a refresh. Blunt guard, silent correctness bug.
   *
   * So instead of choosing between "always rebuild" (flash) and "never rebuild" (stale), the
   * live <img> nodes are MOVED into the incoming tree when their src is unchanged. A moved
   * node keeps its decoded bitmap, so an unchanged image never re-decodes and never flickers,
   * while genuinely new or changed images are created normally. Region markup that is
   * identical is not touched at all.
   */
  _swapRegionPreservingImages(cur, next) {
    if (!cur || !next) return;
    if (cur.innerHTML === next.innerHTML) return; // nothing changed — touch nothing

    const reusable = new Map(); // src -> a live, already-decoded <img> we can carry across
    cur.querySelectorAll("img").forEach((img) => {
      const key = img.getAttribute("src") || "";
      if (key && !reusable.has(key)) reusable.set(key, img);
    });

    const incoming = document.importNode(next, true);
    incoming.querySelectorAll("img").forEach((img) => {
      const key = img.getAttribute("src") || "";
      const live = reusable.get(key);
      if (!live) return;
      reusable.delete(key);
      img.replaceWith(live); // same picture -> reuse the painted node instead of a fresh one
    });

    cur.replaceChildren(...incoming.childNodes);
  }
};
var CartNotificationDrawer = class extends Drawer {
  constructor() {
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("variant:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
  async hide() {
    super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    if (window.themeVariables.settings.cartType !== "popover" || event.detail?.blockCartDrawerOpening) {
      return;
    }
    const tempContent = document.createElement("div");
    tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    this.replaceChildren(...tempContent.querySelector(".shopify-section").children);
    this.show();
  }
};
var LineItem = class extends HTMLElement {
  connectedCallback() {
    this.pillLoaderElement = this.querySelector("pill-loader");
    this.addEventListener("line-item:will-change", this._onWillChange.bind(this));
    this.addEventListener("line-item:change", this._onChanged.bind(this));
  }
  _onWillChange() {
    this.pillLoaderElement.setAttribute("aria-busy", "true");
  }
  async _onChanged(event) {
    this.pillLoaderElement.removeAttribute("aria-busy");
    if (event.detail.cart["item_count"] === 0 || event.detail.quantity !== 0) {
      return;
    }
    let marginCompensation = 0;
    if (this.nextElementSibling) {
      marginCompensation = `-${getComputedStyle(this.nextElementSibling).paddingTop}`;
    }
    await animate4(this, { height: [`${this.clientHeight}px`, 0], marginBottom: [0, marginCompensation], overflow: "hidden", opacity: [1, 0] }, { duration: 0.2, easing: "ease" }).finished;
    this.remove();
  }
};
if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}
if (!window.customElements.get("cart-notification-drawer")) {
  window.customElements.define("cart-notification-drawer", CartNotificationDrawer);
}
if (!window.customElements.get("line-item")) {
  window.customElements.define("line-item", LineItem);
}

// js/common/cart/cart-footer-icons.js
var CartFooterIcons = class extends HTMLElement {
  constructor() {
    super();
    this._toggleGiftCardListener = this._toggleGiftCard.bind(this);
    this._onClickBreakdownTextListener = this._onClickBreakdownText.bind(this);
  }

  connectedCallback() {
    this.notes = document.querySelectorAll('textarea[name="note"]');
    this.giftCardUse = this.querySelector('[data-action="toggle-gift-card"]');
    if(this.giftCardUse){
      this.giftCardUse.addEventListener("click", this._toggleGiftCardListener);
      // Restore the persisted "International / gift card" choice. The footer re-renders to its
      // Gokwik default on every cart change / reopen, so without this the box could read "checked"
      // while the button reverted to Gokwik (Shrey, 20 Jul 2026). sessionStorage (not local) so an
      // accidental tick doesn't stick across browser sessions. Deferred so the sibling checkout
      // buttons are already in the DOM when we flip their visibility.
      let intlPref = null;
      try { intlPref = sessionStorage.getItem("mesIntlCheckout"); } catch (e) {}
      if (intlPref === "1") {
        this.giftCardUse.checked = true;
        setTimeout(() => this._applyCheckoutMode(true), 0);
      }
    }

    this._setupGiftNoteButtons();
    this.viewBreakdownText = document.getElementById('cart_breakdown_text');
    this.viewBreakdownText.addEventListener('click', this._onClickBreakdownTextListener)
    this._onNotesInitialized();

  }

  disconnectedCallback() {
    if(this.giftCardUse){
      this.giftCardUse.removeEventListener("click", this._toggleGiftCardListener);
    }
  }

  /**
   * CUSTOM : Scrolls to section when view breakdown text is clicked.
   */
  _onClickBreakdownText(event) {
    utils.scrollToSection('.Cart__prices-inline')
    //Highlight price container inside cart drawer when breakdown link is clicked
    const pricesContainer = document.querySelector('.Cart__prices-container');
    if (pricesContainer) {
      pricesContainer.classList.add('highlight');
      setTimeout(() => {
        pricesContainer.classList.remove('highlight');
      }, 1000);
    }
  }

  _toggleGiftCard(event) {
    const isChecked = event.target.checked;
    this._applyCheckoutMode(isChecked);
    // Remember the choice so reopening the cart keeps the box + button in sync (see connectedCallback).
    try { sessionStorage.setItem("mesIntlCheckout", isChecked ? "1" : "0"); } catch (e) {}
  }

  /**
   * Show the Gokwik button (India) or the native Shopify button (international / gift card).
   * Only swaps when BOTH buttons are rendered (the default cart config); a gokwik-only or
   * shopify-only config renders one button and this is a safe no-op.
   */
  _applyCheckoutMode(isInternational) {
    const gokwikCheckout = document.getElementById("gokwikCheckout");
    const nativeCheckout = document.getElementById("nativeCheckout");
    if (!nativeCheckout) return;
    if (isInternational && gokwikCheckout) {
      gokwikCheckout.classList.add("hide");
      nativeCheckout.classList.remove("hide");
    } else {
      if (gokwikCheckout) gokwikCheckout.classList.remove("hide");
      nativeCheckout.classList.add("hide");
    }
  }

   _setupGiftNoteButtons() {
    let buttons = this.querySelectorAll('.cart-gift-note-types .button');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        this._addSelectedNoteText(button.dataset.notes);
      });
    });
  }

  _addSelectedNoteText(notes) {
    if (this.notes) {
      this.notes.forEach(textarea => {
        if (textarea.id.includes("gift")) {
          textarea.value = "";
          textarea.value += (textarea.value ? '\n' : '') + notes;
          textarea.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })
    }
  }

  _onNotesInitialized() {
    const textareas = this.notes;
    let orderNotesTextarea = null;
    let giftNotesTextarea = null;
  
    textareas.forEach(textarea => {
      if (textarea.id.includes("gift")) {
        giftNotesTextarea = textarea;
      } else {
        orderNotesTextarea = textarea;
      }
    });
  
    if (!orderNotesTextarea || !giftNotesTextarea) {
      console.error('Notes textareas are not properly initialized.');
      return;
    }
  
    const notes = orderNotesTextarea.value.split("\n");
    let orderNotes = [];
    let giftNotes = [];
    
    notes.forEach(note => {
      let trimmedNote;
      if (note.includes("Request:")) {
        trimmedNote = note.split("Request:")[1]?.trim();
        if (trimmedNote) {
          orderNotes.push(trimmedNote);
        }
      } else if (note.includes("Gift note:")) {
        trimmedNote = note.split("Gift note:")[1]?.trim();
        if (trimmedNote) {
          giftNotes.push(trimmedNote);
        }
      }
    });
  
    orderNotesTextarea.value = orderNotes.join("\n");
    giftNotesTextarea.value = giftNotes.join("\n");
  }

};

if (!window.customElements.get("cart-footer-icons")) {
  window.customElements.define("cart-footer-icons", CartFooterIcons);
}

// js/common/cart/cart-note.js
var CartNote = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    if (event.target.getAttribute("name") !== "note") {
      return;
    }
    let notes = [];
    document.querySelectorAll('textarea[name="note"]').forEach(textarea => {
      if (textarea.value.trim() !== "") {
        if (textarea.id.includes("gift") && !textarea.value.includes("Gift")) {
          notes.push("Gift note: " + textarea.value.trim());
        } else if (textarea.id.includes("order") && !textarea.value.includes("Request")) {
          notes.push("Request: " + textarea.value.trim());
        } else {
          notes.push(textarea.value.trim());
        }
      }
    });

    let concatenatedNotes = notes.join("\n");
    let concatenatedNotesUpdated = concatenatedNotes.length > 0 ? concatenatedNotes : "";
    fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: concatenatedNotesUpdated }),
        keepalive: true
        // Allows to make sure the request is fired even when submitting the form
      });
  }
};

var CartNoteDialog = class extends DialogElement {
  constructor() {
    super();
    this.addEventListener("change", this._onNoteChanged);
  }
  _onNoteChanged(event) {
    const linkText = event.target.value === "" ? window.themeVariables.strings.addOrderNote : window.themeVariables.strings.editOrderNote;
    this.controls.forEach((control) => {
      const linkElement = control.querySelector('.link');
      if (linkElement) {
        linkElement.innerHTML = `<span class="link text-sm text-subdued">${linkText}</span>`;
      }
    });
  }
};
if (!window.customElements.get("cart-note")) {
  window.customElements.define("cart-note", CartNote);
}
if (!window.customElements.get("cart-note-dialog")) {
  window.customElements.define("cart-note-dialog", CartNoteDialog);
}

// CUSTOM: js/common/cart/cart-count-widget.js
var CartCountWidget = class extends DialogElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this._abortController = new AbortController();
    document.addEventListener("cart:change", (event) => {
      /* wrap excluded — see mesVisibleCartCount (Shrey 1A, 5 Aug 2026). The published total is
         updated here too, so a badge parsed later and the drawer's own label cannot disagree. */
      window.MES_VISIBLE_COUNT = mesVisibleCartCount(event.detail["cart"]);
      this.itemCount = window.MES_VISIBLE_COUNT;
      /* Sweep EVERY badge, not just this instance. Measured 5 Aug on RC4: the legacy header's
         cart-count sat at a stale "1" while the pill header and the widget both read 5 — three
         surfaces, two answers, which is the shape of the bug Priyanka reported. The sweep is a
         textContent write, so it dispatches nothing and cannot loop. */
      if (window.__mesSyncCartBadges) window.__mesSyncCartBadges();
    }, { signal: this._abortController.signal });
    document.addEventListener("cart:refresh", this._updateFromServer.bind(this), { signal: this._abortController.signal });
    window.addEventListener("pageshow", this._updateFromServer.bind(this));
  }

  disconnectedCallback() {
    this._abortController.abort();
  }
  async _updateFromServer() {
    /* wrap excluded here too — this widget is the second badge surface (Shrey 1A, 5 Aug 2026) */
    window.MES_VISIBLE_COUNT = mesVisibleCartCount(await fetchCart);
    this.itemCount = window.MES_VISIBLE_COUNT;
    if (window.__mesSyncCartBadges) window.__mesSyncCartBadges();
  }
  get itemCount() {
    return parseInt(this.innerText);
  }
  
  set itemCount(count) {
    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      this.firstElementChild.innerText = count;
    } else if (this.itemCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      this.firstElementChild.innerText = count;
    } else {
      (async () => {
        await animate3(this.firstElementChild, { transform: ["translateY(-50%)"], opacity: 0 }, { duration: 0.25, easing: [1, 0, 0, 1] }).finished;
        this.firstElementChild.innerText = count;
        animate3(this.firstElementChild, { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 }, { duration: 0.25, easing: [1, 0, 0, 1] });
      })();
    }
  }
};

if (!window.customElements.get("cart-count-widget")) {
  window.customElements.define("cart-count-widget", CartCountWidget);
}

// CUSTOM: js/common/cart/sticky-buy-button.js
var StickyBuyButton = class extends HTMLElement {
  constructor() {
    super();
    this._action = this.dataset.action || "scroll";
    this._scrollSectionName = this.dataset.scrollSection || "";
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this._onClick);
    // Defer trigger wiring until the DOM is parsed, so children + the scroll-target
    // section reliably exist regardless of section order on the page.
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this._init.bind(this), { once: true });
    } else {
      this._init();
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    if (this._io) this._io.disconnect();
  }

  _init() {
    this._sticky = this.querySelector("[data-sticky-buy-button]");
    if (!this._sticky) return;
    // The sticky bar hides (slides out) while any "trigger" is on screen: the in-flow
    // scrollable button (if shown) and/or the scroll-to target section (scroll action).
    const triggers = [];
    const scrollable = this.querySelector("[data-scrollable-buy-button]");
    if (scrollable) triggers.push(scrollable);
    const target = this._scrollTarget();
    if (this._action === "scroll" && target) triggers.push(target);
    if (!triggers.length) return; // nothing to hide against -> bar stays visible
    this._visible = new Set();
    this._io = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting ? this._visible.add(e.target) : this._visible.delete(e.target));
      this._sticky.classList.toggle("is-hidden", this._visible.size > 0);
    }, { threshold: 0 });
    triggers.forEach((el) => this._io.observe(el));
  }

  _scrollTarget() {
    if (!this._scrollSectionName) return null;
    return document.querySelector(".shopify-section--" + this._slug(this._scrollSectionName));
  }

  _onClick(event) {
    // Link action is a real <a href> -- let the browser navigate natively.
    if (this._action !== "scroll") return;
    const trigger = event.target.closest("button, .button, a");
    if (!trigger || !this.contains(trigger)) return;
    event.preventDefault();
    const target = this._scrollTarget();
    if (target) this._smartScrollTo(target);
  }

  _slug(name) {
    return String(name).toLocaleLowerCase().trim().replace(/\s+/g, "-");
  }

  // Long-distance scroll without the jarring fly-past: instant-jump to about one
  // screen above the target, then smooth-scroll the final stretch into place.
  _smartScrollTo(target) {
    const absoluteTop = Math.max(0, window.pageYOffset + target.getBoundingClientRect().top);
    // "reveal" = the short final stretch the visitor actually sees scroll; everything
    // before it is skipped instantly. Keeps the skip aggressive but lands softly.
    const reveal = window.innerHeight * 0.6;
    if (absoluteTop - window.pageYOffset > reveal + 50) {
      window.scrollTo(0, absoluteTop - reveal);
      requestAnimationFrame(() => {
        window.scrollTo({ top: absoluteTop, behavior: "smooth" });
      });
    } else {
      window.scrollTo({ top: absoluteTop, behavior: "smooth" });
    }
  }
}

if (!window.customElements.get("sticky-buy-button")) {
  window.customElements.define("sticky-buy-button", StickyBuyButton);
}


// js/common/cart/free-shipping-bar.js
var FreeShippingBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["total-price", "discount-threshold", "threshold", "free-gift-threshold"];
  }
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
    this._onClickQuickBuyTextListener = this._onQuickBuyTextClicked.bind(this);
    this.freeGiftInFlight = false;
  }
  async connectedCallback() {
    this.threshold = Math.round(this.threshold * (Shopify.currency.rate || 1));
    document.addEventListener("cart:change", this._onCartChangedListener);
    this.quickBuyItemText = document.getElementById('view-quick-buy-text');
    this.quickBuyItemText.addEventListener('click', this._onClickQuickBuyTextListener)
  }

  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  
  get enableCartDiscount() {
   if(this.getAttribute("show-cart-discount") === "true") {
     return true
   }
   else {
     return false
   }
  }
  
  get discountThreshold(){
    return parseFloat(this.getAttribute("discount-threshold"));
  }
  set discountPercent(value) {
    this.setAttribute("discount-threshold", value);
  }
  
  get discountPercent(){
    return parseFloat(this.getAttribute("discount-percent"));
  }
  set discountPercent(value) {
    this.setAttribute("discount-percent", value);
  }

  get freeGiftThreshold(){
    return parseFloat(this.getAttribute("free-gift-threshold"));
  }
  set freeGiftThreshold(value) {
    this.setAttribute("free-gift-threshold", value);
  }
  
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }

 get enableCartFreeGift() {
   if(this.getAttribute("show-cart-free-gift") === "true") {
     return true
   }
   else {
     return false
   }
  }

  get freeGiftHandle() {
    return this.getAttribute("free-gift-handle");
  }

  /* ⛔ H305 — when TRUE the free gift is delivered by an AUTOMATIC BxGy DISCOUNT at the store,
     not by this theme adding a Rs0 product to the cart. Shrey ruled stacking allowed (A324), so
     the gift and the 15% Exclusive Sale both apply.
     WHY THE SWITCH EXISTS AT ALL: the theme's Rs0-product mechanism cannot be made safe. Its
     one-gift guard is CLIENT-SIDE on a real published product, so a shopper just raises the
     quantity - order #M666922 took three - and there is no server-side cap available off Shopify
     Plus (verified shopifyPlus:false). The discount enforces it where the theme structurally
     cannot.
     ⛔ DEFAULT FALSE, deliberately: shipping this code changes NOTHING until the toggle is
     flipped, so the release and the store change do not have to land in the same instant. Flip it
     the moment the automatic discount goes live - not before (no gift at all) and not after
     (customer gets both the Rs0 product AND the discounted one). */
  get giftViaDiscount() {
    return this.getAttribute("gift-via-discount") === "true";
  }

  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "free-gift-threshold":
      if(this.enableCartFreeGift) {
        progressBarElement.valueMax = newValue;
      }
      break;
        
      case "discount-threshold":
        if(this.enableCartDiscount) {
          progressBarElement.valueMax = newValue;
        }
        break;
        
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    this._updateMessage();
  }

    _showQuickBuyText() {
      if (this.quickBuyItemText) {
        this.quickBuyItemText.classList.toggle("show", true);
        this.quickBuyItemText.classList.toggle("hide", false);
      }
    }
    
    _hideQuickBuyText() {
      if (this.quickBuyItemText) {
        this.quickBuyItemText.classList.toggle("show", false);
        this.quickBuyItemText.classList.toggle("hide", true);
      }
    }
  
   async _addFreeGiftToCart(freeGiftHandle) {
    /* ⛔ Guarded HERE rather than at the call sites: there are eight of them across the cart and
       drawer paths, and a guard repeated eight times is one someone eventually misses. When the
       discount owns the gift we also actively STRIP any Rs0 gift left in a cart from before the
       switch - otherwise that shopper keeps the old product AND gets the discounted one. */
    if (this.giftViaDiscount) {
      this._removeFreeGiftFromCart(freeGiftHandle);
      return;
    }
    if (this.freeGiftInFlight) return;
    this.freeGiftInFlight = true;
    let didAdd = false;
    try {
      const cart = await api.fetchCartData();
      if (!cart?.items) return;
      const { isPresent, variantId: giftVariantId } = utils.isProductPresentInCart(cart.items, freeGiftHandle);
      if (isPresent) {
        /* V9.28.105 (H366): ONE gift. Orders #M680785 (3), #M682658 (2) and #M682686 (4) carried more; our drawer offers
           no stepper on the gift line, so the quantity is raised elsewhere (DERIVED: Gokwik's checkout). Whenever such a
           cart comes back through our render, set it back to 1. It cannot stop edits made inside checkout; the
           automatic BxGy (H366 step 3) closes those at checkout itself. */
        const giftQty = cart.items.filter((it) => it.handle && it.handle.toLowerCase() === freeGiftHandle.toLowerCase())
          .reduce((n, it) => n + (it.quantity || 0), 0);
        if (giftQty > 1 && giftVariantId) {
          await api.cartUpdate(giftVariantId, 1);
          didAdd = true;
        }
        return;
      }

      const product = await api.fetchProductByName(freeGiftHandle);
      const variantId = product?.variants?.[0]?.id;
      if (!variantId) return;

      await api.cartAdd(variantId, 1);
      didAdd = true;

    } catch (e) {
      console.error("Free gift failed:", e);
    } finally {
      this.freeGiftInFlight = false;

      if (didAdd) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
      }
    }
  }



  async _removeFreeGiftFromCart(freeGiftHandle) {
    if (this.freeGiftInFlight) return;
    this.freeGiftInFlight = true;

    const checkoutButton = document.getElementById('gokwikCheckout');
    const checkoutButton2 = document.getElementById('nativeCheckout');

    if (checkoutButton) checkoutButton.disabled = true;
    if (checkoutButton2) checkoutButton2.disabled = true;

    let didRemove = false;

    try {
      const cart = await api.fetchCartData();
      if (!cart?.items) return;

      const { isPresent, variantId } = utils.isProductPresentInCart(cart.items, freeGiftHandle);
      if (!isPresent || !variantId) return;

      await api.cartRemove(variantId);
      didRemove = true;

    } catch (e) {
      console.error("Free gift remove failed:", e);
    } finally {
      this.freeGiftInFlight = false;

      if (checkoutButton) checkoutButton.disabled = false;
      if (checkoutButton2) checkoutButton2.disabled = false;

      if (didRemove) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      }
    }
  }


  
  _updateMessage() {
    const messageElement = this.querySelector("span");
    // Check if the total price exceeds the shipping threshold
    if (this.totalPrice >= this.threshold) {
        // Condition 1: When the cart price is > shipping threshold and > discount threshold >= free gift threshold and when discount threshold is enabled
        if (this.totalPrice >= this.threshold && 
            this.totalPrice > this.discountThreshold && 
            this.totalPrice >= this.freeGiftThreshold &&
            this.enableCartDiscount &&
            this.enableCartFreeGift) {
            // Add free gift to cart
            this._addFreeGiftToCart(this.freeGiftHandle);
            // Update message to indicate free gift reached
            messageElement.innerHTML = this.getAttribute("free-gift-reached-message");
            // Hide quick buy text
            this._hideQuickBuyText();
        }

        // Condition 2: When the cart price is greater than shipping threshold and discount threshold and less than free gift threshold
        else if (this.totalPrice >= this.threshold && 
                   this.totalPrice > this.discountThreshold && 
                   this.totalPrice < this.freeGiftThreshold && 
                   this.enableCartDiscount && 
                   this.enableCartFreeGift) {
            // Remove free gift from cart
            this._removeFreeGiftFromCart(this.freeGiftHandle);
            // Show quick buy text
            this._showQuickBuyText();
            // Update message to indicate discount reached and remaining amount for free gift
            const replacement1 = `<span class="bold text-accent">${formatMoney((this.totalPrice * this.discountPercent)/100).replace(/\$/g, "$$$$")}</span>`;
            const replacement2 = `<span class="bold text-accent">${formatMoney(this.freeGiftThreshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
            messageElement.innerHTML = this.getAttribute("discount-reached-message").replace(new RegExp("({.*})", "g"), replacement1);
            messageElement.innerHTML += " ";
            messageElement.innerHTML += this.getAttribute("free-gift-unreached-message").replace(new RegExp("({.*})", "g"), replacement2);
        }

        // Condition 3: When the cart price is greater than shipping threshold and >= free gift threshold and when discount is not enabled
        else if (this.totalPrice >= this.threshold && 
                   this.totalPrice >= this.freeGiftThreshold &&
                   !this.enableCartDiscount && 
                   this.enableCartFreeGift) {
            // Add free gift to cart
            this._addFreeGiftToCart(this.freeGiftHandle);
            // Hide quick buy text
            this._hideQuickBuyText();
            // Update message to indicate free gift reached
            messageElement.innerHTML = this.getAttribute("free-gift-reached-message");
        }

        // Condition 4: When the cart price is greater than shipping threshold and less than free gift threshold and discount is not enabled
        else if (this.totalPrice >= this.threshold && 
                   this.totalPrice < this.freeGiftThreshold && 
                   !this.enableCartDiscount && 
                   this.enableCartFreeGift) {
            // Calculate remaining amount for free gift
            
            const replacement = `<span class="bold text-accent">${formatMoney(this.freeGiftThreshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
            // Update message to indicate remaining amount for free gift
            messageElement.innerHTML = this.getAttribute("free-gift-unreached-message").replace(new RegExp("({.*})", "g"), replacement);
            // Remove free gift from cart
            this._removeFreeGiftFromCart(this.freeGiftHandle);
            // Show quick buy text
            this._showQuickBuyText();
        }

        // Condition 5: When the cart price is greater than shipping threshold and discount threshold
        else if (this.totalPrice >= this.threshold && 
                   this.totalPrice > this.discountThreshold && 
                   this.enableCartDiscount && 
                   !this.enableCartFreeGift) {
            // Calculate discount amount
            const replacement = `<span class="bold text-accent">${formatMoney((this.totalPrice * this.discountPercent)/100).replace(/\$/g, "$$$$")}</span>`;
            // Update message to indicate discount reached
            messageElement.innerHTML = this.getAttribute("discount-reached-message").replace(new RegExp("({.*})", "g"), replacement);
        }

        // Condition 6: When the cart price is greater than shipping threshold but less than discount threshold  
        else if(this.totalPrice >= this.threshold && 
                   this.totalPrice <= this.discountThreshold && 
                   this.enableCartDiscount){
            // Calculate remaining amount for discount
            const replacement = `<span class="bold text-accent">${formatMoney(this.discountThreshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
            // Update message to indicate remaining amount for discount
            messageElement.innerHTML = this.getAttribute("discount-unreached-message").replace(new RegExp("({.*})", "g"), replacement);
            //If free gift is enabled then remove it from cart
            if(this.enableCartFreeGift) {
                this._removeFreeGiftFromCart(this.freeGiftHandle)
                this._showQuickBuyText()
            }
        }

         // Condition 7: When the cart price is less than shipping threshold and free gift is not enabled
        else if(this.totalPrice >= this.threshold && !this.enableCartDiscount && !this.enableCartFreeGift){
            // Update message to indicate shipping threshold reached
            messageElement.innerHTML = this.getAttribute("reached-message")
            //If free gift is enabled then remove it from cart
            if(this.enableCartFreeGift) {
                this._removeFreeGiftFromCart(this.freeGiftHandle)
                this._showQuickBuyText()
            }
        }
          
        // Condition 8: When the cart price is less than shipping threshold
        else if(this.totalPrice < this.threshold) {
            // Calculate remaining amount to qualify for free shipping
            const replacement = `<span class="bold text-accent">${formatMoney(this.threshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
            // Update message to indicate remaining amount to qualify for free shipping
            messageElement.innerHTML = this.getAttribute("unreached-message").replace(new RegExp("({.*})", "g"), replacement);
            //If free gift is enabled then remove it from cart
            if(this.enableCartFreeGift) {
                this._removeFreeGiftFromCart(this.freeGiftHandle)
                this._showQuickBuyText()
            }
        }
    } else {
        // If total price is below shipping threshold, update message accordingly
        const replacement = `<span class="bold text-accent">${formatMoney(this.threshold - this.totalPrice).replace(/\$/g, "$$$$")}</span>`;
        // Update message to indicate remaining amount to qualify for shipping
        messageElement.innerHTML = this.getAttribute("unreached-message").replace(new RegExp("({.*})", "g"), replacement);
        //If free gift is enabled then remove it from cart
        if(this.enableCartFreeGift) {
            this._removeFreeGiftFromCart(this.freeGiftHandle)
            this._showQuickBuyText()
          }
        }
    }

  
  _onCartChanged(event) {
    // Calculate the total price for items that require shipping
    // V9.28.105 (H366): the gift's own line never counts toward the gift threshold (same rule as snippets/free-shipping-bar.liquid).
    const giftHandle = this.freeGiftHandle;
    const priceForItems = event.detail["cart"]["items"]
        .filter((item) => item["requires_shipping"] && typeof item["original_line_price"] === "number" && !(giftHandle && item["handle"] === giftHandle))
        .reduce((sum, item) => sum + (item["original_line_price"] - item["line_level_total_discount"]),0);

    // Calculate the total cart-level discount
    const cartDiscount = event.detail["cart"]["cart_level_discount_applications"]
        .filter(discountAllocation => typeof discountAllocation["total_allocated_amount"] === "number")
        .reduce((sum, discountAllocation) => sum + discountAllocation["total_allocated_amount"], 0);

    // Calculate the total price after subtracting the cart-level discount
    this.totalPrice = priceForItems;
  }

  
  _onQuickBuyTextClicked(event) {
    utils.scrollToSection('.cart-drawer__recommendations')
  }
};

if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}

// js/common/cart/line-item-quantity.js
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();

    // Added
    this._debounceTimer = null;
    this._isUpdating = false;
    this._pendingChange = null;
    this._changeSeq = 0;   // monotonic id per tap; guards against dropping/duplicating queued changes
    this._appliedSeq = 0;  // seq of the last change we actually sent to change.js

    this.addEventListener("click", this._onQuantityDecrease.bind(this));
    this.addEventListener("click", this._onQuantityIncrease.bind(this));
    this.addEventListener("change", this._onQuantityChanged.bind(this));
    this.addEventListener("click", this._onRemoveLinkClicked.bind(this));
  }

  _onQuantityDecrease(event) {
    if (event.target.tagName === "A" && event.target.className.includes("quantity-decrease")) {
      event.preventDefault();

      const lineKey = event.target.dataset.lineKey;
      const quantity = event.target.dataset.quantity;
      let giftWrapChangeObject = {
        bubbles: true,
        detail: {
          target: document.getElementById(this._getGiftWrapCheckboxId(lineKey)),
          action: 'decrease',
          quantity: Math.max(quantity, 0)
        }
      };

      this._changeLineItemQuantity(lineKey, Math.max(quantity, 0), giftWrapChangeObject);
    }
  }

  _onQuantityIncrease(event) {
    if (event.target.tagName === "A" && event.target.className.includes("quantity-increase")) {
      event.preventDefault();

      const lineKey = event.target.dataset.lineKey;
      let quantity = parseInt(event.target.dataset.quantity);
      const maxQuantity = parseInt(event.target.dataset?.max);
      //TODO: what if maxQuantity is not defined, that means user can keep increasing

      // Handle edge case: Do not trigger event to increase gift wrap if it exceeds the maximum quantity.

      // V9.28.168: already at the stock maximum, so the capped request below would change nothing (measured on live:
      // max 1, request for 1, the shopper saw nothing happen). Say why instead of sending it.
      if (!isNaN(maxQuantity) && quantity > maxQuantity) {
        if (this.closest("cart-drawer")) {
          document.documentElement.dispatchEvent(new CustomEvent("mes-cart:notice", { bubbles: true, detail: { text: `Only ${maxQuantity} in stock` } }));
        }
        return;
      }
      if (!isNaN(maxQuantity)) {
        quantity = Math.min(quantity, maxQuantity);
      }

      let giftWrapChangeObject = {};

      if(isNaN(maxQuantity) || parseInt(quantity) <=maxQuantity){
        giftWrapChangeObject = {
          bubbles: true,
          detail: {
            target: document.getElementById(this._getGiftWrapCheckboxId(lineKey)),
            action: 'increase'
          }
        }
      }

      this._changeLineItemQuantity(lineKey, quantity, giftWrapChangeObject);
    }
  }

  _onQuantityChanged(event) {
    if (!event.target.hasAttribute("data-line-key")) return;

    const lineKey = event.target.getAttribute("data-line-key");
    const quantity = parseInt(event.target.value);

    let giftWrapChangeObject = {
      bubbles: true,
      detail: {
        target: document.getElementById(this._getGiftWrapCheckboxId(lineKey)),
        action: 'change',
        quantity
      }
    };

    this._changeLineItemQuantity(lineKey, quantity, giftWrapChangeObject);
  }

  _onRemoveLinkClicked(event) {
    if (!(event.target.tagName === "A" && event.target.href.includes("/cart/change")) &&
        !(event.target instanceof SVGElement || event.target.closest('svg'))) {
      return;
    }

    event.preventDefault();

    const targetElement = event.target instanceof SVGElement || event.target.closest('svg')
      ? utils.findAnchorParent(event.target)
      : event.target;

    const url = new URL(targetElement.href);
    const lineKey = url.searchParams.get("id");

    // `quantity` here is HOW MANY WRAPS TO SUBTRACT, not the line's new quantity — the receiver
    // does `cartQty = giftWrapItemQty - targetQuantity` (_removeProductFromCart, action 'remove').
    // It used to pass 0, meaning "subtract nothing", so deleting a wrapped product left the wrap
    // count untouched: two products wrapped (Rs 78), remove one, still Rs 78 with a single product
    // in the cart (TA-41958, Priyanka 27 Jul 2026 — traced to this call on the dev base, and it
    // silently overwrote the cart-v3 re-level that had just corrected the same line).
    // The ✕ removes the WHOLE line, so the amount removed is that line's current quantity.
    const variantId = String(lineKey).split(':')[0];
    const qtyEl = document.getElementById(`line-item-qty-${variantId}`);
    const removedQty = Math.max(parseInt(qtyEl?.dataset?.initialQuantity, 10) || 1, 1);

    let giftWrapChangeObject = {
      bubbles: true,
      detail: {
        target: document.getElementById(this._getGiftWrapCheckboxId(lineKey)),
        action: 'remove',
        quantity: removedQty
      }
    };

    this._changeLineItemQuantity(lineKey, 0, giftWrapChangeObject);
  }

  _getGiftWrapCheckboxId(lineKey) {
    let variantId = lineKey.split(":")[0];
    return `gift-wrap-checkbox-${variantId}`;
  }

  /* ================= DEBOUNCED CORE ================= */

  async _changeLineItemQuantity(lineKey, targetQuantity, giftWrapChange) {const mesQtyInput = this.querySelector("input[data-line-key]");
    const mesMax = mesQtyInput ? parseInt(mesQtyInput.getAttribute("max"), 10) : NaN;
    if (mesMax > 0 && targetQuantity > mesMax) {
      mesQtyInput.value = mesMax;
      if (this.closest("cart-drawer")) {
        document.documentElement.dispatchEvent(new CustomEvent("mes-cart:notice", { bubbles: true, detail: { text: `Only ${mesMax} in stock` } }));
      }
      return;
    }
    // V9.28.165 (Shrey 1A, 7 Oct): the cart drawer shows "Updating your cart…" in its strip from the tap, not ~3 s
    // later when the new total lands (measured on dev: change.js ~1.2 s bare, ~2 s with the drawer render).
    this._mesAnnounceUpdating();
    // Save latest intent, stamped with a sequence id so a change made DURING an in-flight
    // request is never dropped, and an already-applied change is never re-sent.
    this._pendingChange = { lineKey, targetQuantity, giftWrapChange, seq: ++this._changeSeq };
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => this._flushLineItemChange(), 300); // debounce delay
  }

  _mesAnnounceUpdating() {
    if (window.themeVariables.settings.pageType === "cart" || !this.closest("cart-drawer")) return;
    document.documentElement.dispatchEvent(new CustomEvent("mes-cart:updating", { bubbles: true }));
  }

  async _flushLineItemChange() {
    // A request is already in flight. The old code did `if (this._isUpdating) return;` here,
    // which SILENTLY DROPPED the queued tap — so a +/- tapped while a slower change.js was
    // still resolving did nothing, and the shopper had to press 4-5 times before one happened
    // to land in a gap (Priyanka, 22 Jul). Instead re-arm and apply the LATEST intent the
    // moment the in-flight request settles (the `finally` below drains too — belt & braces).
    if (this._isUpdating) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this._flushLineItemChange(), 120);
      return;
    }
    // Nothing newer than what we last sent — don't fire a redundant request.
    if (!this._pendingChange || this._pendingChange.seq <= this._appliedSeq) return;

    this._isUpdating = true;
    let mesLanded = false;
    const { lineKey, targetQuantity, giftWrapChange, seq } = this._pendingChange;
    this._appliedSeq = seq;  // mark consumed BEFORE the await so a re-entrant flush can't dupe it

    {
      try {
        if (window.themeVariables.settings.pageType === "cart") {
          mesLanded = true;
          window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
          return;
        }
        // a queued tap starts its own request: keep the strip on "Updating…" through it
        this._mesAnnounceUpdating();

        const lineItem = this.closest("line-item");

        lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: { targetQuantity }
        }));

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        // HARDENED (TA-41958 round 4): parse only OK JSON. A challenged/failed change.js used
        // to throw out of the raw .json() below with no catch — the row stayed visually
        // changed with no write behind it. Now a bad response abandons this change cleanly
        // (finally still resets _isUpdating, the pending-change drain still runs).
        const changeRes = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lineKey,
            quantity: targetQuantity,
            sections: sectionsToBundle
          })
        });
        // Shopify serves change.js as text/javascript — HTML is the failure signature, not "not json".
        const changeType = (changeRes.headers.get("content-type") || "").toLowerCase();
        if (!changeRes.ok || changeType.indexOf("html") !== -1) {
          console.warn("[cart] change.js failed (HTTP " + changeRes.status + ") — change abandoned, cart state untouched");
          return;
        }
        const cartContent = await changeRes.json();
        mesLanded = true;

        // Match the changed line by its STABLE variant id, NOT the line key. Shopify re-hashes
        // line_item.key on every quantity change, so `i.key === lineKey` (the pre-change key) finds
        // nothing in the fresh cart and falsely reports quantity 0 — which makes LineItem._onChanged
        // play its "removed" collapse animation (height→0, opacity→0) on a normal +/−: the row
        // contracted to nothing, pulled the list up, then snapped back. `quantity` here is only used
        // by _onChanged as a 0/non-0 removed-flag, so first-match-by-variant is correct (a real
        // removal drops the variant from the cart → length 0 → quantity 0 → the animation still
        // plays as intended). (H61, Shrey 20 Jul 2026.)
        const changedVariantId = String(lineKey).split(":")[0];
        const lineItemAfterChange = cartContent.items.filter(i => String(i.variant_id) === changedVariantId);

        lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
          bubbles: true,
          detail: {
            quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
            cart: cartContent
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart: cartContent
          }
        }));

        if (giftWrapChange && Object.keys(giftWrapChange).length) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:gift-wrap-change", giftWrapChange)
          );
        }

      } finally {
        this._isUpdating = false;
        // V9.28.165: a change that never landed (HTTP error, challenge page, network) sends no cart:change, so end the
        // drawer's "Updating…" here rather than leave it to the 10 s safety.
        if (!mesLanded && this.closest("cart-drawer")) {
          document.documentElement.dispatchEvent(new CustomEvent("mes-cart:update-failed", { bubbles: true }));
        }
        // V9.28.215 (buying-journey audit, Shrey 14 Oct): the line's spinner is cleared only by line-item:change, which a
        // failed change never sends, so it spun until the next change on that line. Clear it here.
        if (!mesLanded) { this.closest("line-item")?.pillLoaderElement?.removeAttribute("aria-busy"); }
        // Taps that arrived while this request was in flight are still pending — apply the
        // latest one now instead of waiting for another user action.
        if (this._pendingChange && this._pendingChange.seq > this._appliedSeq) {
          clearTimeout(this._debounceTimer);
          this._debounceTimer = setTimeout(() => this._flushLineItemChange(), 0);
        }
      }
    }
  }
};

if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

// js/common/cart/shipping-estimator.js
var ShippingEstimator = class extends HTMLElement {
  constructor() {
    super();
    this._estimateShippingListener = this._estimateShipping.bind(this);
  }
  connectedCallback() {
    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;
    this.submitButton.addEventListener("click", this._estimateShippingListener);
  }
  disconnectedCallback() {
    this.submitButton.removeEventListener("click", this._estimateShippingListener);
  }
  /**
   * @doc https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
   */
  async _estimateShipping(event) {
    event.preventDefault();
    const zip = this.querySelector('[name="address[zip]"]').value, country = this.querySelector('[name="address[country]"]').value, province = this.querySelector('[name="address[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const prepareResponse = await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(zip, country, province);
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
    this.resultsElement.hidden = false;
    this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(zip, country, province) {
    const response = await fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
    const responseAsText = await response.text();
    if (responseAsText === "null") {
      return this._getAsyncShippingRates(zip, country, province);
    } else {
      return JSON.parse(responseAsText)["shipping_rates"];
    }
  }
  _formatShippingRates(shippingRates) {
    let formattedShippingRates = shippingRates.map((shippingRate) => {
      return `<li>${shippingRate["presentment_name"]}: ${shippingRate["currency"]} ${shippingRate["price"]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${shippingRates.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : shippingRates.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${formattedShippingRates === "" ? "" : `<ul class="list-disc" role="list">${formattedShippingRates}</ul>`}
      </div>
    `;
  }
  _formatError(errors) {
    let formattedShippingRates = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${formattedShippingRates}</ul>
      </div>
    `;
  }
};
if (!window.customElements.get("shipping-estimator")) {
  window.customElements.define("shipping-estimator", ShippingEstimator);
}

// js/common/facets/facet-apply-button.js
var FacetApplyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._closeDrawer);
    this.form.addEventListener("change", this._updateCount.bind(this));
    this.filterCountElement = document.createElement("span");
    this.appendChild(this.filterCountElement);
  }
  connectedCallback() {
    this._updateCount();
  }
  _updateCount() {
    const form = new FormData(this.form);
    this.filterCountElement.innerText = ` (${Array.from(form.values()).filter((item) => item !== "").length})`;
  }
  async _closeDrawer() {
    this.closest("facet-drawer").hide();
  }
};
if (!window.customElements.get("facet-apply-button")) {
  window.customElements.define("facet-apply-button", FacetApplyButton, { extends: "button" });
}

// js/common/facets/facet-dialog.js
var FacetDialog = class extends DialogElement {
  get initialFocus() {
    return false;
  }
};
if (!window.customElements.get("facet-dialog")) {
  window.customElements.define("facet-dialog", FacetDialog);
}

// js/common/facets/facet-drawer.js
var FacetDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener("dialog:after-hide", this._submitForm);
  }
  _submitForm() {
    this.querySelector("#facet-form").dispatchEvent(new Event("submit"));
  }
};
if (!window.customElements.get("facet-drawer")) {
  window.customElements.define("facet-drawer", FacetDrawer);
}

// js/common/facets/facet-floating-filter.js
import { animate as animate5 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var FacetFloatingFilter = class extends HTMLElement {
  connectedCallback() {
    new IntersectionObserver(this._onFooterVisibilityChanged.bind(this), { rootMargin: "50px 0px" }).observe(document.querySelector(".shopify-section--footer"));
  }
  _onFooterVisibilityChanged(entries) {
    if (entries[0].isIntersecting) {
      animate5(this, { opacity: 0, transform: [null, "translateY(15px)"], visibility: "hidden" }, { duration: 0.15 });
    } else {
      animate5(this, { opacity: 1, transform: [null, "translateY(0)"], visibility: "visible" }, { duration: 0.15 });
    }
  }
};
if (!window.customElements.get("facet-floating-filter")) {
  window.customElements.define("facet-floating-filter", FacetFloatingFilter);
}

// js/common/facets/facet-form.js
var abortController = null;
var openElements = /* @__PURE__ */ new Set();
var facetPendingUrl = null, facetUrlScheduled = false;
document.addEventListener("facet:update", async (event) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  shopifySection.classList.add("is-loading");
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");facetPendingUrl = clonedUrl.toString();
  if (!facetUrlScheduled) {
    facetUrlScheduled = true;
    const flushFacetUrl = () => {
      if (!facetUrlScheduled) return;
      facetUrlScheduled = false;
      try { history.replaceState({}, "", facetPendingUrl); } catch (e) {}
    };
    requestAnimationFrame(() => setTimeout(flushFacetUrl, 0));
    setTimeout(flushFacetUrl, 120);
  }
  try {
    const tempContent = new DOMParser().parseFromString(await (await cachedFetch(url.toString(), { signal: abortController.signal })).text(), "text/html");
    Array.from(tempContent.querySelectorAll("details, facet-dialog")).forEach((item) => {
      if (openElements.has(item.id)) {
        item.setAttribute("open", "");
      }
    });
    shopifySection.replaceChildren(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
    shopifySection.classList.remove("is-loading");
    // V9.20.8 — this scroll-to-top was DEAD on every V3 collection, silently.
    // Impact's markup (.collection__results product-list) doesn't exist in the V3 grid
    // (mes-healing-collection renders .mhc-grid), so querySelector returned null,
    // .getBoundingClientRect() threw a TypeError, and the empty `catch {}` below swallowed
    // it — so paging to page 2 left the shopper stranded mid-list. Fall back to the V3 grid,
    // then to the section itself, and null-guard rather than trusting any one selector.
    const scrollToElement = (window.matchMedia("(min-width: 700px) and (max-width: 999px)").matches
      ? shopifySection.querySelector(".collection__results")
      : shopifySection.querySelector(".collection__results product-list"))
      || shopifySection.querySelector(".mhc-grid-wrap, .mhc-grid")
      || shopifySection;
    if (scrollToElement) {
      // scrollPaddingTop computes to "auto" when unset (the V3 grid), and parseInt("auto")
      // is NaN — `top < NaN` is ALWAYS false, so this guard silently blocked every scroll.
      // The original `|| 0` sat INSIDE parseInt, so it only caught an empty string, not the
      // NaN. Coerce AFTER parsing. (Measured: grid top -9044, padTop NaN -> no scroll.)
      const scrollPadTop = parseInt(getComputedStyle(scrollToElement).scrollPaddingTop) || 0;
      const distance = Math.abs(scrollToElement.getBoundingClientRect().top);
      if (scrollToElement.getBoundingClientRect().top < scrollPadTop) {
        // Distance decides the behaviour. A filter tweak near the top is a short, pleasant
        // glide; paging from the BOTTOM of a 50-card list is ~9000px, and a smooth scroll
        // that far is both awful UX (9 screens of content flying past) and unreliable —
        // measured: smooth over 9044px never moved at all, instant landed correctly. So a
        // long jump is an instant RESET, which is what pagination should feel like anyway.
        // Also honour OS reduced-motion, which the original ignored.
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        scrollToElement.scrollIntoView({
          block: "start",
          behavior: (reduce || distance > window.innerHeight * 2) ? "auto" : "smooth"
        });
      }
    }
  } catch (e) {
  }
});
var FacetForm = class extends HTMLFormElement {
  constructor() {
    super();
    this._isDirty = false;
    this.addEventListener("change", this._onFormChanged);
    this.addEventListener("submit", this._onFormSubmitted);
  }
  connectedCallback() {
    Array.from(this.querySelectorAll("details, facet-dialog")).forEach((disclosureElement) => {
      if (disclosureElement.open) {
        openElements.add(disclosureElement.id);
      }
      disclosureElement.addEventListener("toggle", () => {
        if (disclosureElement.open) {
          openElements.add(disclosureElement.id);
        } else {
          openElements.delete(disclosureElement.id);
        }
      });
    });
  }
  _buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this)), url = new URL(this.action);
    url.search = "";
    searchParams.forEach((value, key) => url.searchParams.append(key, value));
    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
      if (url.searchParams.get(optionToClear) === "") {
        url.searchParams.delete(optionToClear);
      }
    });
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    return url;
  }
  _onFormChanged() {
    this._isDirty = true;
    if (this.hasAttribute("update-on-change")) {
      this.dispatchEvent(new Event("submit", { cancelable: true }));
    } else {
      cachedFetch(this._buildUrl().toString());
    }
  }
  _onFormSubmitted(event) {
    event.preventDefault();
    if (!this._isDirty) {
      return;
    }
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url: this._buildUrl()
      }
    }));
    this._isDirty = false;
  }
};
if (!window.customElements.get("facet-form")) {
  window.customElements.define("facet-form", FacetForm, { extends: "form" });
}

// js/common/facets/facet-link.js
var FacetLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this._onFacetUpdate);
  }
  _onFacetUpdate(event) {
    event.preventDefault();
    const sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", ""), url = new URL(this.href);
    url.searchParams.set("section_id", sectionId);
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facet-link")) {
  window.customElements.define("facet-link", FacetLink, { extends: "a" });
}

// js/common/custom-sort-by.js
var CustomSortBy = class extends HTMLElement {
    /**
     * ⛔ THE LISTENER MUST NOT GO IN THE CONSTRUCTOR (measured 30 Jul 2026, RC4).
     *
     * It used to be `constructor() { this.querySelector('.custom-sort-button').addEventListener(...) }`,
     * which produced TWO OPPOSITE defects on the same element:
     *
     *  1. THE BINDING IS SIMPLY IN THE WRONG PLACE. A constructor runs at UPGRADE time, which for
     *     swapped-in markup can precede the children being reachable, so
     *     `this.querySelector('.custom-sort-button')` can return null and nothing is ever bound —
     *     sorting then silently does nothing. Binding on connect, delegated from the host, cannot
     *     miss its children.
     *  2. It could also bind TWICE on one node (upgrade, move, re-adopt), giving one tap two
     *     dispatches. The `__mesSortBound` latch makes a second connect a no-op.
     *
     * ⚠ WHAT THIS DOES **NOT** FIX, stated so nobody re-derives it: I wrote this while chasing a
     * duplicate section fetch on RC4 that turned out to be my own artefact — two theme.js versions
     * coexisting in one JS context after mid-session pushes, each with its own `facet:update`
     * listener. The "button dead after a swap" reading came from that same muddled session and is
     * NOT independently confirmed. Priyanka's chip flicker is STILL UNDIAGNOSED (30 Jul 2026).
     *
     * Delegating on the host element fixes both: the host survives child replacement, so one
     * binding covers every future button, and the `__mesSortBound` latch makes a second
     * connectedCallback (move, re-adopt, double upgrade) a no-op instead of a second listener.
     */
    connectedCallback() {
      if (this.__mesSortBound) return;
      this.__mesSortBound = true;
      this.addEventListener('click', (event) => {
        const btn = event.target && event.target.closest
          ? event.target.closest('.custom-sort-button')
          : null;
        if (!btn) return;
        /* _updateUrl reads BOTH event.target (for .shopify-section) and event.currentTarget
           (for .value); under delegation currentTarget would be the host, so hand it the
           button explicitly for both. */
        this._updateUrl({ target: btn, currentTarget: btn });
      });
    }

    _onSortByClick(event) {
        this._updateUrl(event);
    }

    _updateUrl(event) {
        const url = new URL(location.href);
        const sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", "");
        const currentValue = event.currentTarget.value;
        const sortByParam = url.searchParams.get("sort_by");

        if (sortByParam === currentValue) {
            url.searchParams.delete("sort_by");
        } else {
            url.searchParams.set("sort_by", currentValue);
        }
        url.searchParams.set("section_id", sectionId);
        url.searchParams.delete("page");
        this.dispatchEvent(new CustomEvent("facet:update", {
            bubbles: true,
            detail: {
                url
            }
        }));
      }
  };

if (!window.customElements.get("custom-sort-by")) {
    window.customElements.define("custom-sort-by", CustomSortBy);
}

// js/common/facets/facet-sort-by.js
var FacetSortBy = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("listbox:change", this._onValueChanged);
  }
  
  _onValueChanged(event) {
    const url = new URL(location.href), sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", "");
    url.searchParams.set("sort_by", event.detail.value);
    url.searchParams.set("section_id", sectionId);
    url.searchParams.delete("page");
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facet-sort-by")) {
  window.customElements.define("facet-sort-by", FacetSortBy);
}

// js/common/feedback/pill-loader.js
import { animate as animate6, timeline as timeline4, stagger as stagger4 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var PillLoader = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  connectedCallback() {
    this.innerHTML = `
      <div class="loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
        <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === "true") {
      timeline4([
        [this, { opacity: [0, 1], visibility: "visible", transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.15 }],
        [this.firstElementChild, { opacity: 1, transform: ["translateY(0)"] }, { duration: 0.15, at: "<" }],
        [this.lastElementChild, { opacity: 0 }, { duration: 0, at: "<" }]
      ]);
      animate6(this.firstElementChild.querySelectorAll("span"), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger4(0.35 / 3), direction: "alternate", repeat: Infinity });
    } else {
      timeline4([
        [this.firstElementChild, { opacity: 0, transform: ["translateY(0)", "translateY(-2px)"] }, { duration: 0.15 }],
        [this.lastElementChild, { opacity: 1, transform: ["translateY(2px)", "translateY(0)"] }, { duration: 0.15 }],
        [this, { opacity: 0, transform: ["translateY(0)", "translateY(-5px)"], visibility: "hidden" }, { duration: 0.15, at: "+0.4" }]
      ]);
    }
  }
};
if (!window.customElements.get("pill-loader")) {
  window.customElements.define("pill-loader", PillLoader);
}

// js/common/feedback/progress-bar.js
var ProgressBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    this.style.setProperty("--progress", `${Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"))}`);
  }
};
if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}

// js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.rangeLowerBound = this.querySelector('input[type="range"]:first-child');
    this.rangeHigherBound = this.querySelector('input[type="range"]:last-child');
    this.textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]');
    this.textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select(), { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select(), { signal: this._abortController.signal });
    this.textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      this.rangeLowerBound.value = event.target.value;
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
    }, { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      this.rangeHigherBound.value = event.target.value;
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputLowerBound.value = event.target.value;
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputHigherBound.value = event.target.value;
    }, { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// js/common/form/quantity-selector.js
var QuantitySelector = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.inputElement = this.querySelector("input");
    this.querySelector("button:first-of-type").addEventListener("click", () => this.inputElement.quantity = this.inputElement.quantity - 1, { signal: this._abortController.signal });
    this.querySelector("button:last-of-type").addEventListener("click", () => this.inputElement.quantity = this.inputElement.quantity + 1, { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
var QuantityInput = class extends HTMLInputElement {
  constructor() {
    super();
    var that = this;
    this.addEventListener("input", this._onValueInput);
    this.addEventListener("change", this._onValueChanged);
    this.addEventListener("keydown", this._onKeyDown);
    this.addEventListener("focus", this.select);
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(quantity) {
    const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
    if (quantity === "") {
      return;
    }
    if (!isNumeric || quantity < 0) {
      quantity = parseInt(quantity) || 1;
    }
    this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
    this.size = Math.max(this.value.length + 1, 2);
  }
  _onValueInput() {
    this.quantity = this.value;
  }
  _onValueChanged() {
    if (this.value === "") {
      this.quantity = 1;
    }
  }
  _onKeyDown(event) {
    event.stopPropagation();
    const originalQuantity = this.quantity;
    if (event.key === "ArrowUp") {
      this.quantity = this.quantity + 1;
    } else if (event.key === "ArrowDown") {
      this.quantity = this.quantity - 1;
    }
    if (originalQuantity !== this.quantity) {
      this._abortController = new AbortController();
      this.addEventListener("blur", () => this.dispatchEvent(new Event("change", { bubbles: true })), { once: true, signal: this._abortController.signal });
    }
  }
};

if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}



// js/common/form/resizable-textarea.js
var ResizableTextarea = class extends HTMLTextAreaElement {
  constructor() {
    super();
    this.addEventListener("input", this._onInput);
  }
  _onInput() {
    this.style.height = "auto";
    this.style.height = this.scrollHeight + 2 + "px";
  }
};
if (!window.customElements.get("resizable-textarea")) {
  window.customElements.define("resizable-textarea", ResizableTextarea, { extends: "textarea" });
}

// js/common/list/listbox.js
var _accessibilityInitialized, _hiddenInput, _onOptionClicked, onOptionClicked_fn, _onInputChanged, onInputChanged_fn, _onKeyDown, onKeyDown_fn;
var Listbox = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onOptionClicked);
    __privateAdd(this, _onInputChanged);
    __privateAdd(this, _onKeyDown);
    __privateAdd(this, _accessibilityInitialized, false);
    __privateAdd(this, _hiddenInput, void 0);
    this.addEventListener("keydown", __privateMethod(this, _onKeyDown, onKeyDown_fn));
  }
  static get observedAttributes() {
    return ["aria-activedescendant"];
  }
  connectedCallback() {
    if (!__privateGet(this, _accessibilityInitialized)) {
      this.setAttribute("role", "listbox");
      __privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]'));
      __privateGet(this, _hiddenInput)?.addEventListener("change", __privateMethod(this, _onInputChanged, onInputChanged_fn).bind(this));
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        option.addEventListener("click", __privateMethod(this, _onOptionClicked, onOptionClicked_fn).bind(this));
        option.id = "option-" + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
        if (option.getAttribute("aria-selected") === "true") {
          this.setAttribute("aria-activedescendant", option.id);
        }
      });
      __privateSet(this, _accessibilityInitialized, true);
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "aria-activedescendant" && oldValue !== null && newValue !== oldValue) {
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        if (option.id === newValue) {
          option.setAttribute("aria-selected", "true");
          if (__privateGet(this, _hiddenInput) && __privateGet(this, _hiddenInput).value !== option.value) {
            __privateGet(this, _hiddenInput).value = option.value;
            __privateGet(this, _hiddenInput).dispatchEvent(new Event("change", { bubbles: true }));
          }
          if (this.hasAttribute("aria-owns")) {
            this.getAttribute("aria-owns").split(" ").forEach((boundId) => {
              document.getElementById(boundId).textContent = option.getAttribute("title") || option.innerText || option.value;
            });
          }
          option.dispatchEvent(new CustomEvent("listbox:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }
};
_accessibilityInitialized = new WeakMap();
_hiddenInput = new WeakMap();
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  this.setAttribute("aria-activedescendant", event.currentTarget.id);
  event.currentTarget.dispatchEvent(new CustomEvent("listbox:select", {
    bubbles: true,
    detail: {
      value: event.currentTarget.value
    }
  }));
};
_onInputChanged = new WeakSet();
onInputChanged_fn = function(event) {
  this.setAttribute("aria-activedescendant", this.querySelector(`[role="option"][value="${CSS.escape(event.target.value)}"]`).id);
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
if (!window.customElements.get("x-listbox")) {
  window.customElements.define("x-listbox", Listbox);
}

// js/common/media/image.js
function imageLoaded(imageOrArray) {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(imageOrArray.map((image) => {
    return new Promise((resolve) => {
      if (image.tagName === "IMG" && image.complete || !image.offsetParent) {
        resolve();
      } else {
        image.onload = () => resolve();
      }
    });
  }));
}
function generateSrcset(imageObject, widths = []) {
  const imageUrl = new URL(imageObject["src"]);
  return widths.filter((width) => width <= imageObject["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}
function createMediaImg(media, widths = [], properties = {}) {
  const image = new Image(media["preview_image"]["width"], media["preview_image"]["height"]), featuredMediaUrl = new URL(media["preview_image"]["src"]);
  for (const propertyKey in properties) {
    image.setAttribute(propertyKey, properties[propertyKey]);
  }
  image.alt = media["alt"];
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media["preview_image"], widths);
  return image;
}

// js/common/product/gift-card-recipient.js
var _recipientCheckbox, _recipientOtherProperties, _recipientFieldsContainer, _synchronizeProperties, synchronizeProperties_fn;
var GiftCardRecipient = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _synchronizeProperties);
    __privateAdd(this, _recipientCheckbox, void 0);
    __privateAdd(this, _recipientOtherProperties, []);
    __privateAdd(this, _recipientFieldsContainer, void 0);
  }
  connectedCallback() {
    const properties = Array.from(this.querySelectorAll('[name*="properties"]')), checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";
    __privateSet(this, _recipientCheckbox, properties.find((input) => input.name === checkboxPropertyName));
    __privateSet(this, _recipientOtherProperties, properties.filter((input) => input.name !== checkboxPropertyName));
    __privateSet(this, _recipientFieldsContainer, this.querySelector(".gift-card-recipient__fields"));
    __privateGet(this, _recipientCheckbox)?.addEventListener("change", __privateMethod(this, _synchronizeProperties, synchronizeProperties_fn).bind(this));
    __privateMethod(this, _synchronizeProperties, synchronizeProperties_fn).call(this);
  }
};
_recipientCheckbox = new WeakMap();
_recipientOtherProperties = new WeakMap();
_recipientFieldsContainer = new WeakMap();
_synchronizeProperties = new WeakSet();
synchronizeProperties_fn = function() {
  __privateGet(this, _recipientOtherProperties).forEach((property) => property.disabled = !__privateGet(this, _recipientCheckbox).checked);
  __privateGet(this, _recipientFieldsContainer).classList.toggle("js:hidden", !__privateGet(this, _recipientCheckbox).checked);
};
if (!window.customElements.get("gift-card-recipient")) {
  window.customElements.define("gift-card-recipient", GiftCardRecipient);
}

// js/common/product/product-loader.js
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (this.loadedProducts[productHandle]) {
      return this.loadedProducts[productHandle];
    }
    this.loadedProducts[productHandle] = new Promise(async (resolve, reject) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return this.loadedProducts[productHandle];
  }
};
__publicField(ProductLoader, "loadedProducts", {});

// js/common/product/product-card.js
import { Delegate as Delegate3 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var ProductCard = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate3(this);
    const isSecondaryImgTap = this.dataset.secondaryImgTap === "true";
    this.addEventListener("pointerover", () => ProductLoader.load(this.getAttribute("handle")), { once: true });
    const primaryMediaElement = this.querySelector(".product-card__image--primary");
    if (primaryMediaElement && isSecondaryImgTap) {
      primaryMediaElement.addEventListener("touchstart", this._onPrimaryMediaTouchStart.bind(this));
      primaryMediaElement.addEventListener("touchend", this._onPrimaryMediaTouchEnd.bind(this));
      primaryMediaElement.addEventListener("click", this._onPrimaryMediaClick.bind(this));
    }
  }
  connectedCallback() {
    this._delegate.on("change", '[type="radio"]', this._onSwatchChanged.bind(this));
    this._delegate.on("pointerover", '[type="radio"] + label', this._onSwatchHovered.bind(this), true);
  }
  
  disconnectedCallback() {
    this._delegate.off();
  }

  _onPrimaryMediaTouchStart(event) {
    // Record touch starting position and time
    this._touchStartTime = Date.now();
    const touch = event.touches[0];
    this._touchStartX = touch.clientX;
    this._touchStartY = touch.clientY;

    // Delay the secondary-image reveal by 500ms. A quick tap-to-open lifts the
    // finger before this fires (timer cleared in touchend), so no image flash.
    // A deliberate press-and-hold still reveals the second image to "peek".
    const primaryMedia = event.currentTarget;
    const secondaryMedia = primaryMedia.nextElementSibling;
    if (!secondaryMedia) {
      console.error("Secondary media element is missing.");
      return;
    }
    this._secondaryRevealTimer = setTimeout(function () {
      primaryMedia.style.opacity = "0";
      secondaryMedia.style.opacity = "1";
      secondaryMedia.style.display = "block";
      primaryMedia.style.removeProperty('display');
    }, 250);
  }

  _onPrimaryMediaTouchEnd(event) {
    // Cancel any pending reveal so a quick tap never flashes the second image
    if (this._secondaryRevealTimer) {
      clearTimeout(this._secondaryRevealTimer);
      this._secondaryRevealTimer = null;
    }
    // Restore images as before
    const primaryMedia = event.currentTarget;
    const secondaryMedia = primaryMedia.nextElementSibling;
    if (!secondaryMedia) {
      console.error("Secondary media element is missing.");
      return;
    }
    primaryMedia.style.opacity = "1";
    primaryMedia.style.display = "block";
    secondaryMedia.style.opacity = "0";
    secondaryMedia.style.removeProperty('display');

    // Determine if this gesture qualifies as a light tap
    const elapsedTime = Date.now() - this._touchStartTime;
    const touch = event.changedTouches[0];
    const distanceX = Math.abs(touch.clientX - this._touchStartX);
    const distanceY = Math.abs(touch.clientY - this._touchStartY);
    const TAP_TIME_THRESHOLD = 300;    // maximum duration in ms (adjust as needed)
    const TAP_DISTANCE_THRESHOLD = 10; // maximum movement in px (adjust as needed)

    if (elapsedTime < TAP_TIME_THRESHOLD &&
        distanceX < TAP_DISTANCE_THRESHOLD &&
        distanceY < TAP_DISTANCE_THRESHOLD) {
      // Valid light tap detected. Trigger navigation if an <a> exists.
      const link = event.target.closest("a");
      if (link) {
        window.location.href = link.href;
      }
      // Set flag to prevent duplicate click handling.
      this._skipClick = true;
    }
  }

  _onPrimaryMediaClick(event) {
    // If navigation was already handled via the touch events, ignore this click.
    if (this._skipClick) {
      this._skipClick = false;
      return;
    }
    const link = event.target.closest("a");
    if (link) {
      window.location.href = link.href;
    }
  }
  
  async _onSwatchHovered(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target.control), primaryMediaElement = this.querySelector(".product-card__image--primary");
    if (firstMatchingVariant.hasOwnProperty("featured_media")) {
      this._createImageElement(firstMatchingVariant["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
    }
  }
  async _onSwatchChanged(event, target) {
    const firstMatchingVariant = await this._getMatchingVariant(target);
    this.querySelectorAll(`a[href^="${this.product["url"]}"`).forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set("variant", firstMatchingVariant["id"]);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
    if (!firstMatchingVariant.hasOwnProperty("featured_media")) {
      return;
    }
    const primaryMediaElement = this.querySelector(".product-card__image--primary"), secondaryMediaElement = this.querySelector(".product-card__image--secondary");
    const newPrimaryMediaElement = this._createImageElement(firstMatchingVariant["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
    if (primaryMediaElement.src !== newPrimaryMediaElement.src) {
      secondaryMediaElement ? secondaryMediaElement.replaceWith(this._createImageElement(this.product["media"][firstMatchingVariant["featured_media"]["position"]] || this.product["media"][1], secondaryMediaElement.className, secondaryMediaElement.sizes)) : null;
      await primaryMediaElement.animate({ opacity: [1, 0] }, { duration: 250, easing: "ease-in", fill: "forwards" }).finished;
      await new Promise((resolve) => newPrimaryMediaElement.complete ? resolve() : newPrimaryMediaElement.onload = () => resolve());
      primaryMediaElement.replaceWith(newPrimaryMediaElement);
      newPrimaryMediaElement.animate({ opacity: [0, 1] }, { duration: 250, easing: "ease-in" });
    }
  }
  
  _createImageElement(media, classes, sizes) {
    const previewImage = media["preview_image"], image = new Image(previewImage["width"], previewImage["height"]);
    image.className = classes;
    image.alt = media["alt"];
    image.sizes = sizes;
    image.src = previewImage["src"];
    image.srcset = generateSrcset(previewImage, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800]);
    return image;
  }
  async _getMatchingVariant(target) {
    this.product = await ProductLoader.load(this.getAttribute("handle"));
    return this.product["variants"].find((variant) => variant[`option${target.closest("[data-option-position]").getAttribute("data-option-position")}`] === target.value);
  }
};
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}

// js/common/product/product-form.js
var ProductForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit);
  }

  connectedCallback() {
    this.id.disabled = false;
  }

  async _onSubmit(event) {
    event.preventDefault();

    if (!this.checkValidity()) {
      this.reportValidity();const mesClear = () => Array.from(this.elements).forEach((b) => { if (b.type === "submit") b.removeAttribute("aria-busy"); });
      mesClear();
      setTimeout(mesClear, 0);
      return;
    }

    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");const setAriaBusy = (on) => {
      this._mesAriaBusy = on;
      if (!on) {
        submitButtons.forEach((submitButton) => submitButton.removeAttribute("aria-busy"));
        return;
      }
      const flush = () => {
        if (this._mesAriaBusy) {
          submitButtons.forEach((submitButton) => submitButton.setAttribute("aria-busy", "true"));
        }
      };
      requestAnimationFrame(() => setTimeout(flush, 0));
      setTimeout(flush, 120);
    };
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
    });
    setAriaBusy(true);

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    // V9.28.162: the post-add cart rides in the same response (no second /cart.js read); the order
    // bump's adds below reuse this list, so their responses carry it too.
    api.withCartJsonSection(sectionsToBundle);
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);
    localStorage.setItem("variantPickerId",this.id.value);
    const that = this;
    try {
      if(this.id.dataset.enableSizeSelection === 'true') {const handle = this.id.dataset.productHandle;
        const cached = await Promise.race([
          Promise.resolve(ProductLoader.load(handle)),
          new Promise((resolve) => setTimeout(resolve, 2500, null))
        ]).catch(() => null);
        const data = cached && Array.isArray(cached.options) ? cached : await api.fetchProductByName(handle);
        const options = data.options;
        const sizeOptionIndex = options.findIndex(option => option.name.toLowerCase().includes('size'));
        if (sizeOptionIndex !== -1) {
          const sizeOptionPosition = options[sizeOptionIndex].position;
          let optionName = `option${sizeOptionPosition}`;
          if (Form.serialize(that).hasOwnProperty(optionName)) {
          } else {
            // No size chosen. Website 3.0: reveal the inline size guide (open +
            // scroll + flash) instead of the legacy hint text. Non-V3 keeps the hint.
            const v3root = that.closest('.mes-pdp3');
            const v3guide = v3root && v3root.querySelector('[data-mes-sg]');
            if (v3guide) {
              v3guide.dispatchEvent(new CustomEvent('mes-pdp3:size-required', { bubbles: true }));
            } else {
              custom.toggleSizeInfoText('remove')
            }
            setAriaBusy(false);setTimeout(() => { if (!that._mesAriaBusy) submitButtons.forEach((submitButton) => submitButton.removeAttribute("aria-busy")); }, 0);
            submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
          });
            return;
          }
        }
      }

      // V9.28.162: open the drawer now, not after the add's two round trips. Not on the cart page
      // or a page-type cart, which redirect to /cart below exactly as before. Dispatched on the
      // form, like variant:add, so the quick-buy drawer can block it the same way.
      const mesOpensDrawer = !(window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart");
      if (mesOpensDrawer) {
        that.dispatchEvent(new CustomEvent("mes-cart:adding", { bubbles: true, detail: { blockCartDrawerOpening: false, handle: that.id.dataset.productHandle || "", variantId: that.id.value } }));
      }
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      api.invalidateCartRead();

      // const response = await fetch("https://mesmerizeindia.com/cart/add.js", {
      //   body: formData,
      //   method: "POST",
      //   headers: {
      //     "X-Requested-With": "XMLHttpRequest"
      //   }
      // });

      setAriaBusy(false);
      submitButtons.forEach((submitButton) => {
        submitButton.removeAttribute("disabled");
      });

      const responseJson = await response.json();
      if (response.ok) {
        // Website 3.0 order bump (B7): a ticked add-on rides along via the SAME standard
        // cart/add.js path (checkout routing untouched). Only fires on a V3 page that has a
        // bump and it is checked; null/unchecked everywhere else, so the normal add is unaffected.
        // ALL bump cards on the page are honoured (rakhi wave added the pairing add-on next to
        // the complementary bump — a single querySelector silently dropped whichever came second).
        try {
          const _bumps = document.querySelectorAll(".mes-pdp3 [data-mes-bump]");
          for (const _bump of _bumps) {
            const _bumpId = _bump.getAttribute("data-bump-variant-id");
            const _bumpToggle = _bump.querySelector("[data-mes-bump-toggle]");
            if (!(_bumpId && _bumpToggle && _bumpToggle.checked)) continue;
            // ⛔ ALREADY-IN-CART GUARD (28 Jul 2026, Priyanka's overcharge report). The bump
            // checkbox STAYS TICKED after its add — nothing unticks it — and this block re-reads
            // it on EVERY subsequent add from the same page. So a second add (another product, a
            // quick-add, anything routed through this submit) silently posted the SAME bump
            // variant again, and cart/add.js increments an existing line rather than erroring.
            // The shopper is charged for an add-on quantity they never chose, and because the
            // bump row is visually part of the product block it does not read as a separate
            // item they could remove. Two-part fix: skip if the variant is already in the cart,
            // and untick the box after a successful add so the UI matches the cart.
            // V9.28.162: the add just made (main or previous bump) returned the cart as it now stands.
            const _cartNow = api.cartFromSections(responseJson.sections) || await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            const _alreadyIn = _cartNow && _cartNow.items
              && _cartNow.items.some((it) => Number(it.variant_id) === Number(_bumpId));
            if (_alreadyIn) { _bumpToggle.checked = false; continue; }
            const _bumpResp = await fetch(`${Shopify.routes.root}cart/add.js`, {
              // Source tagging (Shrey, 19 Aug 2026): the tick-to-add upsell is a separate
              // placement from the offer bundle, so it carries its own slug — otherwise its
              // revenue would silently inflate the bundle's number.
              body: JSON.stringify({ items: [{ id: Number(_bumpId), quantity: 1, properties: { _mes_source: 'pdp-order-bump' } }], sections: sectionsToBundle.join(","), sections_url: `${Shopify.routes.root}variants/${that.id.value}` }),
              method: "POST",
              headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }
            });
            api.invalidateCartRead();
            const _bumpJson = await _bumpResp.json();
            // The main add's bundled drawer section was rendered before the bump existed in the
            // cart; replace it with the LAST bump add's fresh render so the drawer shows every item.
            if (_bumpResp.ok && _bumpJson && _bumpJson.sections) { responseJson.sections = _bumpJson.sections; }
            // Untick on success: the add-on is now IN the cart, so a ticked box would both
            // misrepresent state and re-add on the next submit (see the guard above).
            if (_bumpResp.ok) { _bumpToggle.checked = false; }
          }
        } catch (_bumpErr) {
          console.error("order bump add failed", _bumpErr);
        }
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          return window.location.href = `${Shopify.routes.root}cart`;
        }

        // V9.28.162: from the add's own mes-cart-json section; the old /cart.js read only as fallback.
        const cartContent = await api.cartAfterAdd(responseJson);
        that.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
      } else {
        that.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
      }
    } catch (error) {
      console.error(error);
      // V9.28.162: no cart:error comes from here (non-JSON body, network), so end "Adding…" explicitly.
      that.dispatchEvent(new CustomEvent("mes-cart:add-failed", { bubbles: true }));
      // V9.28.215 (buying-journey audit, Shrey 14 Oct): a throw here (network drop, challenge page, non-JSON reply) left
      // every Add to cart button DISABLED and on "..." until a page reload. Give the shopper the button back.
      that._mesAriaBusy = false;
      Array.from(that.elements).forEach((b) => { if (b.type === "submit") { b.removeAttribute("aria-busy"); b.removeAttribute("disabled"); } });
    }
  }
};

if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm, { extends: "form" });
}

// js/common/product/product-form-listeners.js
var BuyButtons = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onCartErrorListener = this._onCartError.bind(this);
  }
  connectedCallback() {
    this._productForm = document.forms[this.getAttribute("form")];
    this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);
    this._productForm?.addEventListener("cart:error", this._onCartErrorListener);
  }
  disconnectedCallback() {
    this._productForm?.removeEventListener("variant:change", this._onVariantChangedListener);
    this._productForm?.removeEventListener("cart:error", this._onCartErrorListener);
  }
  _onVariantChanged(event) {
    const addToCartButton = this.querySelector('button[type="submit"]'), paymentButton = this.querySelector(".shopify-payment-button");
    addToCartButton.classList.remove("button--secondary", "button--subdued");
    addToCartButton.disabled = !event.detail.variant || !event.detail.variant["available"];
    const addToCartButtonText = addToCartButton.getAttribute("is") === "custom-button" ? addToCartButton.firstElementChild : addToCartButton;
    const buyButtonText = event.target.outerHTML.includes("quick-buy-form") ? "Add" : window.themeVariables.strings.addToCartButton;
    if (!event.detail.variant) {
      addToCartButtonText.innerHTML = window.themeVariables.strings.unavailableButton;
      addToCartButton.classList.add("button--subdued");
      if (paymentButton) {
        paymentButton.style.display = "none";
      }
    } else {
      addToCartButton.classList.add(event.detail.variant["available"] ? paymentButton || this.hasAttribute("force-secondary-button") ? "button--secondary" : "button" : "button--subdued");
      addToCartButtonText.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : buyButtonText : window.themeVariables.strings.soldOutButton;
      if (paymentButton) {
        paymentButton.style.display = event.detail.variant["available"] ? "block" : "none";
      }
    }
  }
  _onCartError(event) {
    const errorBanner = document.createElement("div");
    errorBanner.classList.add("banner", "banner--error", "justify-center");
    errorBanner.setAttribute("role", "alert");
    errorBanner.style.gridColumn = "1/-1";
    errorBanner.style.marginBottom = "1rem";
    errorBanner.innerHTML = `
      <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
        <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
      </svg>
      
      <p>${event.detail.error}</p>
    `;
    this.before(errorBanner);
    setTimeout(async () => {
      await errorBanner.animate({ opacity: [1, 0] }, { duration: 250, fill: "forwards" }).finished;
      errorBanner.remove();
    }, 5e3);
  }
};
if (!window.customElements.get("buy-buttons")) {
  window.customElements.define("buy-buttons", BuyButtons);
}
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (event.detail.variant) {
      const element = this.querySelector('[name="id"]');
      element.value = event.detail.variant["id"];
      element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};
if (!window.customElements.get("payment-terms")) {
  window.customElements.define("payment-terms", PaymentTerms);
}
var PickupAvailability = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  async _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.innerHTML = "";
    } else {
      const element = document.createElement("div");
      element.innerHTML = await (await fetch(`${Shopify.routes.root}variants/${event.detail.variant["id"]}?section_id=pickup-availability`)).text();
      this.replaceChildren(...element.querySelector("pickup-availability").childNodes);
    }
  }
};
if (!window.customElements.get("pickup-availability")) {
  window.customElements.define("pickup-availability", PickupAvailability);
}
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var SalePrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat)));
    //this.classList.toggle("text-lg text-on-sale", variant["compare_at_price"] > variant["price"]);
  }
};
var CompareAtPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["compare_at_price"], currencyFormat)));
    this.hidden = !(variant["compare_at_price"] > variant["price"]);
  }
};
var UnitPrice = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant["unit_price"]) {
      return this.hidden = true;
    }
    const referenceValue = variant["unit_price_measurement"]["reference_value"] !== 1 ? variant["unit_price_measurement"]["reference_value"] : "";
    const node = document.createRange().createContextualFragment(
      `${formatMoney(variant["unit_price"])}/${referenceValue}${variant["unit_price_measurement"]["reference_unit"]}`
    );
    this.lastChild.replaceWith(node);
    this.hidden = false;
  }
};
if (!window.customElements.get("sale-price")) {
  window.customElements.define("sale-price", SalePrice);
}
if (!window.customElements.get("compare-at-price")) {
  window.customElements.define("compare-at-price", CompareAtPrice);
}
if (!window.customElements.get("unit-price")) {
  window.customElements.define("unit-price", UnitPrice);
}
var _onVariantChanged, onVariantChanged_fn;
var SoldOutBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChanged, onVariantChanged_fn).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChanged = new WeakSet();
onVariantChanged_fn = function(event) {
  this.hidden = event.detail.variant["available"];
};
var _onVariantChanged2, onVariantChanged_fn2;
var OnSaleBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged2);
    __publicField(this, "_onVariantChangedListener", __privateMethod(this, _onVariantChanged2, onVariantChanged_fn2).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
};
_onVariantChanged2 = new WeakSet();
onVariantChanged_fn2 = function(event) {
  const variant = event.detail.variant;
  if (variant["compare_at_price"] > variant["price"]) {
    this.hidden = false;
    if (this.hasAttribute("discount-mode")) {
      const _sgDiff = variant["compare_at_price"] - variant["price"];
      const _sgPct = Math.round(_sgDiff * 100 / variant["compare_at_price"]);
      const _sgMode = this.getAttribute("discount-mode");
      const savings = _sgMode === "percentage" ? `${_sgPct}%` : _sgMode === "combined" ? `${formatMoney(_sgDiff)} · ${_sgPct}% Off` : formatMoney(_sgDiff);
      this.innerHTML = `${window.themeVariables.strings.discountBadge.replace("@@", savings)}`;
    }
  } else {
    this.hidden = true;
  }
};
if (!window.customElements.get("sold-out-badge")) {
  window.customElements.define("sold-out-badge", SoldOutBadge);
}
if (!window.customElements.get("on-sale-badge")) {
  window.customElements.define("on-sale-badge", OnSaleBadge);
}
var VariantInventory = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    const variantId = event.detail.variant ? event.detail.variant["id"] : null;
    Array.from(this.children).forEach((item) => item.toggleAttribute("hidden", variantId !== parseInt(item.getAttribute("data-variant-id"))));
  }
};
if (!window.customElements.get("variant-inventory")) {
  window.customElements.define("variant-inventory", VariantInventory);
}
var VariantMedia = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    this.sizesAttribute = this.querySelector("img").sizes;
    this.classAttribute = this.querySelector("img").className;
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  get widths() {
    return this.getAttribute("widths").split(",").map((width) => parseInt(width));
  }
  _onVariantChanged(event) {
    if (!event.detail.variant || !event.detail.variant["featured_media"]) {
      return;
    }
    this.replaceChildren(createMediaImg(event.detail.variant["featured_media"], this.widths, { "class": this.classAttribute, "sizes": this.sizesAttribute }));
  }
};
if (!window.customElements.get("variant-media")) {
  window.customElements.define("variant-media", VariantMedia);
}
var VariantSku = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.hidden = true;
    } else {
      this.innerText = `${window.themeVariables.strings.sku} ${event.detail.variant["sku"]}`;
      this.hidden = !event.detail.variant["sku"];
    }
  }
};
if (!window.customElements.get("variant-sku")) {
  window.customElements.define("variant-sku", VariantSku);
}

// js/common/product/product-gallery.js
import { PhotoSwipeLightbox } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var ProductGallery = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
    this._carousels = Array.from(this.querySelectorAll("media-carousel"));
    this._pageDots = Array.from(this.querySelectorAll("page-dots"));
    this._viewInSpaceButton = this.querySelector("[data-shopify-xr]");
    this._customCursor = this.querySelector(".product-gallery__cursor");
    this.addEventListener("carousel:change", this._onCarouselChanged);
    if (this._viewInSpaceButton) {
      this.addEventListener("carousel:settle", this._updateViewInSpaceButton);
    }
    if (this.hasAttribute("allow-zoom")) {
      this.addEventListener("lightbox:open", (event) => this.openZoom(event.detail.index));
    }
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  get photoswipe() {
    if (this._photoswipe) {
      return this._photoswipe;
    }
    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import("//mesmerizeindia.com/cdn/shop/t/346/assets/photoswipe.min.js?v=96595610301167188461792587326"),
      bgOpacity: 1,
      maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      // UX
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: false,
      closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
        <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
        <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
        <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
      </svg>`
    });
    photoswipe.addFilter("thumbEl", (thumbEl, data) => data["thumbnailElement"]);
    photoswipe.on("uiRegister", () => {
      photoswipe.pswp.ui.registerElement({
        name: "bottom-bar",
        order: 5,
        appendTo: "wrapper",
        html: `
          <div class="pagination">
            <button class="pagination__item group" rel="prev">
              <span class="animated-arrow animated-arrow--reverse"></span>
            </button>
            
            <span class="pagination__current text-sm">
              <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
            </span>
            
            <button class="pagination__item group" rel="next">
              <span class="animated-arrow"></span>
            </button>
          </div>
        `,
        onInit: (el, pswp) => {
          el.querySelector(".pagination__page-count").innerText = pswp.getNumItems();
          el.querySelector('[rel="prev"]')?.addEventListener("click", () => pswp.prev());
          el.querySelector('[rel="next"]')?.addEventListener("click", () => pswp.next());
          pswp.on("change", () => {
            el.querySelector(".pagination__current-page").innerText = pswp.currIndex + 1;
          });
        }
      });
    });
    photoswipe.init();
    return this._photoswipe = photoswipe;
  }
  /**
   * Open the zoom by dynamically creating a data source based on the filtered items
   */
  openZoom(index = 0) {
    const dataSource = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) > img'))
    .filter((image) => !image.classList.contains('hide'))  // Filter out images with class "hide"
    .map((image) => {
        return {
            thumbnailElement: image,
            src: image.src,
            srcset: image.srcset,
            msrc: image.currentSrc || image.src,
            width: parseInt(image.getAttribute("width")),
            height: parseInt(image.getAttribute("height")),
            alt: image.alt,
            thumbCropped: true
        };
    });
    this.photoswipe.loadAndOpen(index, dataSource);
  }

  _updateViewInSpaceButton(event) {
    if (event.detail.slide.getAttribute("data-media-type") === "model") {
      this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", event.detail.slide.getAttribute("data-media-id"));
    } else {
      this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", this._viewInSpaceButton.getAttribute("data-shopify-model3d-default-id"));
    }
  }
  /* V9.28.91: one 3D model per colour (each carries its colour's media alt, so the alt filter shows the right one).
     "View in your space" falls back to its default model whenever a photo is showing, so the default must follow the
     colour too, or a Silver shopper launches the Gold model in AR. Picks the first 3D model the filter left visible. */
  _syncViewInSpaceToVariant() {
    if (!this._viewInSpaceButton) return;
    const models = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="model"]'));
    const visible = models.find((m) => !m.hidden && m.style.display !== "none");
    if (!visible) return;
    const id = visible.getAttribute("data-media-id");
    this._viewInSpaceButton.setAttribute("data-shopify-model3d-default-id", id);
    this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", id);
  }
  _onCarouselChanged(event) {
    if (this._customCursor) {
      this._customCursor.toggleAttribute("hidden", event.detail.slide.getAttribute("data-media-type") !== "image");
    }
  }_onVariantChanged(event) {
    const token = this._mesGalleryToken = (this._mesGalleryToken || 0) + 1;
    const run = () => { if (token === this._mesGalleryToken) this._applyVariantMedia(event); };
    if (document.hidden) { run(); return; }
    requestAnimationFrame(() => setTimeout(run, 0));
  }
  _applyVariantMedia(event) {
    this._onFilterImgVariant(event);
    this._syncViewInSpaceToVariant();
    this._createFilteredZoomImageList(event);
    const filteredIndexes = this._getFilteredMediaIndexes(event.detail.product, event.detail.variant);
    this._carousels.forEach((carousel) => carousel.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes } })));
    this._pageDots.forEach((pageDots) => pageDots.dispatchEvent(new CustomEvent("control:filter", { detail: { filteredIndexes } })));
    if (event.detail.variant["featured_media"] && event.detail.previousVariant["featured_media"] && event.detail.previousVariant["featured_media"]["id"] !== event.detail.variant["featured_media"]["id"] || !event.detail.previousVariant["featured_media"] && event.detail.variant["featured_media"]) {
      this._carousels.forEach((carousel) => carousel.select(event.detail.variant["featured_media"]["position"] - 1, { animate: false }));
    }
  }

  //Custom function to create a filtered list of media images for zooming
   _filterElementsByAlt(elements, currentImgAlt, variantOption2, iscssClass, showClass, hideClass) {
      if (!currentImgAlt) {
          return;
      }
      elements.forEach((element) => {
          if (iscssClass) {
              element.classList.toggle(showClass, false);
              element.classList.toggle(hideClass, true);
          } else {
              element.style.display = hideClass;
          }
          
          const altName = element.alt || element.dataset.mediaAlt;
          const isCommonAlt = altName === `Common ${variantOption2}`;
          const isCurrentImgAlt = altName === currentImgAlt;
          
          if (isCommonAlt || isCurrentImgAlt) {
              if (iscssClass) {
                  element.classList.toggle(showClass, true);
                  element.classList.toggle(hideClass, false);
              } else {
                  element.style.display = showClass;
              }
          }
      });
    }

  //function created to filter the media images when zoom is enabled
   _createFilteredZoomImageList(event) {
      const dataSource = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) > img'));
      const currentImgAlt = event.detail.variant.featured_media?.alt;
      this._filterElementsByAlt(dataSource, currentImgAlt, event.detail.variant.option2, true, 'show', 'hide');
   }

  //function created to filter the product featured images along with its related media images
  _onFilterImgVariant(event) {
    const mediaAltSelector = Array.from(document.querySelectorAll("[data-media-alt]"));
    const currentImgAlt = event.detail.variant.featured_media?.alt;
    this._filterElementsByAlt(mediaAltSelector, currentImgAlt, event.detail.variant.option2, false, 'block', 'none');
  }
    
    // const mediaAltSelector = document.querySelectorAll("[data-media-alt]");
    // // let coverageArray = ["Essential", "ESSENTIAL", "Pro", "PRO", "Max", "MAX"];
    // // let selectedCoverage = event.detail.variant.option1;
    // // let selectedTexture;
    // if(event.detail.variant.featured_media && event.detail.variant.featured_media.alt) {
    //   // mediaAltSelector.forEach(img=>img.style.display="none")
    //   const currentImgAlt = event.detail.variant.featured_media.alt;
    //   // for(let i=0; i<coverageArray.length; i++) {
    //   //   if(currentImgAlt.includes(coverageArray[i])) {
    //   //     selectedTexture = currentImgAlt.split(coverageArray[i])[0];
    //   //   }
    //   // }
    //   // console.log("Texture : " + selectedTexture + " ::: " + " Selected coverage : " + selectedCoverage);
    //   for(let i=0; i<mediaAltSelector.length; i++){
    //     mediaAltSelector[i].style.display="none";
    //     // if the media alt name is same as the featured image alt name or if the alt name is common
    //     if(mediaAltSelector[i].dataset.mediaAlt === `Common ${event.detail.variant.option2}` ||  mediaAltSelector[i].dataset.mediaAlt === currentImgAlt){
    //       mediaAltSelector[i].style.display = 'block';
    //     }
    //     // if(mediaAltSelector[i].dataset.mediaAlt.includes(selectedTexture) && (selectedCoverage === "Max" || selectedCoverage === "MAX") ) {
    //     //   if(mediaAltSelector[i].dataset.mediaAlt.includes("Essential") || mediaAltSelector[i].dataset.mediaAlt.includes("Pro") || mediaAltSelector[i].dataset.mediaAlt.includes("Max")) {
    //     //     mediaAltSelector[i].style.display = 'block';
    //     //   }
    //     // }

    //     // if(mediaAltSelector[i].dataset.mediaAlt.includes(selectedTexture) && (selectedCoverage === "Pro" || selectedCoverage === "PRO")) {
    //     //   if(mediaAltSelector[i].dataset.mediaAlt.includes("Essential") || mediaAltSelector[i].dataset.mediaAlt.includes("Pro")) {
    //     //     mediaAltSelector[i].style.display = 'block';
    //     //   }
    //     // }

    //     // if(mediaAltSelector[i].dataset.mediaAlt.includes(selectedTexture) && (selectedCoverage === "Essential" || selectedCoverage === "ESSENTIAL")) {
    //     //   if(mediaAltSelector[i].dataset.mediaAlt.includes("Essential")) {
    //     //     mediaAltSelector[i].style.display = 'block';
    //     //   }
    //     // }
    //   }
    // }
  // }
  
  _getFilteredMediaIndexes(product, variant) {
    const filteredMediaIds = [];
    product["media"].forEach((media) => {
      let matchMedia = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
      if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
        if (!matchMedia) {
          const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
          product["options"].forEach((option) => {
            if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
              if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                filteredMediaIds.push(media["position"] - 1);
              }
            }
          });
        }
      }
    });
    return filteredMediaIds;
  }
};
var MediaCarousel = class extends ScrollCarousel {
  connectedCallback() {
    super.connectedCallback();
    this._onGestureChangedListener = this._onGestureChanged.bind(this);
    this.addEventListener("gesturestart", this._onGestureStart, { capture: false, signal: this._abortController.signal });
    this.addEventListener("carousel:settle", this._onMediaSettled, { signal: this._abortController.signal });
    this.addEventListener("click", this._onGalleryClick);
  }
  _onMediaSettled(event) {
    const media = event.detail.slide;
    this.items.filter((item) => ["video", "external_video", "model"].includes(item.getAttribute("data-media-type"))).forEach((item) => item.firstElementChild.pause());
    switch (media.getAttribute("data-media-type")) {
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay")) {
          media.firstElementChild.play();
        }
        break;
      case "model":
        if (window.matchMedia("(min-width: 1000px)").matches) {
          media.firstElementChild.play();
        }
        break;
    }
  }
  _onGalleryClick(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope") || !window.matchMedia("screen and (pointer: fine)").matches) {
      return;
    }
    if (this.selectedSlide.getAttribute("data-media-type") !== "image") {
      return;
    }
    const rect = event.currentTarget.getBoundingClientRect(), offsetX = event.clientX - rect.left;
    offsetX > this.clientWidth / 2 ? this.next() : this.previous();
  }
  _onGestureStart(event) {
    event.preventDefault();
    this.addEventListener("gesturechange", this._onGestureChangedListener, { capture: false, signal: this._abortController.signal });
  }
  _onGestureChanged(event) {
    event.preventDefault();
    if (event.scale > 1.5) {
      this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: this.selectedIndexAmongVisible } }));
      this.removeEventListener("gesturechange", this._onGestureChangedListener);
    }
  }
};
var ProductZoomButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
  }
  _onButtonClicked() {
    let media = this.closest(".product-gallery__media"), openIndex;
    if (media) {
      const visibleImages = this.closest("media-carousel").visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(media);
    } else {
      const carousel = this.closest(".product-gallery__media-list-wrapper").querySelector("media-carousel");
      const visibleImages = [];
      for(let i=0; i<carousel.visibleItems.length; i++){
        let item = carousel.visibleItems[i];
        if(item.getAttribute("data-media-type") === "image") {
          visibleImages.push(item);
        }
      }
      // const visibleImages = carousel.visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(carousel.selectedSlide);
    }
    this.dispatchEvent(new CustomEvent("lightbox:open", {
      bubbles: true,
      detail: {
        index: openIndex
      }
    }));
  }
};
if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}
if (!window.customElements.get("product-zoom-button")) {
  window.customElements.define("product-zoom-button", ProductZoomButton, { extends: "button" });
}
if (!window.customElements.get("media-carousel")) {
  window.customElements.define("media-carousel", MediaCarousel);
}

// js/common/product/quick-add.js
var _scopeFromPassed, _scopeToReached, _intersectionObserver;
var ProductQuickAdd = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _scopeFromPassed, false);
    __privateAdd(this, _scopeToReached, false);
    __privateAdd(this, _intersectionObserver, new IntersectionObserver(this._onObserved.bind(this)));
  }
  connectedCallback() {
    this._scopeFrom = document.getElementById(this.getAttribute("form"));
    this._scopeTo = document.querySelector(".footer");
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    this._scopeFromVisible = false;
    // Initial visibility is decided HERE, not left to the markup class + the observer's
    // async first callback — which flashed the bar visible-then-hidden on load while the
    // main ATC was already on screen (notably desktop, where the bar should never appear at
    // the top). Mobile sticky (not inline) is always shown; every other case starts from the
    // real "is the main ATC in view" answer. Transition is suppressed for this initial set.
    this.classList.add("pqa-noanim");
    if (this.dataset.stickyEnabled === "true" && window.innerWidth < 700 && this.dataset.mobileInline !== "true") {
      this.classList.add("is-visible");
    } else {
      var _r = this._scopeFrom.getBoundingClientRect();
      var _atcInView = _r.bottom > 0 && _r.top < (window.innerHeight || document.documentElement.clientHeight);
      this._scopeFromVisible = _atcInView;
      this.classList.toggle("is-visible", !_atcInView);
    }
    requestAnimationFrame(() => this.classList.remove("pqa-noanim"));
    __privateGet(this, _intersectionObserver).observe(this._scopeFrom);
    __privateGet(this, _intersectionObserver).observe(this._scopeTo);
  }
  disconnectedCallback() {
    __privateGet(this, _intersectionObserver).disconnect();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      if (entry.target === this._scopeFrom) {
        this._scopeFromVisible = entry.isIntersecting;
      }
      if (entry.target === this._scopeTo) {
        __privateSet(this, _scopeToReached, entry.isIntersecting);
      }
    });

    if(this.dataset.stickyEnabled !== 'true' || window.innerWidth >= 700 || this.dataset.mobileInline === 'true') {
      this.classList.toggle("is-visible", !this._scopeFromVisible && !__privateGet(this, _scopeToReached));
    } 
  }
};
_scopeFromPassed = new WeakMap();
_scopeToReached = new WeakMap();
_intersectionObserver = new WeakMap();
if (!window.customElements.get("product-quick-add")) {
  window.customElements.define("product-quick-add", ProductQuickAdd);
}

// js/common/product/quick-buy-drawer.js
import { animate as animate7, timeline as timeline5 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var QuickBuyDrawer = class extends Drawer {
  constructor() {
    super();
    this._hasLoaded = false;
    this.addEventListener("variant:add", this._onVariantAdded.bind(this));
    
    this.addEventListener("mes-cart:adding", (event) => { if (event.detail) { event.detail.blockCartDrawerOpening = true; } });
  }

  async show() {
    
    this._autoDismissToken = (this._autoDismissToken || 0) + 1;
    this.style.display = this._isMesQa ? "flex" : "block";
    if (!this._hasLoaded) {
      if (QuickBuyDrawer._mesQaSectionId && !this._mesQaLegacy) {
        
        this._mesQaSkeleton();
        const shown = super.show();
        this._load().then(() => {
          if (!this._isMesQa) { this.style.display = "block"; return; }
          const dialog = this.querySelector("[data-mes-qa-dialog]");
          if (dialog) { animate7(dialog, { opacity: [0, 1] }, { duration: 0.18 }); }
          this._mesQaPrefetchNeighbour();
        }).catch(() => this.hide());
        return shown;
      }
      await this._load();
      this.style.display = this._isMesQa ? "flex" : "block";
    } else if (this._isMesQa) {
      this._mesQaRefreshNav();
      this._mesQaApplyTitleClamp();
      this._mesQaApplyRemembered();
    }
    const shown = super.show();
    if (this._isMesQa) { this._mesQaPrefetchNeighbour(); }
    return shown;
  }

  _mesQaSkeleton() {
    this.classList.add("mes-qa");
    this.style.display = "flex";
    const shell = document.createElement("div");
    shell.className = "mes-qa";
    shell.setAttribute("data-mes-qa", "");
    shell.innerHTML = `<button type="button" class="mes-qa__close" data-mes-qa-close aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></svg></button><div class="mes-qa__dialog mes-qa__dialog--skeleton" data-mes-qa-dialog aria-busy="true" tabindex="-1"><div class="mes-qa__skel-hero"></div><div class="mes-qa__skel-line"></div><div class="mes-qa__skel-line mes-qa__skel-line--short"></div><div class="mes-qa__skel-cards"><span></span><span></span><span></span></div></div>`;
    shell.querySelector("[data-mes-qa-close]").addEventListener("click", () => this.hide());
    this.replaceChildren(shell);
  }

  
  async _load() {
    if (this._hasLoaded) { return; }
    if (this._loading) { return this._loading; }
    this._loading = (async () => {
      
      this.setAttribute("aria-busy", "true");
      const handle = this.getAttribute("handle"), root = window.Shopify.routes.root;
      let doc = null;
      if (QuickBuyDrawer._mesQaSectionId) {
        try {
          const res = await fetch(`${root}products/${handle}?section_id=${QuickBuyDrawer._mesQaSectionId}`);
          if (res.ok) {
            const candidate = new DOMParser().parseFromString(await res.text(), "text/html");
            if (candidate.getElementById("quick-buy-content")) { doc = candidate; }
          }
        } catch (e) { doc = null; }
      }
      if (!doc) {
        doc = new DOMParser().parseFromString(await (await fetch(`${root}products/${handle}`)).text(), "text/html");
      }
      this.setAttribute("aria-busy", "false");
      const quickBuyContent = doc.getElementById("quick-buy-content").content;
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      if (quickBuyContent.querySelector("[data-mes-qa]")) {
        this.classList.add("mes-qa");
        if (this.open) { this.style.display = "flex"; }
        
        const form = quickBuyContent.querySelector('form[is="product-form"]');
        const m = form && /-(template--[A-Za-z0-9_]+)$/.exec(form.getAttribute("id") || "");
        if (m && !QuickBuyDrawer._mesQaSectionId) {
          QuickBuyDrawer._mesQaSectionId = m[1];
          try { sessionStorage.setItem("mes-qa-section-id", m[1]); } catch (e) { /* fine without */ }
        }
      }
      if (!quickBuyContent.querySelector("[data-mes-qa]")) {
        this._mesQaLegacy = true;
        this.classList.remove("mes-qa");
        if (this.open) { this.style.display = "block"; }
      }
      this.replaceChildren(quickBuyContent);
      Shopify.PaymentButton?.init();
      this._hasLoaded = true;
      if (this._isMesQa) { this._mesQaInit(); }
    })();
    try { await this._loading; } finally { this._loading = null; }
  }

  
  preload() {
    return this._load();
  }

  _mesQaPrefetchNeighbour() {
    clearTimeout(this._mesQaPrefetchTimer);
    this._mesQaPrefetchTimer = setTimeout(() => {
      if (!this.open) { return; }
      const ids = QuickBuyDrawer.mesQaList(), i = ids.indexOf(this.id);
      if (ids.length < 2 || i < 0) { return; }
      const next = document.getElementById(ids[(i + 1) % ids.length]);
      if (next && !next._hasLoaded && next.preload) { next.preload().catch(() => {}); }
    }, 700);
  }
  async hide() {
    
    const hidePromise = super.hide();
    if (!hidePromise) {
      if (!this.open) { this.style.display = "none"; }
      return;
    }
    return hidePromise.then(() => {
      
      if (!this.open) { this.style.display = "none"; }
    });
  }

  _onViewCartClicked(){
     this.hide();
  }
  
  _onVariantAdded(event) {
    event.detail.blockCartDrawerOpening = true;
    if (this._isMesQa) {
      
      QuickBuyDrawer.mesQaSetRemembered(this._mesQaSelections());
      const spec = this._mesQaSpec();
      this.querySelector("[data-mes-qa-buynow]")?.removeAttribute("aria-busy");
      if (this._mesQaBuyNow) {
        this._mesQaBuyNow = false;
        event.detail.blockCartDrawerOpening = false;
        this.hide();
        return;
      }
      this.hide();
      QuickBuyDrawer.mesQaToast(spec, 3200);
      return;
    }
    const contentShadow = this.shadowRoot.querySelector('[part="content"]'), fromHeight = contentShadow.clientHeight;
    animate7(contentShadow.children, { opacity: 0, visibility: "hidden" }, { duration: 0.15 });
    // this.replaceChildren(...new DOMParser().parseFromString(event.detail.cart["sections"]["variant-added"], "text/html").querySelector(".shopify-section").children);

    // This modifies the default Shopify behavior, implemented specifically for version 8.4
    const newContent = new DOMParser().parseFromString(event.detail.cart["sections"]["variant-added"], "text/html").querySelector(".banner--success");
     if (newContent) {
      this.replaceChildren(newContent);
      this.shadowRoot.querySelector('[part="overlay"]').style.display = "none"
      document.documentElement.classList.remove('lock');
     }
      
    // Add event listener for [data-quick-buy-cart] dynamically after the content is added
    const quickBuyCartButton = this.querySelector('[data-quick-buy-cart]');
    if (quickBuyCartButton) {
      quickBuyCartButton.addEventListener('click', this._onViewCartClicked.bind(this));
    }
    
    requestAnimationFrame(async () => {
      await timeline5([
        [contentShadow, { height: [`${fromHeight}px`, `${contentShadow.clientHeight}px`] }, { duration: 0.35, easing: [0.86, 0, 0.07, 1] }],
        [contentShadow.children, { opacity: [0, 1], visibility: "visible" }, { duration: 0.15 }]
      ]).finished;
      contentShadow.style.height = null;

      
      const dismissToken = this._autoDismissToken;
      setTimeout(() => {
        if (dismissToken !== this._autoDismissToken) { return; }
        this.shadowRoot.querySelector('[part="overlay"]').style.display = "block";
        if (this.open) {
          this.hide();
        } else {
          this.style.display = 'none';
        }
      }, 2000);
    });

    this._hasLoaded = false;
}

  
  get _isMesQa() { return this.classList.contains("mes-qa"); }

  
  get initialFocus() {
    if (!this._isMesQa) { return super.initialFocus; }
    return this.querySelector("[data-mes-qa-dialog]") || this;
  }

  
  _mesQaResetInline() {
    const dialog = this.querySelector("[data-mes-qa-dialog]"), closeBtn = this.querySelector("[data-mes-qa-close]");
    [dialog, closeBtn].forEach((el) => { if (el) { el.style.opacity = ""; el.style.transform = ""; el.style.visibility = ""; } });
    if (dialog) {
      dialog.style.height = "";
      dialog.style.backgroundColor = "";
      this._mesQaFadeParts(dialog).forEach((el) => { el.style.opacity = ""; });
    }
    this.style.zIndex = "";
    const overlay = this.shadowRoot.querySelector('[part="overlay"]');
    if (overlay) { overlay.style.opacity = ""; }
  }

  
  _mesQaFadeParts(dialog) {
    return dialog ? Array.from(dialog.children).filter((el) => !el.matches("[data-mes-qa-nav], .mes-qa__full")) : [];
  }

  
  _mesQaApplyTitleClamp() {
    const root = this.querySelector("[data-mes-qa]");
    if (!root) { return; }
    const name = this.controls[0]?.closest(".mhc-card")?.querySelector(".mhc-card__name");
    let lines = 0;
    if (name && name.classList.contains("mhc-clamp")) {
      lines = parseInt(getComputedStyle(name).webkitLineClamp, 10) || parseInt(getComputedStyle(name).getPropertyValue("--mhc-title-lines"), 10) || 2;
    }
    root.classList.toggle("mes-qa--clamp", lines > 0);
    if (lines > 0) { root.style.setProperty("--mes-qa-title-lines", String(lines)); } else { root.style.removeProperty("--mes-qa-title-lines"); }
  }

  get openFrom() {
    if (!this._isMesQa) { return super.openFrom; }
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "bottom" : "center";
  }

  _setInitialPosition() {
    if (!this._isMesQa) { return super._setInitialPosition(); }
    this.style.left = this.style.right = this.style.top = this.style.bottom = "0px";
  }

  _showTransition(animate11 = true) {
    if (!this._isMesQa) { return super._showTransition(animate11); }
    this._setInitialPosition();
    this._mesQaResetInline();
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const dialog = this.querySelector("[data-mes-qa-dialog]"), closeBtn = this.querySelector("[data-mes-qa-close]");
    let controls;
    if (this._mesQaSwapDir && dialog) {
      delete this._mesQaSwapDir;
      const from = this._mesQaSwapFrom;
      delete this._mesQaSwapFrom;
      
      this.style.opacity = "1";
      this.style.visibility = "visible";
      if (closeBtn) { closeBtn.style.opacity = "1"; }
      dialog.scrollTop = 0;
      const parts = this._mesQaFadeParts(dialog);
      if (reduceMotion || !from) {
        this.classList.add("show-close-cursor");
        return Promise.resolve();
      }
      const toHeight = dialog.getBoundingClientRect().height;
      const toBg = getComputedStyle(dialog).backgroundColor;
      parts.forEach((el) => { el.style.opacity = "0"; });
      dialog.style.height = `${from.height}px`;
      dialog.style.backgroundColor = from.bg;
      controls = timeline5([
        [dialog, { height: [`${from.height}px`, `${toHeight}px`], backgroundColor: [from.bg, toBg] }, { duration: 0.22, easing: [0.25, 0.1, 0.25, 1] }],
        [parts, { opacity: [0, 1] }, { at: 0.04, duration: 0.18, easing: [0.2, 0, 0.2, 1] }]
      ]);
      animate11 ? controls.play() : controls.finish();
      return controls.finished.then(() => {
        dialog.style.height = "";
        dialog.style.backgroundColor = "";
        parts.forEach((el) => { el.style.opacity = ""; });
        this.classList.add("show-close-cursor");
      });
    }
    
    if (reduceMotion || !dialog) {
      controls = animate7(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.1 });
    } else if (this.openFrom === "bottom") {
      controls = timeline5([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }],
        [dialog, { transform: ["translateY(100%)", "translateY(0px)"] }, { at: "<", duration: 0.34, easing: [0.16, 0.84, 0.28, 1] }],
        [closeBtn, { opacity: [0, 1] }, { at: "<", duration: 0.2 }]
      ]);
    } else {
      controls = timeline5([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }],
        [dialog, { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0px)"] }, { at: "<", duration: 0.28, easing: "ease" }],
        [closeBtn, { opacity: [0, 1] }, { at: "<", duration: 0.2 }]
      ]);
    }
    animate11 ? controls.play() : controls.finish();
    return controls.finished.then(() => this.classList.add("show-close-cursor"));
  }

  _hideTransition() {
    if (!this._isMesQa) { return super._hideTransition(); }
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const dialog = this.querySelector("[data-mes-qa-dialog]"), closeBtn = this.querySelector("[data-mes-qa-close]");
    let controls;
    if (this._mesQaSwapDir && dialog) {
      delete this._mesQaSwapDir;
      
      this.style.visibility = "hidden";
      this.style.opacity = "0";
      this._mesQaResetInline();
      this.classList.remove("show-close-cursor");
      return Promise.resolve();
    }
    if (reduceMotion || !dialog) {
      controls = animate7(this, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 });
    } else if (this.openFrom === "bottom") {
      controls = timeline5([
        [closeBtn, { opacity: [null, 0] }, { duration: 0.2 }],
        [dialog, { transform: ["translateY(0px)", "translateY(100%)"] }, { at: "<", duration: 0.26, easing: [0.4, 0, 1, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { at: "<", duration: 0.24 }]
      ]);
    } else {
      controls = timeline5([
        [closeBtn, { opacity: [null, 0] }, { duration: 0.2 }],
        [dialog, { opacity: [null, 0], transform: ["translateY(0px)", "translateY(12px)"] }, { at: "<", duration: 0.22, easing: [0.4, 0, 1, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { at: "<", duration: 0.24 }]
      ]);
    }
    return controls.finished.then(() => {
      
      this._mesQaResetInline();
      this.style.visibility = "hidden";
      this.style.opacity = "0";
      this.classList.remove("show-close-cursor");
    });
  }

  _mesQaInit() {
    this.querySelector("[data-mes-qa-dialog]")?.setAttribute("tabindex", "-1");
    this.querySelector("[data-mes-qa-close]")?.addEventListener("click", () => this.hide());
    this.querySelector("[data-mes-qa-buynow]")?.addEventListener("click", (event) => {
      const form = this.querySelector('.mes-qa__footer form[is="product-form"]');
      if (!form) { return; }
      this._mesQaBuyNow = true;
      event.currentTarget.setAttribute("aria-busy", "true");
      
      form.requestSubmit();
      setTimeout(() => { this._mesQaBuyNow = false; this.querySelector("[data-mes-qa-buynow]")?.removeAttribute("aria-busy"); }, 6000);
    });
    this.querySelector("[data-mes-qa-prev]")?.addEventListener("click", () => this._mesQaStep(-1));
    this.querySelector("[data-mes-qa-next]")?.addEventListener("click", () => this._mesQaStep(1));
    this._mesQaRefreshNav();
    this._mesQaApplyTitleClamp();
    this._mesQaApplyAccent();
    this._mesQaApplyRemembered();
    this._mesQaSampleTint();
    this._mesQaWatchPreorder();
    this._mesQaWatchVariantImage();
  }

  
  _mesQaWatchVariantImage() {
    if (this._mesQaImgWired) { return; }
    this._mesQaImgWired = true;
    this.addEventListener("variant:change", async (event) => {
      const media = event.detail && event.detail.variant && event.detail.variant.featured_media;
      const src = media && ((media.preview_image && media.preview_image.src) || media.src);
      const img = this.querySelector("[data-mes-qa-hero]");
      if (!img || !src || img.getAttribute("data-media-id") === String(media.id)) { return; }
      img.setAttribute("data-media-id", String(media.id));
      const url = (w) => `${src}${src.indexOf("?") > -1 ? "&" : "?"}width=${w}`;
      const next = new Image();
      next.crossOrigin = "anonymous";
      next.src = url(900);
      try { await next.decode(); } catch (e) { /* swap anyway */ }
      if (img.getAttribute("data-media-id") !== String(media.id)) { return; }
      
      if (img._mesQaFirst === undefined) { img._mesQaFirst = { id: event.detail.previousVariant && event.detail.previousVariant.featured_media ? String(event.detail.previousVariant.featured_media.id) : "", pos: img.style.objectPosition }; }
      img.style.objectPosition = String(media.id) === img._mesQaFirst.id ? img._mesQaFirst.pos : "50% 50%";
      img.srcset = `${url(660)} 660w, ${url(900)} 900w, ${url(1320)} 1320w`;
      img.src = url(900);
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        img.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 220, easing: "ease-out" });
      }
      this._mesQaSampleTint();
    });
  }

  
  _mesQaWatchPreorder() {
    const root = this.querySelector("[data-mes-qa]"), box = this.querySelector(".quick-buy-drawer__ship-date");
    if (!root || !box) { return; }
    const sync = () => root.classList.toggle("is-preorder", box.style.display !== "none" && box.textContent.trim() !== "");
    sync();
    this._mesQaPreorderObserver?.disconnect();
    this._mesQaPreorderObserver = new MutationObserver(sync);
    this._mesQaPreorderObserver.observe(box, { attributes: true, attributeFilter: ["style"], childList: true, subtree: true });
  }

  
  static mesQaList() {
    const seen = new Set(), ids = [];
    document.querySelectorAll('button[aria-controls^="quick-buy-"]').forEach((btn) => {
      const id = btn.getAttribute("aria-controls");
      if (id && !seen.has(id) && document.getElementById(id)) { seen.add(id); ids.push(id); }
    });
    return ids;
  }

  _mesQaRefreshNav() {
    const nav = this.querySelector("[data-mes-qa-nav]");
    if (!nav) { return; }
    const ids = QuickBuyDrawer.mesQaList(), i = ids.indexOf(this.id);
    if (ids.length < 2 || i < 0) { nav.hidden = true; return; }
    nav.hidden = false;
    const label = nav.querySelector("[data-mes-qa-navlabel]");
    if (label) { label.textContent = `${i + 1} / ${ids.length}`; }
  }

  _mesQaSelections() {
    const out = {};
    this.querySelectorAll('input[type="radio"]:checked').forEach((input) => { out[input.name] = input.value; });
    return out;
  }

  _mesQaApplyRemembered() {
    const wanted = QuickBuyDrawer._mesQaRemember;
    if (!wanted) { return; }
    Object.keys(wanted).forEach((name) => {
      const input = Array.from(this.querySelectorAll(`input[type="radio"][name="${name}"]`)).find((el) => el.value === wanted[name] && !el.disabled);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  
  async _mesQaStep(dir) {
    if (this._mesQaStepping) { return; }
    const ids = QuickBuyDrawer.mesQaList(), i = ids.indexOf(this.id);
    if (ids.length < 2 || i < 0) { return; }
    const target = document.getElementById(ids[(i + dir + ids.length) % ids.length]);
    if (!target || target === this) { return; }
    this._mesQaStepping = true;
    const nav = this.querySelector("[data-mes-qa-nav]");
    const dialog = this.querySelector("[data-mes-qa-dialog]");
    const parts = this._mesQaFadeParts(dialog);
    try {
      QuickBuyDrawer._mesQaRemember = this._mesQaSelections();
      nav?.setAttribute("aria-busy", "true");
      try { await target.preload(); } catch (e) { return; } finally { nav?.removeAttribute("aria-busy"); }
      
      const img = target.querySelector("[data-mes-qa-hero]");
      if (img && img.decode) { await Promise.race([img.decode().catch(() => {}), new Promise((r) => setTimeout(r, 350))]); }
      if (!this.open || !dialog) { return; }
      
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches && parts.length) {
        await animate7(parts, { opacity: [1, 0] }, { duration: 0.11, easing: [0.4, 0, 1, 1] }).finished;
      }
      
      if (!this.open) { parts.forEach((el) => { el.style.opacity = ""; }); return; }
      
      target._mesQaSwapFrom = { height: dialog.getBoundingClientRect().height, bg: getComputedStyle(dialog).backgroundColor };
      target._mesQaSwapDir = dir;
      this._mesQaSwapDir = dir;
      const shown = target.show();
      this.hide();
      await shown;
    } finally {
      this._mesQaStepping = false;
    }
  }

  
  _mesQaApplyAccent() {
    const control = this.controls[0], accent = control?.closest("[data-accent]")?.getAttribute("data-accent");
    if (accent && /^#[0-9a-f]{6}$/i.test(accent)) { this.style.setProperty("--mes-qa-accent-glow", `${accent}2E`); }
  }

  
  _mesQaSampleTint() {
    const img = this.querySelector("[data-mes-qa-hero]");
    if (!img) { return; }
    
    const pageDark = (() => {
      const raw = getComputedStyle(this).getPropertyValue("--w3-page").trim() || getComputedStyle(document.body).backgroundColor;
      if (!raw) { return false; }
      const probe = document.createElement("span"); probe.style.color = raw; probe.style.display = "none"; document.body.appendChild(probe);
      const m = getComputedStyle(probe).color.match(/[\d.]+/g); probe.remove();
      if (!m || m.length < 3) { return false; }
      const [r0, g0, b0] = m.slice(0, 3).map(Number);
      return (0.299 * r0 + 0.587 * g0 + 0.114 * b0) < 90;
    })();
    this.classList.toggle("mes-qa-dark", pageDark);
    const key = `${this.getAttribute("handle")}|${(img.getAttribute("src") || "").split("?")[0]}|${pageDark ? "d" : "l"}`;
    QuickBuyDrawer._mesQaTints = QuickBuyDrawer._mesQaTints || {};
    const apply = (rgb) => {
      const [r, g, b] = rgb;
      const relLum = (c) => { const v = c.map((x) => { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); }); return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2]; };
      const ratio = (a, c) => { const l1 = relLum(a), l2 = relLum(c); return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05); };const dark = ratio([255, 255, 255], rgb) > ratio([21, 23, 26], rgb);
      const glass = pageDark ? rgb.map((v) => Math.round(v + (255 - v) * 0.06)) : rgb.map((v) => Math.round(v * 0.61 + 255 * 0.39));
      const glassDark = ratio([255, 255, 255], glass) > ratio([21, 23, 26], glass);
      const st = this.style;
      st.setProperty("--mes-qa-bg", `rgb(${r},${g},${b})`);
      st.setProperty("--mes-qa-ink", dark ? "#FFFFFF" : "#15171A");
      st.setProperty("--mes-qa-ink-muted", dark ? "#FFFFFF" : "#4A4F56");
      st.setProperty("--mes-qa-compare", dark ? "#FFFFFF" : "#5C6168");
      st.setProperty("--mes-qa-rule", dark ? "rgba(255,255,255,.26)" : "rgba(20,22,26,.14)");
      st.setProperty("--mes-qa-glass-ink", glassDark ? "#FFFFFF" : "#15171A");
      st.setProperty("--mes-qa-glass-ink-muted", glassDark ? "#FFFFFF" : "#2D3035");
      st.setProperty("--mes-qa-glass-ink-faint", glassDark ? "#FFFFFF" : "#3D4249");
      st.setProperty("--mes-qa-glass-rule", glassDark ? "rgba(255,255,255,.3)" : "rgba(20,22,26,.18)");
    };
    if (QuickBuyDrawer._mesQaTints[key]) { apply(QuickBuyDrawer._mesQaTints[key]); return; }
    const sample = () => {
      try {
        const w = 28, h = 28, canvas = document.createElement("canvas");
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        const d = ctx.getImageData(0, h - 5, w, 5).data;
        let r = 0, g = 0, b = 0, n = 0;
        for (let i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
        r /= n; g /= n; b /= n;
        const mix = 0.55;
        const rgb = pageDark
          ? [Math.round(r * 0.3 + 14), Math.round(g * 0.3 + 14), Math.round(b * 0.3 + 14)]
          : [Math.round(r + (255 - r) * mix), Math.round(g + (255 - g) * mix), Math.round(b + (255 - b) * mix)];
        QuickBuyDrawer._mesQaTints[key] = rgb;
        apply(rgb);
      } catch (e) { /* CORS or decode failure: keep the paper fallback */ }
    };
    if (img.complete && img.naturalWidth) { sample(); } else { img.addEventListener("load", sample, { once: true }); }
  }

  _mesQaSpec() {
    const values = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((el) => el.value);
    if (!values.length) { return ""; }
    const last = values[values.length - 1];
    return values.length > 1 ? `${values.slice(0, -1).join(" · ")} · Size ${last}` : values[0];
  }

  
  static mesQaGetRemembered() {
    try { return JSON.parse(sessionStorage.getItem("mes-qa-remembered") || "null"); } catch (e) { return null; }
  }
  static mesQaSetRemembered(selections) {
    try {
      if (selections && Object.keys(selections).length) { sessionStorage.setItem("mes-qa-remembered", JSON.stringify(selections)); }
    } catch (e) { /* storage unavailable: no one-tap this session */ }
  }

  static async mesQaCollectSections() {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }));
    return sections;
  }

  
  static async mesQaAddVariant(variantId, blockCartDrawerOpening, source) {
    const sections = await QuickBuyDrawer.mesQaCollectSections();
    
    api.withCartJsonSection(sections);
    
    const item = { id: Number(variantId), quantity: 1 };
    if (source) { item.properties = { _mes_source: source }; }
    
    const opensDrawer = blockCartDrawerOpening === false;
    if (opensDrawer) {
      document.documentElement.dispatchEvent(new CustomEvent("mes-cart:adding", { bubbles: true, detail: { blockCartDrawerOpening: false } }));
    }
    let response, responseJson, cartContent;
    try {
      response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: [item], sections: sections.join(","), sections_url: `${Shopify.routes.root}variants/${variantId}` })
      });
      api.invalidateCartRead();
      responseJson = await response.json();
      if (!response.ok) { throw new Error(responseJson.description || responseJson.message || "add failed"); }
      cartContent = await api.cartAfterAdd(responseJson, { cache: "no-store" });
    } catch (error) {
      if (opensDrawer) { document.documentElement.dispatchEvent(new CustomEvent("mes-cart:add-failed", { bubbles: true })); }
      throw error;
    }
    document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: { items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson], cart: cartContent, blockCartDrawerOpening: blockCartDrawerOpening !== false }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: "variant:add", cart: cartContent }
    }));
    return cartContent;
  }

  static async mesQaOneTap(button, drawer) {
    const remembered = QuickBuyDrawer.mesQaGetRemembered();
    const handle = drawer.getAttribute("handle");
    if (!remembered || !handle) { return false; }
    let product;
    try { product = await (await fetch(`${Shopify.routes.root}products/${handle}.js`)).json(); } catch (e) { return false; }
    const keys = Object.keys(remembered).filter((k) => /^option[123]$/.test(k));
    if (!product || !product.variants || (product.options || []).length !== keys.length) { return false; }
    const variant = product.variants.find((v) => v.available && keys.every((k) => v[k] === remembered[k]));
    if (!variant) { return false; }
    
    if ((variant.options || []).some((o) => /personali[sz]/i.test(String(o)))) { return false; }
    
    const lastSpec = (variant.options || []).map((v, i) => /size/i.test(String(((product.options || [])[i] || {}).name || (product.options || [])[i] || "")) ? `Size ${v}` : v).join(" · ");
    QuickBuyDrawer.mesQaAsk({
      title: "Same as your last pick?",
      spec: lastSpec,
      repeat: () => QuickBuyDrawer.mesQaOneTapAdd(button, drawer, variant, lastSpec),
      change: () => drawer.show()
    }, button);
    return true;
  }

  static async mesQaOneTapAdd(button, drawer, variant, spec) {
    button.setAttribute("aria-busy", "true");
    try {
      const sourceHost = drawer.getAttribute("data-mes-source") ? drawer : button.closest("[data-mes-source]");
      await QuickBuyDrawer.mesQaAddVariant(variant.id, true, sourceHost ? sourceHost.getAttribute("data-mes-source") : "");
      QuickBuyDrawer.mesQaToast(spec, 3200);
      return true;
    } catch (e) {
      drawer.show();
      return false;
    } finally {
      button.removeAttribute("aria-busy");
    }
  }

  static mesQaProductIdFor(button) {
    const id = button.getAttribute("aria-controls") || "";
    const tail = id.split("-").pop();
    return /^\d+$/.test(tail) ? Number(tail) : null;
  }

  static async mesQaRefreshCartState() {
    if (!document.querySelector('button[aria-controls^="quick-buy-"]')) { return; }
    let cart;
    try { cart = await (await fetch(`${Shopify.routes.root}cart.js`, { cache: "no-store" })).json(); } catch (e) { return; }
    QuickBuyDrawer._mesQaCart = cart;
    QuickBuyDrawer.mesQaPaintCartState(cart);
  }

  static mesQaPaintCartState(cart) {
    const qtyByProduct = {};
    (cart.items || []).forEach((item) => { qtyByProduct[item.product_id] = (qtyByProduct[item.product_id] || 0) + item.quantity; });
    document.querySelectorAll('button[aria-controls^="quick-buy-"]').forEach((button) => {
      const productId = QuickBuyDrawer.mesQaProductIdFor(button);
      if (!productId) { return; }
      const qty = qtyByProduct[productId] || 0;
      let stepper = button.parentElement.querySelector(`[data-mes-qa-stepper="${productId}"]`);
      if (qty > 0 && !stepper) {
        stepper = document.createElement("div");
        stepper.className = "mes-qa-stepper";
        stepper.setAttribute("data-mes-qa-stepper", String(productId));
        stepper.innerHTML = `<button type="button" class="mes-qa-stepper__btn" data-mes-qa-dec aria-label="Decrease quantity"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg></button><span class="mes-qa-stepper__qty" data-mes-qa-qty></span><button type="button" class="mes-qa-stepper__btn" data-mes-qa-inc aria-label="Increase quantity"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>`;
        stepper.querySelector("[data-mes-qa-dec]").addEventListener("click", () => QuickBuyDrawer.mesQaStep(productId, -1, stepper));
        stepper.querySelector("[data-mes-qa-inc]").addEventListener("click", (e) => QuickBuyDrawer.mesQaAskStep(productId, stepper, button, e.currentTarget));
        button.insertAdjacentElement("afterend", stepper);
      }
      if (stepper) {
        stepper.hidden = qty === 0;
        const qtyEl = stepper.querySelector("[data-mes-qa-qty]");
        if (qtyEl) { qtyEl.textContent = String(qty); }
      }
      if (qty > 0) { button.setAttribute("data-mes-qa-in-cart", ""); } else { button.removeAttribute("data-mes-qa-in-cart"); }
    });
  }

  
  static async mesQaStep(productId, dir, stepper) {
    
    if (QuickBuyDrawer._mesQaStepBusy) { return; }
    const cart = QuickBuyDrawer._mesQaCart;
    const line = (cart?.items || []).find((item) => item.product_id === productId);
    if (!line) { return QuickBuyDrawer.mesQaRefreshCartState(); }
    const target = Math.max(0, line.quantity + dir);
    QuickBuyDrawer._mesQaStepBusy = true;
    stepper.querySelectorAll("button").forEach((b) => b.setAttribute("aria-busy", "true"));
    try {
      const sections = await QuickBuyDrawer.mesQaCollectSections();
      const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: line.key, quantity: target, sections: sections.join(",") })
      });
      const type = (res.headers.get("content-type") || "").toLowerCase();
      if (!res.ok || type.indexOf("html") !== -1) { return; }
      const cartContent = await res.json();
      QuickBuyDrawer._mesQaCart = cartContent;
      QuickBuyDrawer.mesQaPaintCartState(cartContent);
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "line-item:change", cart: cartContent } }));
    } catch (e) {
      /* leave the cart as the server has it */
    } finally {
      QuickBuyDrawer._mesQaStepBusy = false;
      stepper.querySelectorAll("button").forEach((b) => b.removeAttribute("aria-busy"));
      QuickBuyDrawer.mesQaRefreshCartState();
    }
  }

  static mesQaBoot() {
    if (QuickBuyDrawer._mesQaBooted) { return; }
    QuickBuyDrawer._mesQaBooted = true;
    
    try { QuickBuyDrawer._mesQaSectionId = sessionStorage.getItem("mes-qa-section-id") || null; } catch (e) { QuickBuyDrawer._mesQaSectionId = null; }
    
    document.addEventListener("click", (event) => {
      const button = event.target.closest && event.target.closest('button[aria-controls^="quick-buy-"]');
      if (!button || button.hasAttribute("aria-busy")) { return; }
      const drawer = document.getElementById(button.getAttribute("aria-controls"));
      if (!drawer || drawer.open) { return; }
      
      const card = button.closest("[data-mhc-card]");
      const pick = card && card.getAttribute("data-mes-sw-pick");
      if (pick) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const cut = pick.indexOf("|");
        QuickBuyDrawer.mesQaOpenWith(drawer, [[pick.slice(0, cut), pick.slice(cut + 1)]]);
        return;
      }
      if (!QuickBuyDrawer.mesQaGetRemembered()) { return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      QuickBuyDrawer.mesQaOneTap(button, drawer).then((added) => { if (!added) { drawer.show(); } });
    }, true);
    
    document.addEventListener("click", (event) => {
      const sw = event.target.closest && event.target.closest("[data-mhc-sw-value]");
      if (!sw) { return; }
      event.preventDefault();
      const card = sw.closest("[data-mhc-card]"), row = sw.closest("[data-mhc-sw]");
      if (!card || !row) { return; }
      row.querySelectorAll("[data-mhc-sw-value]").forEach((b) => b.setAttribute("aria-pressed", b === sw ? "true" : "false"));
      const pos = row.getAttribute("data-opt"), value = sw.getAttribute("data-mhc-sw-value");
      card.setAttribute("data-mes-sw-pick", `${pos}|${value}`);
      
      const toggle = card.querySelector("[aria-controls^='quick-buy-']");
      const drawer = toggle && document.getElementById(toggle.getAttribute("aria-controls"));
      if (drawer && !drawer.open && drawer.preload) { QuickBuyDrawer.mesQaApplyPicks(drawer, [[pos, value]]).catch(() => {}); }
      QuickBuyDrawer.mesQaSwapCardPhoto(card, sw.getAttribute("data-img"));
    });
    
    const preloadFor = (event) => {
      const button = event.target.closest && event.target.closest('button[aria-controls^="quick-buy-"]');
      const drawer = button && document.getElementById(button.getAttribute("aria-controls"));
      if (drawer && !drawer._hasLoaded && drawer.preload) { drawer.preload().catch(() => {}); }
    };
    document.addEventListener("mouseover", preloadFor, { passive: true });
    document.addEventListener("touchstart", preloadFor, { passive: true });
    ["variant:add", "cart:change", "cart:refresh"].forEach((name) => document.addEventListener(name, () => QuickBuyDrawer.mesQaRefreshCartState()));
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", () => QuickBuyDrawer.mesQaRefreshCartState()); } else { QuickBuyDrawer.mesQaRefreshCartState(); }
  }

  
  static mesQaSwapCardPhoto(card, src) {
    const img = card.querySelector(".mhc-card__imgbox img");
    if (!img || !src || img.getAttribute("src") === src) { return; }
    const token = (card._mesSwTok = (card._mesSwTok || 0) + 1);
    const pre = new Image();
    pre.crossOrigin = "anonymous";
    pre.decoding = "async";
    pre.alt = "";
    pre.onload = () => {
      if (card._mesSwTok !== token) { return; }
      const box = img.parentElement, veil = card.querySelector("[data-veil]");
      card.querySelectorAll(".mhc-card__swfade").forEach((el) => el.remove());
      const oldVeil = veil ? veil.style.background : "";
      card.dispatchEvent(new CustomEvent("mhc:resample", { detail: pre }));
      const newVeil = veil ? veil.style.background : "";
      if (veil) { veil.style.background = oldVeil; }
      const layer = document.createElement("div");
      layer.className = "mhc-card__swfade";
      layer.setAttribute("aria-hidden", "true");
      layer.appendChild(pre);
      if (newVeil) { const v = document.createElement("div"); v.className = "mhc-card__swveil"; v.style.background = newVeil; layer.appendChild(v); }
      (veil && veil.parentElement === box ? veil : img).insertAdjacentElement("afterend", layer);
      const settle = () => {
        if (card._mesSwTok !== token) { layer.remove(); return; }
        img.removeAttribute("srcset");
        img.setAttribute("src", src);
        if (veil && newVeil) { veil.style.background = newVeil; }
        const drop = () => { if (layer.isConnected) { layer.remove(); } };
        (img.decode ? img.decode() : Promise.resolve()).then(drop, drop);
      };
      requestAnimationFrame(() => requestAnimationFrame(() => { layer.style.opacity = "1"; }));
      let done = false;
      const once = () => { if (!done) { done = true; settle(); } };
      layer.addEventListener("transitionend", once, { once: true });
      setTimeout(once, 600);
    };
    pre.src = src;
  }

  
  static async mesQaApplyPicks(drawer, picks) {
    const key = JSON.stringify(picks || []);
    try { await drawer.preload(); } catch (e) { return false; }
    
    const picker = drawer.querySelector("variant-picker");
    for (let i = 0; picker && !picker.product && i < 100; i++) { await new Promise((r) => setTimeout(r, 50)); }
    await new Promise((r) => requestAnimationFrame(() => setTimeout(r, 0)));
    (picks || []).forEach(([pos, value]) => {
      const input = Array.from(drawer.querySelectorAll(`input[type="radio"][name="option${pos}"]`)).find((r) => r.value === value);
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event("change", { bubbles: true })); }
    });
    drawer._mesPicked = key;
    
    if (!drawer._mesPickWatch) {
      drawer._mesPickWatch = true;
      drawer.addEventListener("change", (e) => { if (e.isTrusted) { drawer._mesPicked = null; } });
    }
    return true;
  }
  static async mesQaOpenWith(drawer, picks) {
    const key = JSON.stringify(picks || []);
    
    if (drawer._hasLoaded && drawer._mesPicked === key) { drawer.show(); return; }
    
    drawer.classList.add("mes-qa-picking");
    drawer.show();
    try { await QuickBuyDrawer.mesQaApplyPicks(drawer, picks); } finally { drawer.classList.remove("mes-qa-picking"); }
  }

  
  static mesQaAskStep(productId, stepper, button, anchor) {
    const cart = QuickBuyDrawer._mesQaCart;
    const line = (cart?.items || []).find((item) => item.product_id === productId);
    if (!line || line.product_has_only_default_variant) { return QuickBuyDrawer.mesQaStep(productId, 1, stepper); }
    const drawer = document.getElementById(button.getAttribute("aria-controls") || "");
    const spec = (line.options_with_values || []).map((o) => /size/i.test(o.name) ? `Size ${o.value}` : o.value).join(" · ");
    QuickBuyDrawer.mesQaAsk({
      title: "Add one more?",
      spec,
      repeat: () => QuickBuyDrawer.mesQaStep(productId, 1, stepper),
      change: drawer ? () => QuickBuyDrawer.mesQaOpenWith(drawer, (line.options_with_values || []).map((o, i) => [String(i + 1), o.value])) : null
    }, anchor);
  }

  static mesQaAsk(opts, anchor) {
    let ask = document.querySelector(".mes-qa-ask");
    if (!ask) {
      ask = document.createElement("div");
      ask.className = "mes-qa-ask";
      ask.setAttribute("role", "dialog");
      ask.setAttribute("aria-label", "Add one more");
      document.body.appendChild(ask);
      document.addEventListener("pointerdown", (e) => { if (!ask.hidden && !ask.contains(e.target) && !e.target.closest("[data-mes-qa-inc]")) { ask.hidden = true; } }, true);
      document.addEventListener("keydown", (e) => { if (e.key === "Escape") { ask.hidden = true; } });
      window.addEventListener("scroll", () => { if (!ask.hidden && ask.classList.contains("is-anchored")) { ask.hidden = true; } }, { passive: true });
    }
    ask.innerHTML = `<div class="mes-qa-ask__card"><span class="mes-qa-ask__text"><span class="mes-qa-ask__title"></span><span class="mes-qa-ask__spec"></span></span><span class="mes-qa-ask__btns"><button type="button" class="mes-qa-ask__change" data-ask-change>Change</button><button type="button" class="mes-qa-ask__repeat" data-ask-repeat>Repeat</button></span></div>`;
    ask.querySelector(".mes-qa-ask__title").textContent = opts.title;
    ask.querySelector(".mes-qa-ask__spec").textContent = opts.spec || "";
    const change = ask.querySelector("[data-ask-change]");
    if (!opts.change) { change.remove(); }
    change.addEventListener("click", () => { ask.hidden = true; opts.change?.(); });
    ask.querySelector("[data-ask-repeat]").addEventListener("click", () => { ask.hidden = true; opts.repeat(); });
    ask.hidden = false;
    
    const card = ask.querySelector(".mes-qa-ask__card");
    ask.classList.toggle("is-anchored", !!(anchor && anchor.getBoundingClientRect));
    if (anchor && anchor.getBoundingClientRect) {
      const r = anchor.getBoundingClientRect(), vw = document.documentElement.clientWidth, w = Math.min(340, vw - 24);
      const left = Math.max(12, Math.min(vw - w - 12, r.left + r.width / 2 - w / 2));
      card.style.cssText = `position:fixed;top:0;left:${Math.round(left)}px;width:${w}px;visibility:hidden;`;
      const h = card.offsetHeight || 76;
      const top = r.top - h - 10 >= 12 ? r.top - h - 10 : r.bottom + 10;
      card.style.top = `${Math.round(top)}px`;
      card.style.visibility = "";
    }
    try { ask.querySelector("[data-ask-repeat]").focus({ preventScroll: true }); } catch (e) { /* focus is a nicety */ }
  }

  static mesQaToast(spec, dwell) {
    let toast = document.querySelector(".mes-qa-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "mes-qa-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.innerHTML = `<div class="mes-qa-toast__card"><span class="mes-qa-toast__tick"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 5 5L19.5 7"/></svg></span><span class="mes-qa-toast__text"><span class="mes-qa-toast__title">Added to your cart!</span>${spec ? `<span class="mes-qa-toast__spec"></span>` : ""}</span></div>`;
    if (spec) { toast.querySelector(".mes-qa-toast__spec").textContent = spec; }
    toast.hidden = false;
    clearTimeout(QuickBuyDrawer._mesQaToastTimer);
    QuickBuyDrawer._mesQaToastTimer = setTimeout(() => { toast.hidden = true; }, dwell || 3200);
  }
};
if (!window.customElements.get("quick-buy-drawer")) {
  window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
}
QuickBuyDrawer.mesQaBoot();


var MesCartOffer = (() => {
  let cfg, lastKey = "", scheduled = false, painted = new Set();
  const config = () => {
    if (cfg !== undefined) { return cfg; }
    try { cfg = JSON.parse(document.querySelector("[data-mes-cart-offer]")?.textContent || "null"); } catch (e) { cfg = null; }
    return cfg;
  };
  const rate = () => { const r = Number(config()?.rate); return r > 0 && r < 100 ? r : 0; };
  const cart = () => {
    const m = document.querySelector("[data-mes-cart-covered]");
    if (!m) { return null; }
    return { count: parseInt(m.dataset.count, 10) || 0, original: parseInt(m.dataset.original, 10) || 0, other: parseInt(m.dataset.other, 10) || 0, items: parseInt(m.dataset.items, 10) || 0, units: m.dataset.units || "" };
  };
  const active = () => { const c = config(), k = cart(); return !!(c && c.priceDisplay && rate() && k && k.count >= 1); };
  const label = () => String(config()?.label || "{pct}% cart offer").replace("{pct}", String(rate()));
  const setMoney = (el, cents) => {
    const keep = el.querySelector(":scope > .sr-only");
    const html = formatMoney(cents);
    el.replaceChildren(...(keep ? [keep] : []), document.createRange().createContextualFragment(html));
  };
  const paint = (el, force) => {
    const price = parseInt(el.getAttribute("data-mes-co-price"), 10) || 0;
    const compare = parseInt(el.getAttribute("data-mes-co-compare"), 10) || 0;
    
    const mo = window.MesOffer, cheap = !!(mo && mo.kind === "cheapest");
    const cheapNow = cheap && active() && price > 0 ? Math.round(mo.cost([price])) : price;
    const on = active() && price > 0 && (!cheap || cheapNow < price);
    const now = !on ? price : (cheap ? cheapNow : Math.round(price * (100 - rate())) / 100);
    const strike = compare > price ? compare : (on ? price : 0);
    const isCard = el.classList.contains("mhc-card__pricebox");
    const priceEl = isCard ? el.querySelector("[data-price-el]") : el.querySelector(":scope > sale-price");
    let cmpEl = isCard ? el.querySelector("[data-compare-el]") : el.querySelector(":scope > compare-at-price");
    if (!priceEl) { return; }
    const key = `${on}|${now}|${strike}|${label()}`;
    if (!force && el._mesCoKey === key && el._mesCoText === priceEl.textContent) { return; }
    if (!on && !painted.has(el)) { el._mesCoKey = key; el._mesCoText = priceEl.textContent; return; }
    setMoney(priceEl, now);
    if (!cmpEl && strike && isCard) {
      cmpEl = document.createElement("span");
      cmpEl.className = "mhc-card__compare";
      cmpEl.setAttribute("data-compare-el", "");
      priceEl.after(cmpEl);
    }
    if (cmpEl) { if (strike) { setMoney(cmpEl, strike); } cmpEl.hidden = !strike; }
    let tag = el.querySelector(":scope > .mes-co-tag");
    if (on) {
      if (!tag) { tag = document.createElement("span"); tag.className = "mes-co-tag"; el.appendChild(tag); }
      tag.textContent = label();
      painted.add(el);
    } else {
      tag?.remove();
      painted.delete(el);
    }
    el._mesCoKey = key;
    el._mesCoText = priceEl.textContent;
  };
  const applyAll = (force) => {
    scheduled = false;
    const k = JSON.stringify([active(), rate(), cart()]);
    const changed = k !== lastKey;
    lastKey = k;
    if (active() || painted.size || force || changed) {
      document.querySelectorAll("[data-mes-co]").forEach((el) => paint(el, force || changed));
    }
    if (changed) { document.dispatchEvent(new CustomEvent("mes:cart-offer-change", { detail: { active: active(), rate: rate(), cart: cart() } })); }
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => applyAll(false)); } };
  const boot = () => {
    applyAll(true);
    
    new MutationObserver((records) => {
      for (const r of records) {
        for (const n of r.addedNodes) {
          if (n.nodeType === 1 && (n.matches("[data-mes-co],[data-mes-cart-covered]") || n.querySelector("[data-mes-co],[data-mes-cart-covered]"))) { schedule(); return; }
        }
        if (painted.size && r.target && r.target.closest && r.target.closest("[data-mes-co]")) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    
    document.addEventListener("variant:change", (event) => {
      
      const form = event.target, variant = event.detail && event.detail.variant;
      const formId = form && form.getAttribute ? form.getAttribute("id") : "";
      if (!formId || !variant) { return; }
      document.querySelectorAll(`[data-mes-co][data-mes-co-form="${CSS.escape(formId)}"]`).forEach((el) => {
        el.setAttribute("data-mes-co-price", String(variant.price || 0));
        el.setAttribute("data-mes-co-compare", String(variant.compare_at_price || 0));
        paint(el, true);
      });
    });
    ["cart:change", "variant:add", "cart:refresh"].forEach((name) => document.addEventListener(name, () => { schedule(); setTimeout(schedule, 450); }));
  };
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", boot); } else { boot(); }
  return { config, rate, cart, active, label };
})();
window.MesCartOffer = MesCartOffer;


(function () {
  let offer = null;
  const readOffer = () => {
    if (offer) { return offer; }
    try { offer = JSON.parse(document.querySelector("[data-mes-cart-offer]")?.textContent || "null"); } catch (e) { offer = null; }
    return offer || { rate: 0, excluded: [] };
  };
  const colourIndex = (options) => (options || []).findIndex((o) => {
    const name = (typeof o === "string" ? o : (o && o.name) || "").trim().toLowerCase();
    return name === "colour" || name === "color";
  });
  const dataFor = (bump) => {
    if (bump._mesBumpData !== undefined) { return bump._mesBumpData; }
    try { bump._mesBumpData = JSON.parse(bump.querySelector("[data-mes-bump-variants]")?.textContent || "null"); } catch (e) { bump._mesBumpData = null; }
    return bump._mesBumpData;
  };
  
  let cartCount = null;
  const setCartCount = (cart) => { if (cart && typeof cart.item_count === "number") { cartCount = cart.item_count; renderAll(); } };
  const markerCount = () => { const k = window.MesCartOffer && window.MesCartOffer.cart(); return k ? k.items : null; };
  const render = (bump, colour, mainPrice) => {
    if (typeof mainPrice === "number") { bump.setAttribute("data-main-price", String(mainPrice)); }
    const data = dataFor(bump);
    if (!data || !data.variants || !data.variants.length) { return; }
    let pick = data.variants.find((v) => String(v.id) === bump.getAttribute("data-bump-variant-id"));
    if (data.colourMatch && typeof colour === "string") {
      const wanted = colour.trim().toLowerCase();
      pick = (wanted && data.variants.find((v) => v.available && v.colour === wanted)) || data.variants.find((v) => v.id === data.default) || data.variants[0];
    }
    if (!pick) { return; }
    const { rate, excluded } = readOffer();
    const blocked = (list) => (list || []).some((h) => (excluded || []).indexOf(h) !== -1);
    
    const covered = (flag, list) => (flag === "1" ? true : flag === "0" ? false : !blocked(list));
    const mo = window.MesOffer, cheap = !!(mo && mo.kind === "cheapest");
    const bumpCov = covered(data.bumpCovered, data.bumpCollections), mainCov = covered(data.mainCovered, data.mainCollections);
    const mainP = parseInt(bump.getAttribute("data-main-price"), 10) || 0;
    
    const discounted = rate > 0 && rate < 100 && bumpCov && (cheap || mainCov);
    const now = !discounted ? pick.price : (cheap ? Math.min(pick.price, Math.round(mo.cost([pick.price], mo.cartUnits().concat(mainCov && mainP ? [mainP] : [])))) : Math.round(pick.price * (100 - rate)) / 100);
    
    const strike = pick.compare > pick.price ? pick.compare : (discounted && now < pick.price ? pick.price : 0);
    const save = strike > now ? strike - now : 0;
    bump.setAttribute("data-bump-variant-id", String(pick.id));
    bump.querySelectorAll("[data-mes-bump-opt]").forEach((b) => b.setAttribute("aria-pressed", String(b.getAttribute("data-mes-bump-opt") === pick.colour)));
    const img = bump.querySelector("[data-mes-bump-img]");
    if (img && pick.img && img.getAttribute("src") !== pick.img) { img.src = pick.img; }
    const price = bump.querySelector("[data-mes-bump-price]");
    if (price) { price.innerHTML = formatMoney(now); }
    const compare = bump.querySelector("[data-mes-bump-compare]");
    if (compare) { compare.innerHTML = strike ? formatMoney(strike) : ""; compare.hidden = !strike; }
    const tag = bump.querySelector("[data-mes-bump-tag]");
    const main = parseInt(bump.getAttribute("data-main-price"), 10);
    if (tag && cartCount === 0 && main > 0) {
      const mainNow = cheap ? main : (discounted ? Math.round(main * (100 - rate)) / 100 : main);
      tag.innerHTML = `Get both for just ${formatMoney(Math.round(mainNow + now))}`;
      tag.hidden = false;
    } else if (tag) {
      tag.innerHTML = save ? `Add &amp; save ${formatMoney(save)}` : "";
      tag.hidden = !save;
    }
  };
  const pageBumps = () => Array.from(document.querySelectorAll(".mes-pdp3 [data-mes-bump]")).filter((b) => !b.closest("quick-buy-drawer"));
  function renderAll() { pageBumps().forEach((bump) => render(bump)); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", renderAll); } else { renderAll(); }
  if (pageBumps().length) {
    
    const fromMarker = markerCount();
    if (fromMarker !== null) { setCartCount({ item_count: fromMarker }); }
    else { fetch(`${Shopify.routes.root}cart.js`, { cache: "no-store" }).then((r) => (r.ok ? r.json() : null)).then(setCartCount).catch(() => {}); }
    document.addEventListener("mes:cart-offer-change", () => { const n = markerCount(); if (n !== null) { setCartCount({ item_count: n }); } });
    ["cart:change", "variant:add", "cart:refresh"].forEach((name) => document.addEventListener(name, (event) => {
      const cart = event.detail && event.detail.cart;
      if (cart && typeof cart.item_count === "number") { setCartCount(cart); }
    }));
  }
  document.addEventListener("variant:change", (event) => {
    if (event.target.closest && event.target.closest("quick-buy-drawer")) { return; }
    const product = event.detail && event.detail.product, variant = event.detail && event.detail.variant;
    if (!product || !variant) { return; }
    const idx = colourIndex(product.options);
    const colour = idx >= 0 ? (variant.options || [])[idx] : undefined;
    pageBumps().forEach((bump) => render(bump, colour, typeof variant.price === "number" ? variant.price : undefined));
  });
  
  document.addEventListener("click", (event) => {
    const chip = event.target.closest && event.target.closest("[data-mes-bump-opt]");
    if (!chip || chip.disabled) { return; }
    event.preventDefault();
    const bump = chip.closest("[data-mes-bump]"), data = bump && dataFor(bump);
    if (!data || !data.variants) { return; }
    const wanted = chip.getAttribute("data-mes-bump-opt");
    const pick = data.variants.find((v) => v.available && v.colour === wanted);
    if (!pick) { return; }
    bump.setAttribute("data-bump-variant-id", String(pick.id));
    render(bump);
    const toggle = bump.querySelector("[data-mes-bump-toggle]");
    if (toggle && !toggle.checked) { toggle.checked = true; toggle.dispatchEvent(new Event("change", { bubbles: true })); }
  });
  
  document.addEventListener("mes:bump-host-price", (event) => {
    const price = event.detail && event.detail.price;
    if (typeof price === "number") { pageBumps().forEach((bump) => render(bump, undefined, price)); }
  });
})();



(function () {
  if (window.__mesSageBar) { return; }
  window.__mesSageBar = true;
  const sageBtn = () => {
    const b = document.getElementById("sagepilot-outofstock-button");
    return b && b.isConnected && b.style.display !== "none" ? b : null;
  };
  const sync = () => {
    const sage = sageBtn();
    document.querySelectorAll("product-quick-add buy-buttons").forEach((bb) => {
      const src = bb.querySelector('button[type="submit"]');
      let mirror = bb.querySelector("[data-mes-notify]");
      if (!src) { return; }
      if (sage) {
        if (!mirror) {
          mirror = document.createElement("button");
          mirror.type = "button";
          mirror.setAttribute("data-mes-notify", "");
          mirror.className = src.className.replace(/\bbutton--subdued\b/, "").trim();
          mirror.setAttribute("style", src.getAttribute("style") || "");
          mirror.addEventListener("click", (e) => { e.preventDefault(); const s = sageBtn(); if (s) { s.click(); } });
          src.after(mirror);
        }
        mirror.textContent = (sage.textContent || "").trim() || "Notify Me";
        src.hidden = true;
      } else if (mirror) {
        mirror.remove();
        src.hidden = false;
      }
    });
    
    document.querySelectorAll('[data-mes-sage-hid]').forEach((b) => { if (!sage || b.form !== sage.form) { b.hidden = false; b.removeAttribute("data-mes-sage-hid"); } });
    if (sage && sage.form) {
      Array.from(sage.form.querySelectorAll('button[type="submit"]')).forEach((b) => { if (b.disabled && !b.hidden) { b.hidden = true; b.setAttribute("data-mes-sage-hid", ""); } });
    }
  };
  const later = () => { sync(); setTimeout(sync, 400); setTimeout(sync, 1500); };
  const boot = () => {
    if (!document.querySelector("[data-sagepilot-oos]") || !document.querySelector("product-quick-add buy-buttons")) { return; }
    later();
    document.addEventListener("variant:change", later);
    const host = document.querySelector('.mes-pdp3 .product-info__buy-buttons form[action*="/cart/add"], form[action*="/cart/add"]');
    if (host && window.MutationObserver) { new MutationObserver(sync).observe(host, { childList: true }); }
    window.addEventListener("load", later);
  };
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", boot); } else { boot(); }
})();


(function () {
  
  if (window.__mesBumpGallery) { return; }
  window.__mesBumpGallery = true;
  let state = null;
  const reduced = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const pathOf = (u) => { try { return new URL(u, location.href).pathname; } catch (e) { return String(u); } };
  const square = (r) => { const size = Math.min(r.width, r.height); return { left: r.left + (r.width - size) / 2, top: r.top + (r.height - size) / 2, width: size, height: size }; };
  const between = (from, to) => `translate(${from.left - to.left}px, ${from.top - to.top}px) scale(${from.width / to.width}, ${from.height / to.height})`;
  const flyAt = (rect, src) => {
    const fly = document.createElement("img");
    fly.className = "mes-bzoom__fly";
    fly.alt = "";
    fly.src = src;
    Object.assign(fly.style, { left: `${rect.left}px`, top: `${rect.top}px`, width: `${rect.width}px`, height: `${rect.height}px` });
    document.body.appendChild(fly);
    return fly;
  };
  const index = (track) => Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));

  async function openGallery(bump, thumb) {
    if (state) { return; }
    let data = null;
    try { data = bump ? JSON.parse(bump.querySelector("[data-mes-bump-variants]")?.textContent || "null") : null; } catch (e) { data = null; }
    const thumbSrc = thumb.currentSrc || thumb.src;
    let images = (data && data.images && data.images.length ? data.images.slice() : []);
    
    if (!bump) { try { images = JSON.parse(thumb.getAttribute("data-mes-zoom-images") || "[]"); } catch (e) { images = []; } }
    let start = images.findIndex((src) => pathOf(src) === pathOf(thumbSrc));
    if (start < 0) { images.unshift(thumbSrc.replace(/([?&])width=\d+/, "$1width=1200")); start = 0; }
    else if (data && data.variants) {
      
      const variantPaths = new Set(data.variants.map((v) => pathOf(v.img)));
      const own = pathOf(thumbSrc);
      const end = images.findIndex((src, i) => i > start && variantPaths.has(pathOf(src)) && pathOf(src) !== own);
      images = images.slice(start, end < 0 ? undefined : end);
      start = 0;
    }
    const title = thumb.getAttribute("alt") || "";
    
    let info = null;
    try { info = JSON.parse(thumb.getAttribute("data-mes-zoom-info") || "null"); } catch (e) { info = null; }
    const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
    const infoHtml = info && info.title ? `<div class="mes-bzoom__info"><div class="mes-bzoom__info-head"><p class="mes-bzoom__info-title">${esc(info.title)}</p><p class="mes-bzoom__info-price">${info.worth ? `<s>${esc(info.worth)}</s>` : ""}<b>FREE</b></p></div>${info.note ? `<p class="mes-bzoom__info-note">${esc(info.note)}</p>` : ""}${info.features && info.features.length ? `<div class="mes-bzoom__info-cards">${info.features.map((f) => `<div class="mes-bzoom__info-card"><b>${esc(f.t)}</b>${f.d ? `<span>${esc(f.d)}</span>` : ""}</div>`).join("")}</div>` : ""}</div>` : "";

    const root = document.createElement("div");
    root.className = `mes-bzoom${images.length > 1 ? " mes-bzoom--multi" : ""}${infoHtml ? " mes-bzoom--info" : ""}`;
    root.setAttribute("role", "dialog");
    root.setAttribute("data-mes-overlay", "");
    root.setAttribute("aria-modal", "true");
    root.setAttribute("aria-label", title ? `Photos of ${title}` : "Photos");
    root.tabIndex = -1;
    const chevron = (d) => `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
    root.innerHTML = `<div class="mes-bzoom__scrim"></div><div class="mes-bzoom__track">${images.map((src, i) => `<div class="mes-bzoom__slide"><img src="${src}" alt="${title.replace(/"/g, "&quot;")}" draggable="false" decoding="async"${Math.abs(i - start) > 1 ? ' loading="lazy"' : ""}></div>`).join("")}</div>${images.length > 1 ? `<div class="mes-bzoom__dots">${images.map(() => "<span></span>").join("")}</div><button type="button" class="mes-bzoom__nav mes-bzoom__nav--prev" data-bz-step="-1" aria-label="Previous photo">${chevron("M15 18l-6-6 6-6")}</button><button type="button" class="mes-bzoom__nav mes-bzoom__nav--next" data-bz-step="1" aria-label="Next photo">${chevron("M9 6l6 6-6 6")}</button>` : ""}${infoHtml}`;
    document.body.appendChild(root);
    const html = document.documentElement, prevOverflow = html.style.overflow;
    html.style.overflow = "hidden";
    const track = root.querySelector(".mes-bzoom__track"), scrim = root.querySelector(".mes-bzoom__scrim");
    const slides = Array.from(track.querySelectorAll("img"));
    const dots = Array.from(root.querySelectorAll(".mes-bzoom__dots span"));
    const paintDots = () => { const i = index(track); dots.forEach((d, k) => d.classList.toggle("is-on", k === i)); };
    track.scrollLeft = start * track.clientWidth;
    paintDots();
    track.addEventListener("scroll", () => requestAnimationFrame(paintDots), { passive: true });
    state = { bump, thumb, root, track, scrim, slides, prevOverflow, closing: false };

    const onKey = (e) => {
      if (e.key === "Escape") { e.preventDefault(); e.stopImmediatePropagation(); closeGallery(); }
      else if (e.key === "ArrowRight" || e.key === "ArrowLeft") { track.scrollBy({ left: (e.key === "ArrowRight" ? 1 : -1) * track.clientWidth, behavior: "smooth" }); }
    };
    state.onKey = onKey;
    
    window.addEventListener("keydown", onKey, true);
    root.addEventListener("click", (e) => {
      const step = e.target.closest("[data-bz-step]");
      if (step) { track.scrollBy({ left: Number(step.dataset.bzStep) * track.clientWidth, behavior: "smooth" }); return; }
      if (e.target.closest(".mes-bzoom__slide img, .mes-bzoom__info")) { return; }
      closeGallery();
    });

    const target = slides[start];
    await Promise.race([target.decode ? target.decode().catch(() => {}) : Promise.resolve(), new Promise((r) => setTimeout(r, 140))]);
    root.focus({ preventScroll: true });
    if (reduced()) {
      root.classList.add("is-in");
      scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 150, fill: "forwards" });
      return;
    }
    const to = square(target.getBoundingClientRect()), from = thumb.getBoundingClientRect();
    const fly = flyAt(to, target.complete && target.naturalWidth ? target.currentSrc || target.src : thumbSrc);
    thumb.style.visibility = "hidden";
    scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: "ease-out", fill: "forwards" });
    
    const restR = root.classList.contains("mes-bzoom--info") ? "18px" : "0px";
    await fly.animate([{ transform: between(from, to), borderRadius: "40px" }, { transform: "none", borderRadius: restR }], { duration: 400, easing: "cubic-bezier(.2,.85,.25,1)" }).finished.catch(() => {});
    root.classList.add("is-in");
    requestAnimationFrame(() => fly.remove());
  }

  async function closeGallery() {
    if (!state || state.closing) { return; }
    state.closing = true;
    const { thumb, root, track, scrim, slides, prevOverflow, onKey } = state;
    window.removeEventListener("keydown", onKey, true);
    const finish = () => {
      thumb.style.visibility = "";
      root.remove();
      document.documentElement.style.overflow = prevOverflow;
      if (thumb.isConnected) { thumb.focus({ preventScroll: true }); }
      state = null;
    };
    if (reduced() || !thumb.isConnected) {
      root.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150 }).finished.then(finish, finish);
      return;
    }
    const img = slides[index(track)] || slides[0];
    const from = square(img.getBoundingClientRect()), to = thumb.getBoundingClientRect();
    const fly = flyAt(from, img.currentSrc || img.src);
    const sameAsThumb = pathOf(img.currentSrc || img.src) === pathOf(thumb.currentSrc || thumb.src);
    root.classList.remove("is-in");
    scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, easing: "ease-in", fill: "forwards" });
    const restR = root.classList.contains("mes-bzoom--info") ? "18px" : "0px";
    await fly.animate([{ transform: "none", borderRadius: restR }, { transform: between(to, from), borderRadius: "40px" }], { duration: 340, easing: "cubic-bezier(.4,0,.2,1)", fill: "forwards" }).finished.catch(() => {});
    finish();
    if (sameAsThumb) { fly.remove(); }
    else { fly.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140 }).finished.then(() => fly.remove(), () => fly.remove()); }
  }

  const trigger = (e) => {
    const img = e.target.closest && e.target.closest("[data-mes-bump-img], img[data-mes-zoom]");
    if (!img) { return false; }
    const bump = img.hasAttribute("data-mes-bump-img") ? img.closest("[data-mes-bump]") : null;
    if (!bump && !img.hasAttribute("data-mes-zoom")) { return false; }
    e.preventDefault();
    e.stopPropagation();
    openGallery(bump, img);
    return true;
  };
  document.addEventListener("click", trigger, true);
  document.addEventListener("keydown", (e) => { if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches("[data-mes-bump-img], img[data-mes-zoom]")) { trigger(e); } }, true);
})();


window.MesQuickAddDrawer = function (handle, fallbackId, mode, source) {
  const all = Array.from(document.querySelectorAll("quick-buy-drawer")).filter((d) => d.getAttribute("handle") === handle);
  let drawer = all.find((d) => d._hasLoaded) || all[0] || null;
  
  const peek = mode === "peek";
  if (!drawer) {
    drawer = document.createElement("quick-buy-drawer");
    drawer.id = fallbackId;
    drawer.setAttribute("header-bordered", "");
    drawer.setAttribute("open-from", "bottom");
    drawer.setAttribute("handle", handle);
    drawer.setAttribute("role", "region");
    drawer.setAttribute("aria-live", "polite");
    drawer.className = "quick-buy-drawer drawer mes-pdp3 mhc-qb";
    document.body.appendChild(drawer);
  }
  if (peek) { return drawer; }
  drawer.classList.remove("or-qa-bundle", "mes-qa-edit");
  if (mode) { drawer.classList.add(mode); }
  
  if (source) {
    if (drawer._mesHomeSource === undefined) { drawer._mesHomeSource = drawer.getAttribute("data-mes-source"); }
    drawer.setAttribute("data-mes-source", source);
  }
  if (!drawer._mesModeWired) {
    drawer._mesModeWired = true;
    
    new MutationObserver(() => {
      if (drawer.hasAttribute("open")) { return; }
      clearTimeout(drawer._mesModeTimer);
      drawer._mesModeTimer = setTimeout(() => {
        if (drawer.hasAttribute("open")) { return; }
        drawer.classList.remove("or-qa-bundle", "mes-qa-edit");
        if (drawer._mesHomeSource !== undefined) {
          if (drawer._mesHomeSource) { drawer.setAttribute("data-mes-source", drawer._mesHomeSource); } else { drawer.removeAttribute("data-mes-source"); }
          drawer._mesHomeSource = undefined;
        }
      }, 450);
    }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
  }
  return drawer;
};


(function () {
  if (window.__mesCartQuickAdd) { return; }
  window.__mesCartQuickAdd = true;
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  let cssReady = null;
  const ensureCss = () => {
    if (cssReady) { return cssReady; }
    const has = Array.from(document.styleSheets).some((sheet) => { try { return /mes-quick-add\.css/.test(sheet.href || ""); } catch (e) { return false; } })
      || document.querySelector('link[href*="mes-quick-add.css"]');
    if (has) { cssReady = Promise.resolve(); return cssReady; }
    const href = window.themeVariables && window.themeVariables.mesQuickAddCss;
    if (!href) { cssReady = Promise.resolve(); return cssReady; }
    cssReady = new Promise((resolve) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = link.onerror = () => resolve();
      document.head.appendChild(link);
      setTimeout(resolve, 2500);
    });
    return cssReady;
  };
  const sectionsWanted = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }));
    return sections;
  };
  const announce = (cart) => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "line-item:change", cart } }));
  };
  const productCache = {};
  const productFor = (handle) => (productCache[handle] = productCache[handle] || fetch(`${root()}products/${handle}.js`).then((r) => r.json()));
  const selectedOptions = (drawer, count) => {
    const out = [];
    for (let i = 1; i <= count; i++) {
      const picked = Array.from(drawer.querySelectorAll(`input[type="radio"][name="option${i}"]`)).find((r) => r.checked);
      out.push(picked ? picked.value : null);
    }
    return out;
  };

  
  async function currentLine(ctx) {
    const cart = await (await fetch(`${root()}cart.js`, { cache: "no-store" })).json();
    const same = (a, b) => JSON.stringify(a || {}) === JSON.stringify(b || {});
    const line = (cart.items || []).find((it) => it.key === ctx.key) || (cart.items || []).find((it) => it.variant_id === ctx.variantId && same(it.properties, ctx.properties));
    if (line) { ctx.key = line.key; ctx.quantity = line.quantity; }
    return line || null;
  }
  async function changeLine(key, quantity) {
    const sections = sectionsWanted();
    const res = await fetch(`${root()}cart/change.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity, sections: sections.join(",") }) });
    if (!res.ok) { throw new Error("change failed"); }
    return res.json();
  }
  async function addItem(variantId, quantity, properties) {
    
    const sections = api.withCartJsonSection(sectionsWanted());
    const item = { id: Number(variantId), quantity };
    if (properties && Object.keys(properties).length) { item.properties = properties; }
    const res = await fetch(`${root()}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items: [item], sections: sections.join(","), sections_url: `${root()}variants/${variantId}` }) });
    api.invalidateCartRead();
    const json = await res.json();
    if (!res.ok) { throw new Error(json.description || json.message || "add failed"); }
    return api.cartAfterAdd(json, { cache: "no-store" });
  }

  function buildBar(drawer) {
    const footer = drawer.querySelector(".mes-qa__footer");
    if (!footer) { return null; }
    let bar = footer.querySelector("[data-mes-edit-bar]");
    if (bar) { return bar; }
    bar = document.createElement("div");
    bar.className = "mes-qa-editbar";
    bar.setAttribute("data-mes-edit-bar", "");
    bar.innerHTML = `<button type="button" class="mes-qa-editbar__another" data-edit-another>Add another</button><button type="button" class="mes-qa-editbar__change" data-edit-change>Change</button>`;
    footer.appendChild(bar);
    bar.addEventListener("click", (e) => onBarClick(drawer, e));
    drawer.addEventListener("change", () => refreshBar(drawer));
    drawer.addEventListener("input", (e) => { if (e.target.closest && e.target.closest(".product-info__property")) { refreshBar(drawer); } });
    return bar;
  }

  async function refreshBar(drawer) {
    const ctx = drawer._mesEdit, bar = drawer.querySelector("[data-mes-edit-bar]");
    if (!ctx || !bar || !drawer.classList.contains("mes-qa-edit")) { return; }
    const product = await productFor(ctx.handle);
    const chosen = selectedOptions(drawer, product.options.length);
    const variant = chosen.every((v) => v !== null) ? product.variants.find((v) => v.options.every((o, i) => o === chosen[i])) : null;
    ctx.chosen = variant;
    const usable = !!(variant && variant.available);
    
    const peek = {};
    propFields(drawer).forEach((f) => { const k = propKey(f); if (k && !f.disabled && String(f.value || "").trim()) { peek[k] = f.value.trim(); } });
    const own = {};
    propFields(drawer).forEach((f) => { const k = propKey(f); if (k && ctx.properties && ctx.properties[k] != null) { own[k] = String(ctx.properties[k]); } });
    const textChanged = JSON.stringify(peek) !== JSON.stringify(own);
    const differs = usable && (variant.id !== ctx.variantId || textChanged);
    const another = bar.querySelector("[data-edit-another]"), change = bar.querySelector("[data-edit-change]");
    another.disabled = !usable || bar.hasAttribute("aria-busy");
    change.disabled = !differs || bar.hasAttribute("aria-busy");
    change.classList.toggle("is-ready", differs);
  }

  
  function propFields(drawer) {
    return Array.from(drawer.querySelectorAll(".product-info__property [name^='properties[']"));
  }
  function propKey(field) { const m = /^properties\[(.*)\]$/.exec(field.name || ""); return m ? m[1] : null; }
  function fillProps(drawer, ctx) {
    propFields(drawer).forEach((f) => {
      const k = propKey(f);
      if (k && !f.disabled && ctx.properties && ctx.properties[k] != null && !f.value) { f.value = ctx.properties[k]; }
    });
  }
  function propsFromPopup(drawer, base) {
    const props = { ...(base || {}) };
    for (const f of propFields(drawer)) {
      const k = propKey(f);
      if (!k) { continue; }
      if (f.disabled) { delete props[k]; continue; }
      if (f.required && !String(f.value || "").trim()) { f.reportValidity(); f.focus(); return null; }
      if (String(f.value || "").trim()) { props[k] = f.value.trim(); } else { delete props[k]; }
    }
    return props;
  }

  async function onBarClick(drawer, e) {
    const ctx = drawer._mesEdit, bar = drawer.querySelector("[data-mes-edit-bar]");
    const another = e.target.closest("[data-edit-another]"), change = e.target.closest("[data-edit-change]");
    if (!ctx || !bar || bar.hasAttribute("aria-busy") || !(another || change)) { return; }
    if (e.target.closest("button").disabled) { return; }
    const props = propsFromPopup(drawer, ctx.properties);
    if (props === null) { return; }
    ctx.nextProperties = props;
    if (change) { changeFast(drawer, ctx); return; }
    bar.setAttribute("aria-busy", "true");
    try {
      const cart = await addItem(ctx.chosen.id, 1, props);
      announce(cart);
      await currentLine(ctx);
      const label = another.textContent;
      another.textContent = "Added";
      setTimeout(() => { another.textContent = label; }, 1400);
    } catch (err) {
      console.warn("cart edit failed", err);
    } finally {
      bar.removeAttribute("aria-busy");
      refreshBar(drawer);
    }
  }

  
  async function changeFast(drawer, ctx) {
    const v = ctx.chosen, qty = ctx.quantity || 1, props = ctx.nextProperties || ctx.properties || {}, oldVariant = ctx.variantId;
    const row = document.querySelector(`line-item[data-mcart-key="${CSS.escape(ctx.key)}"] pill-loader`);
    drawer.hide();
    row?.setAttribute("aria-busy", "true");
    const post = (url, body) => fetch(`${root()}${url}`, { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify(body) });
    const withProps = (id) => { const item = { id: Number(id), quantity: qty }; if (Object.keys(props).length) { item.properties = props; } return item; };
    const merge = (cart, addJson) => {
      const items = (cart.items || []).slice();
      (addJson.items || []).forEach((it) => { const i = items.findIndex((x) => x.key === it.key); if (i > -1) { items[i] = it; } else { items.unshift(it); } });
      cart.items = items;
      cart.item_count = items.reduce((n, it) => n + (it.quantity || 0), 0);
      cart.total_price = items.reduce((n, it) => n + (it.final_line_price || 0), 0);
      cart.sections = addJson.sections;
      return cart;
    };
    try {
      let removed = await post("cart/change.js", { id: ctx.key, quantity: 0 });
      if (!removed.ok) {
        if (!(await currentLine(ctx))) { throw new Error("line gone"); }
        removed = await post("cart/change.js", { id: ctx.key, quantity: 0 });
        if (!removed.ok) { throw new Error("remove failed"); }
      }
      const afterRemove = await removed.json();
      const sections = sectionsWanted().join(",");
      const added = await post("cart/add.js", { items: [withProps(v.id)], sections, sections_url: `${root()}variants/${v.id}` });
      const addJson = await added.json();
      if (!added.ok) {
        
        const back = await post("cart/add.js", { items: [withProps(oldVariant)], sections });
        if (back.ok) { announce(merge(afterRemove, await back.json())); }
        throw new Error(addJson.description || "add failed, line restored");
      }
      announce(merge(afterRemove, addJson));
      ctx.variantId = Number(v.id);
    } catch (err) {
      console.warn("cart edit failed", err);
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    } finally {
      row?.removeAttribute("aria-busy");
    }
  }

  async function applyLine(drawer) {
    const ctx = drawer._mesEdit;
    const product = await productFor(ctx.handle);
    const variant = product.variants.find((v) => v.id === ctx.variantId);
    if (variant) {
      variant.options.forEach((value, i) => {
        const input = Array.from(drawer.querySelectorAll(`input[type="radio"][name="option${i + 1}"]`)).find((r) => r.value === value);
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
    buildBar(drawer);
    refreshBar(drawer);
  }

  
  const cardOf = (el) => el && el.closest && el.closest(".mcart-upcard[data-mcart-card-handle]");
  const cardDrawer = (card, mode, source) => window.MesQuickAddDrawer(card.getAttribute("data-mcart-card-handle"), `quick-buy-mcart-${card.getAttribute("data-mcart-card-pid")}`, mode, source);
  const preloadCard = (e) => {
    const card = cardOf(e.target);
    if (!card || card._mesPreloaded) { return; }
    card._mesPreloaded = true;
    ensureCss();
    const drawer = cardDrawer(card, "peek");
    if (drawer && !drawer._hasLoaded && typeof drawer.preload === "function") { drawer.preload().catch(() => { card._mesPreloaded = false; }); }
  };
  document.addEventListener("touchstart", preloadCard, { passive: true, capture: true });
  document.addEventListener("mouseover", preloadCard, { passive: true, capture: true });
  document.addEventListener("click", async (e) => {
    const card = cardOf(e.target);
    if (!card || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) { return; }
    const hit = e.target.closest(".mcart-upcard__media, .mcart-upcard__title, [data-mcart-qa]");
    if (!hit) { return; }
    e.preventDefault();
    e.stopPropagation();
    const place = card.closest("[data-mes-source]");
    const drawer = cardDrawer(card, null, place ? place.getAttribute("data-mes-source") : "");
    await ensureCss();
    if (typeof drawer.show === "function") { drawer.show(); }
  }, true);
  
  const warmPane = (cart) => {
    if (window.MES_SLOW) { return; }
    const cardsNow = () => {
      const pane = Array.from(cart.querySelectorAll("[data-mcart-pane]")).find((p) => !p.hidden) || cart;
      return Array.from(pane.querySelectorAll(".mcart-upcard[data-mcart-card-handle]")).slice(0, 2);
    };
    const run = () => cardsNow().forEach((card) => preloadCard({ target: card }));
    const later = () => { if ("requestIdleCallback" in window) { requestIdleCallback(run, { timeout: 1200 }); } else { setTimeout(run, 400); } };
    if (cardsNow().length) { later(); return; }
    
    const mo = new MutationObserver(() => { if (cardsNow().length) { mo.disconnect(); clearTimeout(stop); later(); } });
    mo.observe(cart, { childList: true, subtree: true });
    const stop = setTimeout(() => mo.disconnect(), 10000);
  };
  const watchCart = () => {
    const cart = document.querySelector("cart-drawer");
    if (!cart) { return; }
    const onOpen = () => { ensureCss(); warmPane(cart); };
    if (cart.hasAttribute("open")) { onOpen(); }
    new MutationObserver(() => { if (cart.hasAttribute("open")) { onOpen(); } }).observe(cart, { attributes: true, attributeFilter: ["open"] });
    cart.addEventListener("click", (e) => { if (e.target.closest && e.target.closest("[data-mcart-swtch-opt]")) { setTimeout(() => warmPane(cart), 400); } });
  };
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", watchCart); } else { watchCart(); }

  document.addEventListener("click", async (e) => {
    const hit = e.target.closest && e.target.closest(".mcart-li__media, .mcart-li__title, .mcart-li__variant");
    if (!hit) { return; }
    const line = hit.closest("line-item[data-mcart-handle]");
    if (!line || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) { return; }
    e.preventDefault();
    const handle = line.getAttribute("data-mcart-handle"), key = line.getAttribute("data-mcart-key");
    const drawer = window.MesQuickAddDrawer(handle, `quick-buy-cart-${line.getAttribute("data-mcart-pid")}`, "mes-qa-edit");
    
    let cartLine = null;
    try { cartLine = ((await (await fetch(`${root()}cart.js`, { cache: "no-store" })).json()).items || []).find((it) => it.key === key); } catch (err) { cartLine = null; }
    drawer._mesEdit = {
      handle, key,
      variantId: Number(line.getAttribute("data-mcart-variant")),
      quantity: cartLine ? cartLine.quantity : (parseInt(line.getAttribute("data-mcart-qty"), 10) || 1),
      properties: (cartLine && cartLine.properties) || {}
    };
    await ensureCss();
    if (typeof drawer.show !== "function") { return; }
    drawer.show();
    try { await drawer.preload(); } catch (err) { return; }
    applyLine(drawer);
    fillProps(drawer, drawer._mesEdit);
    setTimeout(() => fillProps(drawer, drawer._mesEdit), 400);
  }, true);
})();

//CUSTOM: Scroll to section
var ScrollToSection = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
  }
   async connectedCallback() {
      this._abortController = new AbortController();
   }
  
   disconnectedCallback() {
    this._abortController.abort();
  }
  
  _onButtonClicked() {
    let sectionName = this.dataset.sectionName;
     utils.scrollToSection(sectionName)
  }
}

if (!window.customElements.get("scroll-to-section")) {
  window.customElements.define("scroll-to-section", ScrollToSection);
}


//CUSTOM: Compact combo offers
var CompactComboOffers = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  
   connectedCallback() {
     document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
     this._abortController = new AbortController();
   }
  
   disconnectedCallback() {
     document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
     this._abortController.abort();
  }

  show() {
    this.hidden = false;
  }
  
  hide() {
    this.hidden = true;
  }

  _onVariantChanged(event) {
      const {variant} = event.detail;
      const {price} = variant;
      const {available} = variant;
      if(!available) {
        this.hide();
        return;
      }
      else{
         this.show()
      }

     let maxDiscount = Number(this.dataset.maxDiscountPercent);
    
      // Ensure variant and maxDiscount are valid
      if (!variant || isNaN(maxDiscount) || maxDiscount < 0 || maxDiscount > 100) {
        console.warn("Invalid variant or discount data");
        return;
      }
    
      // Calculate the final adjusted price and format it
      const adjustedPrice = Math.floor((variant.price * (1 - maxDiscount / 100)) / 100) * 100;
      const formattedPrice = formatMoney(adjustedPrice);
            
      // Update the price in the DOM
      const priceElement = this.querySelector('.price');
      if (priceElement) {
        priceElement.innerHTML = formattedPrice;
      } else {
        console.error("Price element not found");
      }
    }
  
  _onButtonClicked() {
    let sectionName = this.dataset.sectionName;
     utils.scrollToSection(sectionName)
  }
}
if (!window.customElements.get("compact-combo-offers")) {
  window.customElements.define("compact-combo-offers", CompactComboOffers);
}



//CUSTOM : COD / Delivery checker
var CODChecker = class extends HTMLElement {
  constructor() {
    super();
     this.addEventListener("click", this._onButtonSubmit);
     this.addEventListener("keypress", this._onButtonSubmit);
  }
   async connectedCallback() {
      this._abortController = new AbortController();
   }
  
   disconnectedCallback() {
    this._abortController.abort();
  }
  
  _onButtonSubmit(event) {
    if ((event.target.tagName === "BUTTON" || event.target.parentElement.tagName === "BUTTON") || 
        (event.target.tagName === "INPUT" && event.keyCode === 13)) {
      this._onCheckCodAvailability();
    }
  }

  _onCheckCodAvailability() {
    let _that = this;
    const url = 'https://cod.shopifyapps.com/payment/check';
    const account_id = 'capes-india.myshopify.com'
    const zip = document.querySelector('input[name="address[postal-code]"]').value;
    const data = {x_account_id: account_id,zip_code: zip}
    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {"Content-Type": "application/json",'Accept': 'application/json'},
    }).then(function (response) {
        return response.json().then(function (content) {
          _that._createCODAvailabilityResults(content.cod_available)
      })
    }) 
  }

  _createCODAvailabilityResults(isCODAvailable) {
    let CODHolder = document.querySelector(".cod__results");
    let CODResults = "";
    CODHolder.hidden = false;
    CODHolder.innerHTML = "";
    if(isCODAvailable) {
      CODResults = `🛫 Express shipping : ${this.dataset.expressDtLower} - ${this.dataset.expressDtUpper}<br/>🚚 Standard shipping : ${this.dataset.standardDtLower} - ${this.dataset.standardDtUpper}<br/> 💵 COD available on orders above ₹299 only <br/><br/>Shipping rates calculated at checkout`;
    }
    else{
      CODResults = `${this.dataset.errorMsg}`
    }
    CODHolder.innerHTML = CODResults;
  }
}

if (!window.customElements.get("cod-checker")) {
  window.customElements.define("cod-checker", CODChecker);
}


var VariantProductVariations = class extends HTMLElement {
  async connectedCallback() {
    this._abortController = new AbortController();
    this.product = await ProductLoader.load(this.getAttribute("handle"));
    this.variantId =  this.getAttribute("variantId")
    const ProductVariations = new custom.VariantMetaFieldFeatures(this.product, this.variantId, this);
    this._getVariantCardsForVariations(ProductVariations)
    this._setPreorderForVariations(ProductVariations)

  }

  _getVariantCardsForVariations(ProductVariations) {
    ProductVariations.getVariantCardMapping(`variant-card-for-${this.product.id}`)
    ProductVariations.createVariantFeatureCards(this.variantId);
  }

  _setPreorderForVariations(ProductVariations) {
    ProductVariations.getVariantPreorderMapping(`variant-preorder-for-${this.product.id}`)
    this._dispatchPreorderEvent(this.variantId)
  }

  /**
   * Custom function to get dispatch pre order event
   * `source` lets only this element's own VariantMetaFieldFeatures act on it (custom.js setVariantToPreorder).
   */
  _dispatchPreorderEvent(variantId) {
    const event = new CustomEvent("variant:preorder", { detail: { variantId, source: this }});
    document.dispatchEvent(event);
  }

  disconnectedCallback() {
    this._abortController.abort();
  }
}

if (!window.customElements.get("variant-product-variations")) {
  window.customElements.define("variant-product-variations", VariantProductVariations);
}

      
// js/common/product/variant-picker.js
var VariantPicker = class extends HTMLElement {
  async connectedCallback() {
    this._abortController = new AbortController();
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));

    //custom
    this.colorSwatches = Array.from(this.querySelectorAll("[data-color-swatch]"));
    this.swatches = Array.from(this.querySelectorAll("[data-swatch]"));
    if (!this.masterSelector) {
      console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    
    //Custom
    if(this.product) {
      this.variantIdIncludedMappingSelector = document.getElementById(`variant-mapping-for-${this.product.id}`);
      this.variantIncludedSelector = document.getElementById(`variant-included-for-${this.product.id}`);{
        const qaHost = this.closest("quick-buy-drawer");
        this.lineItemProperty = Array.from((qaHost || document).querySelectorAll(".product-info__property")).filter((el) => qaHost ? true : !el.closest("quick-buy-drawer"));
      }
      
      //Hide unavailable variants when page loads
      this._updateDisableSelectors();
      
      //Hiding line item properties based on condition
      this._hideLineItemProperties();
      
      if(this.variantIdIncludedMappingSelector){
       this.variantIdIncludedMapping = this.variantIdIncludedMappingSelector.dataset.variantMapping.split(",");
      }
    }
    
    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("change", this._onOptionChanged.bind(this), { signal: this._abortController.signal });
    });

    this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this), { signal: this._abortController.signal });
    this.selectVariant(this.selectedVariant["id"]);
    this._showVariantPriceDiff(this.product, this.selectedVariant["id"])
    //custom function to enable size selection
    if (this.masterSelector.dataset.enableSizeSelection === 'true') {
      this._enableSizeVariantBasedOnConditions(event)
    }

    this.variantPickerFeatures = new custom.VariantMetaFieldFeatures(this.product, this.selectedVariant["id"], this);
    //Feature cards
    this.variantPickerFeatures.getVariantCardMapping(`variant-card-for-${this.product.id}`)
    this.variantPickerFeatures.createVariantFeatureCards(this.selectedVariant["id"]);
    //Preorder
    this.variantPickerFeatures.getVariantPreorderMapping(`variant-preorder-for-${this.product.id}`)
    this._dispatchPreorderEvent(this.selectedVariant["id"])
  }

  
  disconnectedCallback() {
    this._abortController.abort();
  }
  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }

  /**
   * Custom function to get dispatch pre order event
   * `source` scopes it to this picker's own buy box: the page's, or its quick-add popup's (14 Sep 2026).
   */
  _dispatchPreorderEvent(variantId) {
    const event = new CustomEvent("variant:preorder", { detail: { variantId, source: this }});
    document.dispatchEvent(event);
  }

  /**
   * Custom funciton to get the included variant data
   */
  _getVariantIncluded(id){
    if(this.variantIncludedSelector){
      this.variantIncludedSelector.innerHTML = '';
      for(let i=0; i<this.variantIdIncludedMapping.length; i++){
        let variantIdMapArr = this.variantIdIncludedMapping[i].split("~");
        let variantId = variantIdMapArr[0].trim();
        let includedData = variantIdMapArr[1].trim();
        if(String(id) === variantId) {
          let includedArr = includedData.split("\n");
          for(let i=0; i<includedArr.length; i++){
            if(includedArr[i]) {
              this.variantIncludedSelector.innerHTML+= `<li>${includedArr[i]}</li>`;
            }
          }
        }
      }
    }
  }

   /**
   * Custom function to check if the option list for variant has a matching keyword, if yes then show line item properties
   */
  _hideLineItemProperties() {
    const optionList = this._getSelectedOptionValues();
    if (this.lineItemProperty.length === 0) {
        console.log("Line item property not added to the product");
        return; // No need to proceed further
    }
    const lowercaseOptionList = optionList.map(item => item ? item.toLowerCase() : null);
    for (const currentProperty of this.lineItemProperty) {
        const currentPropertyKeyword = currentProperty.dataset.keyword.toLowerCase();
        // V9.20.5 — a HIDDEN `required` field kills Add to Cart silently on the whole product.
        // The browser blocks submit on the invalid control, then tries to focus it to show
        // "Please fill in this field"; it's display:none so it can't be focused, so the submit
        // is abandoned with NO event and NO message — both ATC buttons look completely dead.
        // Hiding therefore MUST also drop `required` (and disable, so an empty property is
        // never posted); showing restores whatever the block/metafield authored.
        const fields = currentProperty.querySelectorAll('input, select, textarea');
        if (lowercaseOptionList.includes(currentPropertyKeyword)) {
            currentProperty.style.display = "block";
            fields.forEach(field => {
              field.disabled = false;
              if (field.dataset.mesAuthoredRequired === '1') field.required = true;
            });
        } else {
            currentProperty.style.display = "none";
            fields.forEach(field => {
              // remember the authored state once, before we clear it
              if (field.dataset.mesAuthoredRequired === undefined) {
                field.dataset.mesAuthoredRequired = field.required ? '1' : '0';
              }
              field.required = false;
              field.disabled = true;
              if (field.type === 'text' || field.tagName === 'TEXTAREA') field.value = '';
            });
        }
     }
  }

  /**
   * Updates the price difference display for all variants compared to the selected variant.
   * Positive differences show as "-" and negative as "+" (reversed signs).
   * @param {Object} product - The product object containing variants.
   * @param {Number} selectedVariantId - The currently selected variant ID.
   */
  _showVariantPriceDiff(product, selectedVariantId) {
    const selectedVariant = this._getVariantById(selectedVariantId);
    const selectedVariantPrice = selectedVariant.price;
    for (const variant of this.product.variants) {
      const variantId = variant.id;
      // Find the DOM element once
      const el = document.querySelector(`[data-price-delta="price-delta-${variantId}"]`);
      if (!el) continue; // Skip if element not found
      el.innerHTML = '';
      // Check if this variant has a corresponding swatch (and it's not the selected one)
      const swatchExists = Array.from(this.swatches).some(
        swatch => Number(swatch.dataset.variantid) === variantId &&
                  Number(swatch.dataset.variantid) !== selectedVariantId
      );

      if (swatchExists) {
        const priceDiff = selectedVariantPrice - variant.price;
        if(priceDiff !== 0) {
          const sign = priceDiff > 0 ? "-" : "+"; // reversed
          el.innerHTML = `${sign}${formatMoney(Math.abs(priceDiff))}`;
        }
      }
    }
  }


  /**
   * Select a new variant by its ID
   */

  selectVariant(id) {
    localStorage.setItem("variantPickerId", id);
    
    if (!this._isVariantSelectable(this._getVariantById(id))) {
      id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
    }
    const previousVariant = this.selectedVariant;
    if (previousVariant && previousVariant.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    
    //Custom
    this._getVariantIncluded(id); //added this line to fix bug of not changing variants when variants are switched

    this._showVariantPriceDiff(this.product, id)

    if (this.variantPickerFeatures) {
      this.variantPickerFeatures.getVariantCardMapping(`variant-card-for-${this.product.id}`);
      this.variantPickerFeatures.createVariantFeatureCards(this.selectedVariant.id);
    }if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      VariantPicker._pendingUrl = newUrl.toString();
      if (!VariantPicker._urlWriteScheduled) {
        VariantPicker._urlWriteScheduled = true;
        const flushUrl = () => {
          if (!VariantPicker._urlWriteScheduled) return;
          VariantPicker._urlWriteScheduled = false;
          try {
            window.history.replaceState({ path: VariantPicker._pendingUrl }, "", VariantPicker._pendingUrl);
          } catch (e) {}
        };
        requestAnimationFrame(() => setTimeout(flushUrl, 0));
        setTimeout(flushUrl, 120);
      }
    }
    this._updateDisableSelectors();
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.selectedVariant,
        previousVariant
      }
    }));
  }

  
  _onOptionChanged(event) {
    if (!event.target.name.startsWith("option")) {
      return;
    }
    // Capture the size the shopper had ACTUALLY chosen BEFORE selectVariant runs.
    // When size is unselected and a colour/build changes, selectVariant() falls back to
    // a complete variant (colour + FIRST size) and _onMasterSelectorChanged auto-checks
    // that first-size radio. Reading "previously checked" after that would mistake the
    // auto-check for the shopper's own pick and restore it — so the size wrongly defaults
    // to the first one. Snapshot it here so an unselected size stays unselected.
    var preChangeSize = null;
    if (this.masterSelector.dataset.enableSizeSelection === 'true') {
      this._sizeRadios().forEach(function (r) {
        if (r.checked) { preChangeSize = r.value; }
      });
    }
    this.selectVariant(this._getVariantFromOptions()?.id);
    if (this.masterSelector.dataset.enableSizeSelection === 'true') {
      this._enableSizeVariantBasedOnConditions(event, preChangeSize)
    }
    custom.toggleSizeInfoText('add')
    // ⛔ Check pre-order for the variant the page is SHOWING, not a re-lookup (14 Sep 2026, Shrey).
    // With size unselected, selectVariant() falls back to the first size and the price/button follow
    // it, but _enableSizeVariantBasedOnConditions has just unchecked every size radio, so
    // _getVariantFromOptions() now matches nothing and returned undefined. That second dispatch wiped
    // the date a moment after the first one painted it: tapping MagSnap 4 before a size showed
    // "Add to cart" with no ship date on live and dev alike.
    this._dispatchPreorderEvent(this.selectedVariant?.id)
  }

  /**
   * Disable variant selection based on size condition
   */
  
  
  _sizeOptName() {
    if (this._sizeOpt) return this._sizeOpt;
    const opts = (this.product && this.product.options) || [];
    const i = opts.findIndex((o) => String((o && o.name) || o).toLowerCase().includes("size"));
    this._sizeOpt = "option" + (i === -1 ? 2 : i + 1);
    return this._sizeOpt;
  }
  _sizeRadios() {
    const name = this._sizeOptName();
    const form = this.masterSelector && this.masterSelector.form;
    if (form) { return Array.from(form.elements).filter((el) => el.name === name && el.type === "radio"); }
    return Array.from(this.querySelectorAll(`input[name="${name}"]`));
  }

  _enableSizeVariantBasedOnConditions(event, preChangeSize) {
    var radioButtons = this._sizeRadios();
    // Remember the size the shopper had picked, so changing a DIFFERENT option
    // (colour / personalisation) doesn't wipe it. Only an initial page load (no event)
    // or a size that's become unavailable for the new combo should stay deselected.
    var changedIsSize = !!(event && event.target && event.target.name === this._sizeOptName());
    // Use the size captured BEFORE selectVariant ran (passed in from _onOptionChanged) —
    // NOT the live DOM, which selectVariant may have just auto-checked to the first size.
    // If the shopper had no size selected, preChangeSize is null and nothing is restored.
    var previouslyChecked = null;
    if (preChangeSize != null) {
      radioButtons.forEach(function(radioButton) {
          if (radioButton.value === preChangeSize) { previouslyChecked = radioButton; }
      });
    }
    var disabledLabelCount = 0;
    radioButtons.forEach(function(radioButton) {
        var label = radioButton.nextElementSibling;
        if (label.classList.contains("is-disabled")) {
            disabledLabelCount++;
        }
        radioButton.checked = false;
    });
    if (radioButtons.length - disabledLabelCount === 1) {
        radioButtons.forEach(function(radioButton) {
            if (!radioButton.nextElementSibling.classList.contains("is-disabled")) {
                radioButton.checked = true;
            }
        });
    }
    if (changedIsSize) {
      // Shopper clicked a size → honour exactly that one.
      event.target.checked = true;
    } else if (event && previouslyChecked && !previouslyChecked.nextElementSibling.classList.contains("is-disabled")) {
      // Shopper changed colour/personalisation → keep their existing size if still available
      // (a real event only; page-load init has no event, so the size stays deselected).
      previouslyChecked.checked = true;
    }
  }
  
  _onMasterSelectorChanged() {
    const options = this.selectedVariant?.options || [];
    options.forEach((value, index) => {
      let input = this.optionSelectors[index].querySelector(`input[type="radio"][name="option${index + 1}"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
      if (input.tagName === "SELECT" || input.tagName === "INPUT" && input.type === "hidden") {
        triggerChangeEvent = input.value !== value;
        input.value = value;
      } else if (input.tagName === "INPUT" && input.type === "radio") {
        triggerChangeEvent = !input.checked && input.value === value;
        input.checked = input.value === value;
      }
      if (triggerChangeEvent) {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  
  /**
   * Get the product variant by its ID
   */
  _getVariantById(id) {
    return this.product["variants"].find((variant) => variant["id"] === id);
  }
  /**
   * Get the variant based on the options
   */
  _getVariantFromOptions() {
    const options = this._getSelectedOptionValues();
    this._hideLineItemProperties(options);
    return this.product["variants"].find((variant) => {
      return variant["options"].every((value, index) => value === options[index]);
    });
  }
  /**
   * Detect if a specific variant is selectable. This is used when the "hide sold out variant" option is enabled, to allow
   * returning true only if the variant is actually available
   */
  _isVariantSelectable(variant) {
    if (!variant) {
      return false;
    } else {
      return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
    }
  }
  /**
   * This method is used internally to select an available or selectable variant, when the current choice does not
   * match the requirements. For instance, if sold out variants are configured to be hidden, but that the choices end
   * up being a non-valid variant, the theme automatically changes the variant to match the requirements. In the case
   * the customer end up on variant combinations that do not exist, it also switches to a valid combination.
   *
   * The algorithm is as follows: if we have for instance three options "Color", "Size" and "Material", we pop the last
   * option (Material) and try to find the first available variant for the given Color and Size. If none is found we
   * remove the second option (Size) and try to find the first available variant for the selected color. Finally, if none
   * is found we return the first available variant independently of any choice.
   */
  _getFirstMatchingAvailableOrSelectableVariant() {
    let options = this._getSelectedOptionValues(), matchedVariant = null, slicedCount = 0;

    do {
      options.pop();
      slicedCount += 1;
      matchedVariant = this.product["variants"].find((variant) => {
        if (this.hideSoldOutVariants) {
          return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        } else {
          return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        }
      });
    } while (!matchedVariant && options.length > 0);
    return matchedVariant;
  }
  _getSelectedOptionValues() {
    return this.optionSelectors.map((optionSelector) => {
      const selectedInput = optionSelector.querySelector('input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]');
      return selectedInput ? selectedInput.value : null; // Return the value if it exists, otherwise return null
    });
  }
  /**
   * We add specific class to sold out variants based on the selectors
   */
  _updateDisableSelectors() {
    const selectedVariant = this.selectedVariant;
    if (!selectedVariant) {
      return;
    }
    const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
      const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
      optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        optionValue.toggleAttribute("hidden", !available);
      } else {
        optionValue.classList.toggle("is-disabled", !available);
      }
    };
    if (this.optionSelectors && this.optionSelectors[0]) {
      this.product["options"][0]["values"].forEach((value, valueIndex) => {
        const hasAtLeastOneCombination = this.product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = this.product["variants"].some((variant) => variant["option1"] === value && variant["available"]);
        applyClassToSelector(this.optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
        if (this.optionSelectors[1]) {
          this.product["options"][1]["values"].forEach((value2, valueIndex2) => {
            const hasAtLeastOneCombination2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
            applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
            if (this.optionSelectors[2]) {
              this.product["options"][2]["values"].forEach((value3, valueIndex3) => {
                const hasAtLeastOneCombination3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
                applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
              });
            }
          });
        }
      });
    }
  }
};
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    this.innerHTML = event.detail.variant[this.getAttribute("for")];
  }
};
if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}
if (!window.customElements.get("variant-option-value")) {
  window.customElements.define("variant-option-value", VariantOptionValue);
}

// js/common/media/base-media.js
import { inView as inView4 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var BaseMedia = class extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView4(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerHandler(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};

// js/common/media/model.js
var ModelMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    this.player;
    this._addExitButton();
  }
  /* V9.28.94 (Priyanka: "when the 3D view is active one gets stuck"). While the 3D is playing it owns every drag, so a swipe
     turns the model instead of moving the carousel, and the theme only pauses it once the carousel has moved: a dead end.
     A small "Photos" pill (shown only while playing, styled in mes-pdp3.css) pauses the 3D and moves to the next slide. */
  _addExitButton() {
    if (this.querySelector(".mes-3d-exit")) return;
    const button = document.createElement("button");
    button.type = "button";
    button.className = "mes-3d-exit";
    button.style.display = "none"; /* only mes-pdp3.css reveals it (!important), and only while playing; not `hidden`: theme.css forces [hidden] with !important */
    button.setAttribute("aria-label", "Back to photos");
    button.innerHTML = '<span aria-hidden="true">&larr;</span> Photos';
    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.pause();
      const carousel = this.closest("media-carousel");
      if (carousel && typeof carousel.next === "function") carousel.next();
    });
    this.appendChild(button);
  }
  _playerTarget() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = this.querySelector("model-viewer");
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            this.setAttribute("can-play", "");
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerHandler(target, prop) {
    target[prop]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    } else {
      const models = (await ProductLoader.load(this.getAttribute("handle")))["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }
};
if (!window.customElements.get("model-media")) {
  window.customElements.define("model-media", ModelMedia);
}

/* V9.28.95 (Shrey A684 = 2A): our own 3D viewer for kadas with a tale story (snippets/media.liquid). Shopify's built-in viewer
   here is model-viewer 1.12 (no pan, zoom only toward a fixed point, washed-out lighting). This shows the colour's photo with a
   "Turn it in 3D" pill; play() loads the self-hosted Google model-viewer 4.3.1 module once, then this model's GLB. Behaves like
   the theme's other media for pause(): the gallery calls it when the carousel moves, and it removes the viewer so its GPU
   memory is freed. The gallery's desktop auto-play is ignored on purpose: nothing heavy loads until the shopper taps the pill.
   Zoom is aimed at the band: a kada is a ring, so zooming toward the middle of the view (model-viewer's default) dives into
   the empty hole. _aim() moves the camera target to the band under the finger or cursor, or to the nearest band along the
   line from the centre, or the upper edge, before each zoom-in. "View in your space" stays Shopify's AR: shopify-xr is set up here the
   same way ModelMedia does it, once per page. */
var MesModel3d = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    const signal = this._abortController.signal;
    this.querySelector("[data-m3d-start]")?.addEventListener("click", (event) => { event.preventDefault(); this._start(); }, { signal });
    this.querySelector("[data-m3d-exit]")?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.pause();
      const carousel = this.closest("media-carousel");
      if (carousel && typeof carousel.next === "function") {
        /* V9.28.110: on the kada the 3D slide is the LAST of 8 and next() goes nowhere, so "Photos" left the shopper on
           the 3D poster (measured on live 28 Sep). Then go back to the first photo the colour filter left visible. */
        const before = carousel.selectedIndex;
        carousel.next();
        setTimeout(() => {
          if (carousel.selectedIndex !== before || typeof carousel.select !== "function") return;
          const slides = Array.from(carousel.querySelectorAll(".product-gallery__media"));
          const first = slides.findIndex((s) => s.style.display !== "none" && !s.hidden && s.getAttribute("data-media-type") !== "model");
          if (first > -1 && first !== before) carousel.select(first);
        }, 60);
      }
    }, { signal });
    MesModel3d._setupXr(this.getAttribute("handle"));
  }
  static _setupXr(handle) {
    if (MesModel3d._xrStarted || !window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;
    MesModel3d._xrStarted = true;
    const ready = async () => {
      if (!window.ShopifyXR) { document.addEventListener("shopify_xr_initialized", ready, { once: true }); return; }
      const models = (await ProductLoader.load(handle))["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    };
    window.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: ready }]);
  }
  play() {}
  async _start() {
    if (this.playing) return;
    this.setAttribute("playing", "");
    this.setAttribute("loading", "");
    this.removeAttribute("failed");
    try {
      MesModel3d._lib = MesModel3d._lib || import(this.dataset.mv);
      await MesModel3d._lib;
    } catch (error) {
      MesModel3d._lib = null;
      this.removeAttribute("loading");
      this.setAttribute("failed", "");
      return;
    }
    if (!this.playing) return;
    const viewer = document.createElement("model-viewer");
    const attrs = {
      src: this.dataset.glb, alt: this.dataset.alt || "", "camera-controls": "", "touch-action": "none",
      "tone-mapping": "neutral", "shadow-intensity": "0", "camera-orbit": "0deg 10deg auto",
      "min-camera-orbit": "auto 0deg 0.035m", "max-camera-orbit": "auto 180deg auto", "min-field-of-view": "18deg",
      "interaction-prompt": "auto",
      "interpolation-decay": "120"
    };
    Object.keys(attrs).forEach((key) => viewer.setAttribute(key, attrs[key]));
    viewer.addEventListener("load", () => this.removeAttribute("loading"), { once: true });
    viewer.addEventListener("wheel", (event) => { if (event.deltaY < 0) this._aim(viewer, event.clientX, event.clientY); }, { capture: true, passive: true });
    viewer.addEventListener("touchstart", (event) => {
      if (event.touches.length !== 2) return;
      const [a, b] = event.touches;
      this._aim(viewer, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
    }, { capture: true, passive: true });
    viewer.addEventListener("error", () => { this.removeAttribute("loading"); this.setAttribute("failed", ""); }, { once: true });
    this.querySelector("[data-m3d-stage]").replaceChildren(viewer);
  }
  _aim(viewer, x, y) {
    if (!viewer.loaded || typeof viewer.positionAndNormalFromPoint !== "function") return;
    let hit = viewer.positionAndNormalFromPoint(x, y);
    if (!hit) {
      const box = viewer.getBoundingClientRect(), cx = box.left + box.width / 2, cy = box.top + box.height / 2;
      let dx = x - cx, dy = y - cy;
      const length = Math.hypot(dx, dy);
      if (length < 8) { dx = 0; dy = -1; } else { dx /= length; dy /= length; }
      const reach = Math.hypot(box.width, box.height) / 2;
      for (let step = 0; step < reach && !hit; step += 3) hit = viewer.positionAndNormalFromPoint(cx + dx * step, cy + dy * step);
    }
    if (hit) viewer.cameraTarget = `${hit.position.x}m ${hit.position.y}m ${hit.position.z}m`;
  }
  pause() {
    if (!this.playing) return;
    this.removeAttribute("playing");
    this.removeAttribute("loading");
    this.querySelector("[data-m3d-stage]")?.replaceChildren();
  }
};
if (!window.customElements.get("mes-model-3d")) {
  window.customElements.define("mes-model-3d", MesModel3d);
}

// js/common/media/video.js
var onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
var VideoMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { once: true, signal: this._abortController.signal });
    }
    if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`
        <slot></slot>
        
        <svg part="play-button" fill="none" width="48" height="48" viewBox="0 0 48 48">
          <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z" fill="#ffffff"/>
          <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="#1a1a1a"/>
          <path d="M24 .5C36.979.5 47.5 11.021 47.5 24S36.979 47.5 24 47.5.5 36.979.5 24 11.021.5 24 .5Z" stroke="#1a1a1a" stroke-opacity=".12"/>
        </svg>
      `));
    }
  }
  _playerTarget() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector("template");
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute("autoplay") || window.matchMedia("screen and (max-width: 999px)").matches;
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          this.setAttribute("can-play", "");
          const player = new YT.Player(this.querySelector("iframe"), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector("iframe"));
          if (muteVideo) {
            player.setMuted(true);
          }
          this.setAttribute("can-play", "");
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = this.querySelector("video");
      this.setAttribute("loaded", "");
      this.setAttribute("can-play", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
        this.removeAttribute("suspended");
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerHandler(target, prop) {
    if (this.getAttribute("host") === "youtube") {
      prop === "play" ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === "play" && !this.hasAttribute("host")) {
        target.play().catch((error) => {
          if (error.name === "NotAllowedError") {
            this.setAttribute("suspended", "");
            target.controls = true;
            const replacementImageSrc = target.previousElementSibling?.currentSrc;
            if (replacementImageSrc) {
              target.poster = replacementImageSrc;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }
};
if (!window.customElements.get("video-media")) {
  window.customElements.define("video-media", VideoMedia);
}

// js/common/navigation/accordion-disclosure.js
import { timeline as timeline6 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";

// js/common/navigation/animated-details.js
var AnimatedDetails = class extends HTMLDetailsElement {
  constructor() {
    super();
    this.summaryElement = this.firstElementChild;
    this.contentElement = this.lastElementChild;
    this._open = this.hasAttribute("open");
    this.summaryElement.addEventListener("click", this._onSummaryClicked.bind(this));
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", () => this.open = true);
      this.addEventListener("shopify:block:deselect", () => this.open = false);
    }
  }
  set open(value) {
    if (value !== this._open) {
      this._open = value;
      if (this.isConnected) {
        this._transition(value);
      } else {
        value ? this.setAttribute("open", "") : this.removeAttribute("open");
      }
    }
  }
  get open() {
    return this._open;
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    this.open = !this.open;
  }
  _transition(value) {
  }
};

// js/common/navigation/accordion-disclosure.js
var AccordionDisclosure = class extends AnimatedDetails {
  static get observedAttributes() {
    return ["open"];
  }
  constructor() {
    super();
    this.customScrollHeight = this.dataset.scrollHeight;
    this.setAttribute("aria-expanded", this._open ? "true" : "false");
  }
  set open(value) {
    super.open = value;
    this.setAttribute("aria-expanded", value ? "true" : "false");
  }
  get open() {
    return super.open;
  }
  async _transition(value) {
    this.style.overflow = "hidden";
    if (value) {
      this.setAttribute("open", "");
      await timeline6([
        [this, { height: [`${this.summaryElement.clientHeight}px`, `${this.customScrollHeight ? this.customScrollHeight : this.scrollHeight}px`] }, { duration: 0.25, easing: "ease" }],
        [this.contentElement, { opacity: [0, 1], transform: ["translateY(0)", "translateY(-4px)"] }, { duration: 0.15, at: "-0.1" }]
      ]).finished;
    } else {
      await timeline6([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [this, { height: [`${this.clientHeight}px`, `${this.summaryElement.clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
      ]).finished;
      this.removeAttribute("open");
    }
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      this.setAttribute("aria-expanded", newValue === "" ? "true" : "false");
    }
  }
};
if (!window.customElements.get("accordion-disclosure")) {
  window.customElements.define("accordion-disclosure", AccordionDisclosure, { extends: "details" });
}

// js/common/navigation/tabs.js
import { animate as animate8 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var Tabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => this.selectedIndex = index, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transition(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transition(fromPanel, toPanel) {
    await animate8(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate8(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("x-tabs")) {
  window.customElements.define("x-tabs", Tabs);
}

// js/common/search/predictive-search.js
import { animate as animate9 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(`<slot name="idle"></slot>`));
  }
  connectedCallback() {
    this._searchForm = this.closest("form");
    this._queryInput = this._searchForm.elements["q"];
    this._searchForm.addEventListener("submit", this._onFormSubmitted.bind(this));
    this._searchForm.addEventListener("reset", this._onSearchCleared.bind(this));
    this._queryInput.addEventListener("input", debounce(this._onInputChanged.bind(this), this.autoCompleteDelay));
  }
  /**
   * Return the delay in ms before we send the autocomplete request. Using a value too low can cause the results to
   * refresh too often, so we recommend to keep the default one
   */
  get autoCompleteDelay() {
    return 280;
  }
  /**
   * Check if the store supports the predictive API (some languages do not). When not supported, the predictive
   * search is simply disabled and only the standard search is used
   */
  supportsPredictiveApi() {
    return JSON.parse(document.getElementById("shopify-features").innerHTML)["predictiveSearch"];
  }
  /**
   * Check if the input is not empty, and if so, trigger the predictive search
   */
  _onInputChanged() {
    if (this._queryInput.value === "") {
      this.dispatchEvent(new CustomEvent('predictive-search-cleared'));
      return this._onSearchCleared();
    }
    this._abortController?.abort();
    this._abortController = new AbortController();
    this.dispatchEvent(new CustomEvent('predictive-search-started', { detail: { query: this._queryInput.value }}));
    try {
      return this.supportsPredictiveApi() ? this._doPredictiveSearch() : this._doFallbackSearch();
    } catch (e) {
      if (e.name !== "AbortError") {
        throw e;
      }
    }
  }
  /**
   * Prevent the form submission if the query is empty
   */
  _onFormSubmitted(event) {
    if (this._queryInput.value === "") {
      return event.preventDefault();
    }
  }
  /**
   * Do the actual predictive search
   */
  async _doPredictiveSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[limit]=10&resources[limit_scope]=each`;
    const nodeElement = new DOMParser().parseFromString(await (await cachedFetch(`${window.Shopify.routes.root}search/suggest?${queryParams}`, { signal: this._abortController.signal })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot("results");
  }
  /**
   * For merchants using store that do not support the predictive search, we have to fallback to standard search. Unfortunately,
   * the standard search is less convenient, and we have to simulate one request for each desired resource type
   */
  async _doFallbackSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[limit]=10&resources[limit_scope]=each`;
    const nodeElement = new DOMParser().parseFromString(await (await cachedFetch(`${window.Shopify.routes.root}search?${queryParams}`, { signal: this._abortController.signal })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot("results");
  }
  /**
   * If any search is pending, we abort them, and transition to the idle slot
   */
  _onSearchCleared() {
    this._abortController?.abort();
    this._queryInput.focus();
    this.dispatchEvent(new CustomEvent('predictive-search-cleared'));
    return this._transitionToSlot("idle");
  }
  /**
   * Transition between different slot. To prevent useless animation, the slot does not transition if we go to the same slot
   */
  async _transitionToSlot(toSlotName) {
    if (this.shadowRoot.firstElementChild.name === toSlotName) {
      return;
    }
    await animate9(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [1, 0] }, { duration: 0.1 }).finished;
    this.shadowRoot.firstElementChild.setAttribute("name", toSlotName);
    return animate9(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [0, 1], transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.1 }).finished;
  }
};
if (!window.customElements.get("predictive-search")) {
  window.customElements.define("predictive-search", PredictiveSearch);
}

// js/common/search/search-drawer.js
var SearchDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "top" : this.getAttribute("open-from") || "right";
  }
};
if (!window.customElements.get("search-drawer")) {
  window.customElements.define("search-drawer", SearchDrawer);
}

// js/common/text/section-header.js
import { animate as animate10, inView as inView5 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
var _reveal2, reveal_fn2;
var SectionHeader = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _reveal2);
  }
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, __privateMethod(this, _reveal2, reveal_fn2).bind(this), { margin: "0px 0px -100px 0px" });
    }
  }
};
_reveal2 = new WeakSet();
reveal_fn2 = function() {
  const heading = this.querySelector('h2[reveal-on-scroll="true"]'), headingKeyframe = getHeadingKeyframe(heading);
  animate10(...headingKeyframe);
};
if (!window.customElements.get("section-header")) {
  window.customElements.define("section-header", SectionHeader);
}

// // js/common/ui/marquee-text.js
class MarqueeText extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = null;
    this.mutationObserver = null;
  }

  connectedCallback() {
    this._initialize();
    this.resizeObserver = new ResizeObserver(this._calculateDuration.bind(this));
    this.resizeObserver.observe(this);
    this.mutationObserver = new MutationObserver(this._calculateDuration.bind(this));
    this.mutationObserver.observe(this, { childList: true, subtree: true });
    window.addEventListener('resize', this._calculateDuration.bind(this));
  }

  _initialize() {
    this.style.setProperty("--marquee-animation-duration", `${this._defaultDuration()}s`);
    requestAnimationFrame(() => {
      setTimeout(() => this._calculateDuration(), 100);
    });
  }

  _defaultDuration() {
    return 16;
  }

  _calculateDuration() {
    requestAnimationFrame(() => {
      const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5);
      const contentWidth = this.scrollWidth;
      const span = this.querySelector("span");

      if (span) {
        const spanWidth = span.scrollWidth;
        if (contentWidth > 0 && spanWidth > 0) {
          // const duration = (scrollingSpeed * spanWidth / contentWidth).toFixed(3);
          const duration = scrollingSpeed;
          this.style.setProperty("--marquee-animation-duration", `${duration}s`);
        } else {
          console.log('Invalid content or span width:', contentWidth, spanWidth);
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this);
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    window.removeEventListener('resize', this._calculateDuration.bind(this));
  }
}

// if (!window.customElements.get("marquee-text")) {
//   window.customElements.define("marquee-text", MarqueeText);
// }

// js/common/ui/marquee-text.js
// var MarqueeText = class extends HTMLElement {
//   constructor() {
//     super();
//     if (window.ResizeObserver) {
//       new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
//     }
//   }

//   connectedCallback() {
//     this._calculateDuration([{ target: this, contentRect: this.getBoundingClientRect() }]);
//   }

//   _calculateDuration(entries) {
//     debugger;
//     const loopDuration = parseFloat(this.getAttribute("scrolling-speed") || 20); // in seconds
//     const span = this.querySelector("span");
//     if (!span) return;

//     const contentWidth = span.clientWidth;
//     const containerWidth = this.clientWidth;
//     const totalDistance = contentWidth + containerWidth;
//     const speed = totalDistance / loopDuration;
//     const duration = totalDistance / speed;

//     this.style.setProperty("--marquee-animation-duration", `${duration.toFixed(3)}s`);
//   }
// };

if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}


// // js/custom/navigation-panel.js
// var NavigationPanel = class extends HTMLElement {
//   constructor() {
//     super();
//     this.menu_type = this.dataset.menu;
//   }

//   _showActiveMenuContentOnLoad() {
//     let isWomen = this.menu_type.toLowerCase().includes("women");
      
//     document.querySelectorAll(".menu_tabcontent").forEach((tabContent) => {
//       tabContent.style.display = "none";
//     });
  
//     Array.from(this.querySelectorAll(".menu_tablinks")).forEach((tabLink) => {
//       let menuTitleActive = tabLink.dataset.menuTitle;
//       console.log(menuTitleActive)
//       if (isWomen && menuTitleActive.toLowerCase() === "women") {
//         document.getElementById(`menu_for_${menuTitleActive}`).style.display = "block";
//         tabLink.classList.add("active");
//       } else if (!isWomen && menuTitleActive.toLowerCase() === "men") {
//         document.getElementById(`menu_for_${menuTitleActive}`).style.display = "block";
//         tabLink.classList.add("active");
//       } else {
//         tabLink.classList.remove("active");
//       }
//     });
//   }


//   _showMenuContentOnClick() {
//     Array.from(this.querySelectorAll(".menu_tablinks")).forEach((tabLink) => {
//       tabLink.addEventListener("click", (event) => {
//         document.querySelectorAll(".menu_tabcontent").forEach((tab) => {
//           tab.style.display = "none";
//         });

//         let menuTitleActive = tabLink.dataset.menuTitle;
//         document.querySelectorAll(".menu_tablinks").forEach((link) => {
//           link.classList.remove("active");
//         });

//         document.getElementById(`menu_for_${menuTitleActive}`).style.display = "block";

//         event.currentTarget.classList.add("active");
//       });
//     });
//   }



// js/custom/navigation-panel.js
var NavigationPanel = class extends HTMLElement {
  constructor() {
    super();
    this.menu_type = this.dataset.menu;
  }

  _showActiveMenuContentOnLoad() {
    const tabLinks = Array.from(this.querySelectorAll(".menu_tablinks"));
    let activated = false;

    // Hide all menu contents first
    document.querySelectorAll(".menu_tabcontent").forEach(tabContent => {
      tabContent.style.display = "none";
    });

    // Try to activate matching menu_type
    tabLinks.forEach(tabLink => {
      const menuTitle = tabLink.dataset.menuTitle;
      if (this.menu_type.includes(menuTitle) && !activated) {
        document.getElementById(`menu_for_${menuTitle}`).style.display = "block";
        tabLink.classList.add("active");
        activated = true;
      } else {
        tabLink.classList.remove("active");
      }
    });

    // If nothing matched, activate the first tab by default
    if (!activated && tabLinks.length > 0) {
      const firstTab = tabLinks[0];
      const menuTitle = firstTab.dataset.menuTitle;
      document.getElementById(`menu_for_${menuTitle}`).style.display = "block";
      firstTab.classList.add("active");
    }
  }

  _showMenuContentOnClick() {
    Array.from(this.querySelectorAll(".menu_tablinks")).forEach(tabLink => {
      tabLink.addEventListener("click", (event) => {
        // Hide all contents
        document.querySelectorAll(".menu_tabcontent").forEach(tab => {
          tab.style.display = "none";
        });

        // Remove active class from all tabs
        document.querySelectorAll(".menu_tablinks").forEach(link => {
          link.classList.remove("active");
        });

        const menuTitleActive = tabLink.dataset.menuTitle

        // Show selected tab
        document.getElementById(`menu_for_${menuTitleActive}`).style.display = "block";
        event.currentTarget.classList.add("active");
      });
    });
  }

  connectedCallback() {
    this._showMenuContentOnClick();
    this._showActiveMenuContentOnLoad();
  }
};


if (!window.customElements.get("navigation-panel")) {
  window.customElements.define("navigation-panel", NavigationPanel);
}


// // CUSTOM : js/how-to-apply  
// var SearchCertificate = class extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this._searchForm = this.querySelectorAll("form")[0];
//     this._queryInput = this._searchForm.elements["q"];
//     this._queryInput.addEventListener("input", debounce(this._onInputChanged.bind(this), this.autoCompleteDelay));
//     this._productListError = this.querySelectorAll(".product-list__error")[0];
//   }

//    _onInputChanged(event) {
//       const searchQuery = this._queryInput.value.trim().toUpperCase();
//       const productContainers = document.querySelectorAll(".product-card-container");
//       const collectionTitles = document.querySelectorAll(".collection-title");
//       let productsAreShown = [];
      
//       productContainers.forEach((container) => {
//         const productTitle = container.getAttribute("data-product-title").toUpperCase();
//         const productType = container.getAttribute("data-type").toUpperCase();
//         const productTag = container.getAttribute("data-tag").toUpperCase();
//         const shouldShowProduct = (productTitle.indexOf(searchQuery) > -1 || productType.indexOf(searchQuery) > -1 || productTag.indexOf(searchQuery) > -1);
//         shouldShowProduct ? productsAreShown.push(true) :  productsAreShown.push(false);
//         container.style.display = shouldShowProduct ? "block" : "none";
//       });
      
//       collectionTitles.forEach((title) => {
//         const collectionTitle = title.getAttribute("data-collection-title").toUpperCase();
//         const productsInSection = document.querySelectorAll(`[data-collection-title="${collectionTitle}"].product-card-container`);
//         const visibleProductsInSection = Array.from(productsInSection).filter((product) => product.style.display !== "none");
//         const shouldShowCollection = visibleProductsInSection.length > 0;
//         title.style.display = shouldShowCollection ? "block" : "none";
//       });

//        // If no search returns not products, show error message
//       const noProductsShown = !productsAreShown.includes(true);
//       this._productListError.classList.toggle('hidden', !noProductsShown);
      
//       // Reset visibility when the input is cleared
//       if (searchQuery === "") {
//         productContainers.forEach((container) => {
//           container.style.display = "block";
//         });
//         collectionTitles.forEach((title) => {
//           title.style.display = "block";
//         });
//       }
//     }
  
//   /**
//    * Return the delay in ms before we send the autocomplete request. Using a value too low can cause the results to
//    * refresh too often, so we recommend to keep the default one
//    */
//   get autoCompleteDelay() {
//     return 280;
//   }
// };
  
// if (!window.customElements.get("search-certificate")) {
//   window.customElements.define("search-certificate", SearchCertificate);
// }

// Countdown Timer Code
import { animate as animate15, inView as inView15 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
let _flips, _expirationDate, _interval, _isVisible, _CountdownTimer_instances, recalculateFlips_fn;

// Countdown Timer Class
class CountdownTimer extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CountdownTimer_instances);
    __privateAdd(this, _flips);
    __privateAdd(this, _expirationDate);
    __privateAdd(this, _interval);
    __privateAdd(this, _isVisible);
  }

  connectedCallback() {
    __privateSet(this, _flips, Array.from(this.querySelectorAll('countdown-timer-flip')));
    const expiresAt = this.getAttribute('expires-at');
    if (expiresAt !== '') {
      __privateSet(this, _expirationDate, new Date(expiresAt));
      __privateSet(this, _interval, setInterval(__privateMethod(this, _CountdownTimer_instances, recalculateFlips_fn).bind(this), 1000));
      __privateMethod(this, _CountdownTimer_instances, recalculateFlips_fn).call(this);
    }
    inView15(this, () => {
      __privateSet(this, _isVisible, true);
      return () => __privateSet(this, _isVisible, false);
    }, { margin: '500px' });
  }

  disconnectedCallback() {
    clearInterval(__privateGet(this, _interval));
  }

  get daysFlip() {
    return __privateGet(this, _flips).find(flip => flip.getAttribute('type') === 'days');
  }

  get hoursFlip() {
    return __privateGet(this, _flips).find(flip => flip.getAttribute('type') === 'hours');
  }

  get minutesFlip() {
    return __privateGet(this, _flips).find(flip => flip.getAttribute('type') === 'minutes');
  }

  get secondsFlip() {
    return __privateGet(this, _flips).find(flip => flip.getAttribute('type') === 'seconds');
  }
}

_flips = new WeakMap();
_expirationDate = new WeakMap();
_interval = new WeakMap();
_isVisible = new WeakMap();
_CountdownTimer_instances = new WeakSet();

// Recalculate flips function
recalculateFlips_fn = function() {
  const dateNow = new Date();
  if (__privateGet(this, _expirationDate) < dateNow) {
    if (this.getAttribute('expiration-behavior') === 'hide') {
      if(location.pathname.includes("product")){
        this.closest('.product-countdown').remove();
      }
      else{
        this.closest('.shopify-section').remove();
      }
    } else {
      return clearInterval(__privateGet(this, _interval));
    }
  }
  if (!__privateGet(this, _isVisible)) {
    return;
  }
  let delta = Math.abs(__privateGet(this, _expirationDate) - dateNow) / 1000;
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;
  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;
  const seconds = Math.floor(delta % 60);
  this.daysFlip?.updateValue(days);
  this.hoursFlip?.updateValue(hours);
  this.minutesFlip?.updateValue(minutes);
  this.secondsFlip?.updateValue(seconds);
};

// Countdown Timer Flip Class
class CountdownTimerFlip extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    const flipHtml = [...this.textContent].map(() => `<countdown-timer-flip-digit part="digit" ${this.hasAttribute('animate') ? 'animate' : ''} style="display: inline-block">0</countdown-timer-flip-digit>`);
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(flipHtml.join('')));
  }

  updateValue(value) {
    const newValue = Math.min(99, value).toString().padStart(2, '0');
    [...newValue].forEach((digit, index) => {
      this.shadowRoot.children[index].setAttribute('number', digit);
    });
  }
}

// Countdown Timer Flip Digit Class
class CountdownTimerFlipDigit extends HTMLElement {
  static observedAttributes = ['number'];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' }).appendChild(document.createRange().createContextualFragment('<div><slot></slot></div>'));
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === null || oldValue === newValue || !this.hasAttribute('animate')) {
      return this.textContent = newValue;
    }
    await animate15(this.shadowRoot.firstElementChild, { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-8px)'] }, { duration: 0.3, easing: [0.64, 0, 0.78, 0] }).finished;
    this.textContent = newValue;
    animate15(this.shadowRoot.firstElementChild, { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0px)'] }, { duration: 0.3, easing: [0.22, 1, 0.36, 1] });
  }
}

// Define custom elements if they are not already defined
if (!window.customElements.get('countdown-timer')) {
  window.customElements.define('countdown-timer', CountdownTimer);
}
if (!window.customElements.get('countdown-timer-flip')) {
  window.customElements.define('countdown-timer-flip', CountdownTimerFlip);
}
if (!window.customElements.get('countdown-timer-flip-digit')) {
  window.customElements.define('countdown-timer-flip-digit', CountdownTimerFlipDigit);
}


// js/theme.js
import { Delegate as Delegate4 } from "//mesmerizeindia.com/cdn/shop/t/346/assets/vendor.min.js?v=121921991170621470881792587329";
(() => {
  const delegateDocument = new Delegate4(document.documentElement);
  if (window.themeVariables.settings.showPageTransition && "animate" in document.documentElement && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    delegateDocument.on("click", "a", async (event, target) => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey) {
        return;
      }
      if (target.hostname !== window.location.hostname || target.pathname === window.location.pathname) {
        return;
      }
      event.preventDefault();
      await document.body.animate({ opacity: [1, 0] }, { duration: 75, fill: "forwards" }).finished;
      window.location = target.href;
    });
  }
  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    delegateDocument.on("click", 'a[href*="#"]', (event, target) => {
      if (event.defaultPrevented || target.pathname !== window.location.pathname || target.search !== window.location.search) {
        return;
      }
      const url = new URL(target.href);
      if (url.hash === "") {
        return;
      }
      const anchorElement = document.querySelector(url.hash);
      if (anchorElement) {
        event.preventDefault();
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }
  const setScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    }
  };
  setScrollbarWidth();
  window.addEventListener("resize", throttle(setScrollbarWidth));
})();

/**
 * This implementation allows to serialize a form
 */
var Form = function () {
  function Form() {
    _classCallCheck(this, Form);
  }

  _createClass(Form, null, [{
    key: "serialize",
    value: function serialize(form) {
      function stringKey(key, value) {
        var beginBracket = key.lastIndexOf('[');

        if (beginBracket === -1) {
          var hash = {};
          hash[key] = value;
          return hash;
        }

        var newKey = key.substr(0, beginBracket);
        var newValue = {};
        newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
        return stringKey(newKey, newValue);
      }

      var hash = {};

      for (var i = 0, len = form.elements.length; i < len; i++) {
        var formElement = form.elements[i];

        if (formElement.name === '' || formElement.disabled) {
          continue;
        }

        if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
          var stringKeys = stringKey(formElement.name, formElement.value);
          hash = Form.extend(hash, stringKeys);
        }
      }

      return hash;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extended = {};
      var i = 0;

      var merge = function merge(obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
              extended[prop] = Form.extend(extended[prop], obj[prop]);
            } else {
              extended[prop] = obj[prop];
            }
          }
        }
      };

      for (; i < arguments.length; i++) {
        merge(arguments[i]);
      }

      return extended;
    }
  }]);

  return Form;
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

      
export {
  AccordionDisclosure,
  AnimatedDetails,
  BuyButtons,
  CartCount,
  CartDrawer,
  CartFooterIcons,
  CartNote,
  CartNotificationDrawer,
  CompactComboOffers,
  CompareAtPrice,
  ConfirmButton,
  CopyButton,
  CountrySelector,
  CODChecker,
  CustomButton,
  CustomCursor,
  DialogElement,
  Drawer,
  EffectCarousel,
  FacetApplyButton,
  FacetDialog,
  FacetDrawer,
  FacetFloatingFilter,
  FacetForm,
  FacetLink,
  FacetSortBy,
  FreeShippingBar,
  GestureArea,
  GiftCardRecipient,
  HeightObserver,
  LineItem,
  LineItemQuantity,
  Listbox,
  MarqueeText,
  MediaCarousel,
  NavigationPanel,
  ModelMedia,
  NextButton,
  OnSaleBadge,
  PageDots,
  PaymentTerms,
  PickupAvailability,
  PillLoader,
  Player,
  Popover,
  PredictiveSearch,
  PrevButton,
  PriceRange,
  PrivacyBar,
  ProductCard,
  ProductForm,
  ProductGallery,
  ProductLoader,
  ProductQuickAdd,
  ProductZoomButton,
  ProgressBar,
  QuantityInput,
  QuantitySelector,
  QuickBuyDrawer,
  ResizableTextarea,
  RevealItems,
  SafeSticky,
  SalePrice,
  ScrollArea,
  ScrollCarousel,
  ScrollProgress,
  ScrollShadow,
  ScrollToSection,
  SearchDrawer,
  SectionHeader,
  ShareButton,
  ShippingEstimator,
  SoldOutBadge,
  SplitLines,
  Tabs,
  UnitPrice,
  VariantInventory,
  VariantMedia,
  VariantPicker,
  VariantSku,
  VideoMedia,
  VisibilityProgress,
  cachedFetch,
  createMediaImg,
  debounce,
  extractSectionId,
  fetchCart,
  formatMoney,
  generateSrcset,
  getHeadingKeyframe,
  imageLoaded,
  throttle,
  waitForEvent,
  StickyBuyButton,
  CustomSortBy,
  VariantProductVariations
};